!function (e, t) {
  if ("function" == typeof define && define.amd) define("Waline", ["exports"], t);else if ("undefined" != typeof exports) t(exports);else {
    var n = {
      exports: {}
    };
    t(n.exports), e.Waline = n.exports;
  }
}("undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : this, function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.version = e.pageviewCount = e.init = e.defaultLocales = e.commentCount = e.UserList = e.RecentComments = void 0;
  const t = ["nick", "mail", "link"],
    n = e => e.filter(e => t.includes(e)),
    r = ["//unpkg.com/@waline/emojis@1.1.0/weibo"],
    i = "en-US",
    s = e => new Promise((t, n) => {
      if (e.size > 1024e3) return n(new Error("File too large! File size limit 1MB"));
      const r = new FileReader();
      r.readAsDataURL(e), r.onload = () => t(r.result ? r.result.toString() : ""), r.onerror = n;
    }),
    o = e => !0 === e ? '<p class="wl-tex">Tex is not available in preview</p>' : '<span class="wl-tex">Tex is not available in preview</span>',
    a = e => {
      const t = async function (t) {
        return fetch(`https://api.giphy.com/v1/gifs/${t}?${new URLSearchParams({
          lang: e,
          limit: "20",
          rating: "g",
          api_key: "6CIMLkNMMOhRcXPoMCPkFy4Ybk2XUiMp",
          ...(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {})
        }).toString()}`).then(e => e.json()).then(e => {
          let {
            data: t
          } = e;
          return t.map(e => ({
            title: e.title,
            src: e.images.downsized_medium.url
          }));
        });
      };
      return {
        search: e => t("search", {
          q: e,
          offset: "0"
        }),
        default: () => t("trending", {}),
        more: function (e) {
          return t("search", {
            q: e,
            offset: (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0).toString()
          });
        }
      };
    },
    l = ["//unpkg.com/@waline/emojis/tieba/tieba_agree.png", "//unpkg.com/@waline/emojis/tieba/tieba_look_down.png", "//unpkg.com/@waline/emojis/tieba/tieba_sunglasses.png", "//unpkg.com/@waline/emojis/tieba/tieba_pick_nose.png", "//unpkg.com/@waline/emojis/tieba/tieba_awkward.png", "//unpkg.com/@waline/emojis/tieba/tieba_sleep.png"],
    c = new RegExp(`(${/[\u4E00-\u9FFF\u3400-\u4dbf\uf900-\ufaff\u3040-\u309f\uac00-\ud7af\u0400-\u04FF]+|\w+/.source}|${/</.source})|((?:${/(?:^|\s)\/\/(.+?)$/gm.source})|(?:${/\/\*([\S\s]*?)\*\//gm.source}))`, "gmi"),
    u = ["23AC69", "91C132", "F19726", "E8552D", "1AAB8E", "E1147F", "2980C1", "1BA1E6", "9FA0A0", "F19726", "E30B20", "E30B20", "A3338B"],
    d = {},
    h = e => {
      let t = 0;
      return e.replace(c, (e, n, r) => {
        if (r) return `<span style="color: slategray">${r}</span>`;
        if ("<" === n) return "&lt;";
        let i;
        d[n] ? i = d[n] : (i = u[t], d[n] = i);
        const s = `<span style="color: #${i}">${n}</span>`;
        return t = ++t % u.length, s;
      });
    },
    f = ["nick", "nickError", "mail", "mailError", "link", "optional", "placeholder", "sofa", "submit", "like", "cancelLike", "reply", "cancelReply", "comment", "refresh", "more", "preview", "emoji", "uploadImage", "seconds", "minutes", "hours", "days", "now", "uploading", "login", "logout", "admin", "sticky", "word", "wordHint", "anonymous", "level0", "level1", "level2", "level3", "level4", "level5", "gif", "gifSearchPlaceholder", "profile", "approved", "waiting", "spam", "unsticky", "oldest", "latest", "hottest", "reactionTitle"],
    p = e => Object.fromEntries(e.map((e, t) => [f[t], e]));
  var m = p(["Name", "Name cannot be empty.", "Email", "Please confirm your email address.", "Website", "Optional", "Write your comment here...", "No comments yet.", "Post", "Like", "Cancel like", "Reply", "Cancel reply", "Comments", "Refresh", "Load More...", "Preview", "Emoji", "Upload Image", "seconds ago", "minutes ago", "hours ago", "days ago", "just now", "Uploading", "Log In", "logout", "Admin", "Sticky", "words", "Please input comments between $0 and $1 words!\n Current word number: $2", "Anonymous", "Dwarves", "Hobbits", "Ents", "Wizards", "Elves", "Maiar", "GIF", "Search GIF", "Profile", "Approved", "Waiting", "Spam", "Unsticky", "Oldest", "Latest", "Popular", "What do you think?"]),
    g = p(["ニックネーム", "3バイト以上のニックネームをご入力ください.", "メールアドレス", "メールアドレスをご確認ください.", "サイト", "オプション", "ここにコメント", "コメントしましょう~", "提出する", "Like", "Cancel like", "返信する", "キャンセル", "コメント", "更新", "さらに読み込む", "プレビュー", "絵文字", "画像をアップロード", "秒前", "分前", "時間前", "日前", "たっだ今", "アップロード", "ログインする", "ログアウト", "管理者", "トップに置く", "ワード", "コメントは $0 から $1 ワードの間でなければなりません!\n 現在の単語番号: $2", "匿名", "うえにん", "なかにん", "しもおし", "特にしもおし", "かげ", "なぬし", "GIF", "探す GIF", "個人情報", "承認済み", "待っている", "スパム", "べたつかない", "逆順", "正順", "人気順", "どう思いますか？"]),
    v = p(["昵称", "昵称不能为空", "邮箱", "请填写正确的邮件地址", "网址", "可选", "欢迎评论", "来发评论吧~", "提交", "喜欢", "取消喜欢", "回复", "取消回复", "评论", "刷新", "加载更多...", "预览", "表情", "上传图片", "秒前", "分钟前", "小时前", "天前", "刚刚", "正在上传", "登录", "退出", "博主", "置顶", "字", "评论字数应在 $0 到 $1 字之间！\n当前字数：$2", "匿名", "潜水", "冒泡", "吐槽", "活跃", "话痨", "传说", "表情包", "搜索表情包", "个人资料", "通过", "待审核", "垃圾", "取消置顶", "按倒序", "按正序", "按热度", "你认为这篇文章怎么样？"]),
    y = p(["暱稱", "暱稱不能少於3個字元", "郵箱", "請填寫正確的郵件地址", "網址", "可選", "歡迎評論", "來發評論吧~", "提交", "喜歡", "取消喜歡", "回覆", "取消回覆", "評論", "刷新", "載入更多...", "預覽", "表情", "上傳圖片", "秒前", "分鐘前", "小時前", "天前", "剛剛", "正在上傳", "登錄", "退出", "博主", "置頂", "字", "評論字數應在 $0 到 $1 字之間！\n當前字數：$2", "匿名", "潛水", "冒泡", "吐槽", "活躍", "話癆", "傳說", "表情包", "搜索表情包", "個人資料", "通過", "待審核", "垃圾", "取消置頂", "按倒序", "按正序", "按熱度", "你認為這篇文章怎麼樣？"]),
    _ = p(["Apelido", "Apelido não pode ser menor que 3 bytes.", "E-Mail", "Por favor, confirme seu endereço de e-mail.", "Website", "Opcional", "Comente aqui...", "Nenhum comentário, ainda.", "Enviar", "Like", "Cancel like", "Responder", "Cancelar resposta", "Comentários", "Refrescar", "Carregar Mais...", "Visualizar", "Emoji", "Enviar Imagem", "segundos atrás", "minutos atrás", "horas atrás", "dias atrás", "agora mesmo", "Enviando", "Entrar", "Sair", "Admin", "Sticky", "Palavras", "Favor enviar comentário com $0 a $1 palavras!\n Número de palavras atuais: $2", "Anônimo", "Dwarves", "Hobbits", "Ents", "Wizards", "Elves", "Maiar", "GIF", "Pesquisar GIF", "informação pessoal", "Aprovado", "Espera", "Spam", "Unsticky", "Mais velho", "Mais recentes", "Mais quente", "O que você acha?"]),
    w = p(["Псевдоним", "Никнейм не может быть меньше 3 байт.", "Эл. адрес", "Пожалуйста, подтвердите адрес вашей электронной почты.", "Веб-сайт", "Необязательный", "Комментарий здесь...", "Пока нет комментариев.", "Отправить", "Like", "Cancel like", "Отвечать", "Отменить ответ", "Комментарии", "Обновить", "Загрузи больше...", "Превью", "эмодзи", "Загрузить изображение", "секунд назад", "несколько минут назад", "несколько часов назад", "дней назад", "прямо сейчас", "Загрузка", "Авторизоваться", "Выход из системы", "Админ", "Липкий", "Слова", "Пожалуйста, введите комментарии от $0 до $1 слов!\nНомер текущего слова: $2", "Анонимный", "Dwarves", "Hobbits", "Ents", "Wizards", "Elves", "Maiar", "GIF", "Поиск GIF", "Персональные данные", "Одобренный", "Ожидающий", "Спам", "Нелипкий", "самый старый", "последний", "самый горячий", "Что вы думаете?"]);
  const k = {
    zh: v,
    "zh-cn": v,
    "zh-CN": v,
    "zh-tw": y,
    "zh-TW": y,
    en: m,
    "en-US": m,
    "en-us": m,
    jp: g,
    ja: g,
    "jp-jp": g,
    "jp-JP": g,
    "pt-br": _,
    "pt-BR": _,
    ru: w,
    "ru-ru": w,
    "ru-RU": w
  };
  e.defaultLocales = k;
  const b = {
      "Content-Type": "application/json"
    },
    x = function (e) {
      let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
      if ("object" == typeof e && e.errno) throw new TypeError(`${t} failed with ${e.errno}: ${e.errmsg}`);
      return e;
    },
    S = e => {
      let {
        serverURL: t,
        lang: n,
        paths: r,
        type: i,
        signal: s
      } = e;
      return fetch(`${t}/article?path=${encodeURIComponent(r.join(","))}&type=${encodeURIComponent(i.join(","))}&lang=${n}`, {
        signal: s
      }).then(e => e.json());
    },
    T = e => {
      let {
        serverURL: t,
        lang: n,
        path: r,
        type: i,
        action: s,
        isChinaZone: o,
        curPreviewTime: a
      } = e;
      return fetch(`${t}/article?lang=${n}`, {
        method: "POST",
        headers: b,
        body: JSON.stringify({
          path: r,
          type: i,
          action: s,
          isChinaZone: o,
          curPreviewTime: a
        })
      }).then(e => e.json());
    },
    C = e => {
      let {
        serverURL: t,
        lang: n,
        token: r,
        objectId: i,
        comment: s
      } = e;
      return fetch(`${t}/comment/${i}?lang=${n}`, {
        method: "PUT",
        headers: {
          ...b,
          Authorization: `Bearer ${r}`
        },
        body: JSON.stringify(s)
      }).then(e => e.json()).then(e => x(e, "Update comment"));
    },
    M = e => {
      try {
        e = decodeURI(e);
      } catch (e) {}
      return e;
    },
    O = function () {
      return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").replace(/\/$/u, "");
    },
    D = e => /^(https?:)?\/\//.test(e),
    R = e => {
      const t = O(e);
      return D(t) ? t : `https://${t}`;
    },
    E = e => Array.isArray(e) ? e : !!e && [0, e],
    A = (e, t) => "function" == typeof e ? e : !1 !== e && t,
    L = "{--waline-white:#000;--waline-light-grey:#666;--waline-dark-grey:#999;--waline-color:#888;--waline-bgcolor:#1e1e1e;--waline-bgcolor-light:#272727;--waline-bgcolor-hover: #444;--waline-border-color:#333;--waline-disable-bgcolor:#444;--waline-disable-color:#272727;--waline-bq-color:#272727;--waline-info-bgcolor:#272727;--waline-info-color:#666}",
    N = (e, t) => {
      let n = e.toString();
      for (; n.length < t;) n = "0" + n;
      return n;
    };
  function I(e, t) {
    const n = Object.create(null),
      r = e.split(",");
    for (let e = 0; e < r.length; e++) n[r[e]] = !0;
    return t ? e => !!n[e.toLowerCase()] : e => !!n[e];
  }
  function $(e) {
    if (se(e)) {
      const t = {};
      for (let n = 0; n < e.length; n++) {
        const r = e[n],
          i = ue(r) ? z(r) : $(r);
        if (i) for (const e in i) t[e] = i[e];
      }
      return t;
    }
    return ue(e) || he(e) ? e : void 0;
  }
  const P = /;(?![^(]*\))/g,
    U = /:([^]+)/,
    Y = /\/\*.*?\*\//gs;
  function z(e) {
    const t = {};
    return e.replace(Y, "").split(P).forEach(e => {
      if (e) {
        const n = e.split(U);
        n.length > 1 && (t[n[0].trim()] = n[1].trim());
      }
    }), t;
  }
  function j(e) {
    let t = "";
    if (ue(e)) t = e;else if (se(e)) for (let n = 0; n < e.length; n++) {
      const r = j(e[n]);
      r && (t += r + " ");
    } else if (he(e)) for (const n in e) e[n] && (t += n + " ");
    return t.trim();
  }
  const F = I("itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly");
  function H(e) {
    return !!e || "" === e;
  }
  function W(e, t) {
    if (e === t) return !0;
    let n = le(e),
      r = le(t);
    if (n || r) return !(!n || !r) && e.getTime() === t.getTime();
    if (n = de(e), r = de(t), n || r) return e === t;
    if (n = se(e), r = se(t), n || r) return !(!n || !r) && function (e, t) {
      if (e.length !== t.length) return !1;
      let n = !0;
      for (let r = 0; n && r < e.length; r++) n = W(e[r], t[r]);
      return n;
    }(e, t);
    if (n = he(e), r = he(t), n || r) {
      if (!n || !r) return !1;
      if (Object.keys(e).length !== Object.keys(t).length) return !1;
      for (const n in e) {
        const r = e.hasOwnProperty(n),
          i = t.hasOwnProperty(n);
        if (r && !i || !r && i || !W(e[n], t[n])) return !1;
      }
    }
    return String(e) === String(t);
  }
  function V(e, t) {
    return e.findIndex(e => W(e, t));
  }
  const B = e => ue(e) ? e : null == e ? "" : se(e) || he(e) && (e.toString === pe || !ce(e.toString)) ? JSON.stringify(e, G, 2) : String(e),
    G = (e, t) => t && t.__v_isRef ? G(e, t.value) : oe(t) ? {
      [`Map(${t.size})`]: [...t.entries()].reduce((e, t) => {
        let [n, r] = t;
        return e[`${n} =>`] = r, e;
      }, {})
    } : ae(t) ? {
      [`Set(${t.size})`]: [...t.values()]
    } : !he(t) || se(t) || ve(t) ? t : String(t),
    q = {},
    Z = [],
    Q = () => {},
    K = () => !1,
    X = /^on[^a-z]/,
    J = e => X.test(e),
    ee = e => e.startsWith("onUpdate:"),
    te = Object.assign,
    ne = (e, t) => {
      const n = e.indexOf(t);
      n > -1 && e.splice(n, 1);
    },
    re = Object.prototype.hasOwnProperty,
    ie = (e, t) => re.call(e, t),
    se = Array.isArray,
    oe = e => "[object Map]" === me(e),
    ae = e => "[object Set]" === me(e),
    le = e => "[object Date]" === me(e),
    ce = e => "function" == typeof e,
    ue = e => "string" == typeof e,
    de = e => "symbol" == typeof e,
    he = e => null !== e && "object" == typeof e,
    fe = e => he(e) && ce(e.then) && ce(e.catch),
    pe = Object.prototype.toString,
    me = e => pe.call(e),
    ge = e => me(e).slice(8, -1),
    ve = e => "[object Object]" === me(e),
    ye = e => ue(e) && "NaN" !== e && "-" !== e[0] && "" + parseInt(e, 10) === e,
    _e = I(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"),
    we = e => {
      const t = Object.create(null);
      return n => t[n] || (t[n] = e(n));
    },
    ke = /-(\w)/g,
    be = we(e => e.replace(ke, (e, t) => t ? t.toUpperCase() : "")),
    xe = /\B([A-Z])/g,
    Se = we(e => e.replace(xe, "-$1").toLowerCase()),
    Te = we(e => e.charAt(0).toUpperCase() + e.slice(1)),
    Ce = we(e => e ? `on${Te(e)}` : ""),
    Me = (e, t) => !Object.is(e, t),
    Oe = (e, t) => {
      for (let n = 0; n < e.length; n++) e[n](t);
    },
    De = (e, t, n) => {
      Object.defineProperty(e, t, {
        configurable: !0,
        enumerable: !1,
        value: n
      });
    },
    Re = e => {
      const t = parseFloat(e);
      return isNaN(t) ? e : t;
    };
  let Ee;
  const Ae = () => Ee || (Ee = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {});
  let Le;
  class Ne {
    constructor() {
      let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      this.detached = e, this._active = !0, this.effects = [], this.cleanups = [], this.parent = Le, !e && Le && (this.index = (Le.scopes || (Le.scopes = [])).push(this) - 1);
    }
    get active() {
      return this._active;
    }
    run(e) {
      if (this._active) {
        const t = Le;
        try {
          return Le = this, e();
        } finally {
          Le = t;
        }
      }
    }
    on() {
      Le = this;
    }
    off() {
      Le = this.parent;
    }
    stop(e) {
      if (this._active) {
        let t, n;
        for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].stop();
        for (t = 0, n = this.cleanups.length; t < n; t++) this.cleanups[t]();
        if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].stop(!0);
        if (!this.detached && this.parent && !e) {
          const e = this.parent.scopes.pop();
          e && e !== this && (this.parent.scopes[this.index] = e, e.index = this.index);
        }
        this.parent = void 0, this._active = !1;
      }
    }
  }
  function Ie() {
    return Le;
  }
  const $e = e => {
      const t = new Set(e);
      return t.w = 0, t.n = 0, t;
    },
    Pe = e => (e.w & je) > 0,
    Ue = e => (e.n & je) > 0,
    Ye = new WeakMap();
  let ze = 0,
    je = 1;
  const Fe = 30;
  let He;
  const We = Symbol(""),
    Ve = Symbol("");
  class Be {
    constructor(e) {
      let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 ? arguments[2] : void 0;
      this.fn = e, this.scheduler = t, this.active = !0, this.deps = [], this.parent = void 0, function (e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Le;
        t && t.active && t.effects.push(e);
      }(this, n);
    }
    run() {
      if (!this.active) return this.fn();
      let e = He,
        t = qe;
      for (; e;) {
        if (e === this) return;
        e = e.parent;
      }
      try {
        return this.parent = He, He = this, qe = !0, je = 1 << ++ze, ze <= Fe ? (e => {
          let {
            deps: t
          } = e;
          if (t.length) for (let e = 0; e < t.length; e++) t[e].w |= je;
        })(this) : Ge(this), this.fn();
      } finally {
        ze <= Fe && (e => {
          const {
            deps: t
          } = e;
          if (t.length) {
            let n = 0;
            for (let r = 0; r < t.length; r++) {
              const i = t[r];
              Pe(i) && !Ue(i) ? i.delete(e) : t[n++] = i, i.w &= ~je, i.n &= ~je;
            }
            t.length = n;
          }
        })(this), je = 1 << --ze, He = this.parent, qe = t, this.parent = void 0, this.deferStop && this.stop();
      }
    }
    stop() {
      He === this ? this.deferStop = !0 : this.active && (Ge(this), this.onStop && this.onStop(), this.active = !1);
    }
  }
  function Ge(e) {
    const {
      deps: t
    } = e;
    if (t.length) {
      for (let n = 0; n < t.length; n++) t[n].delete(e);
      t.length = 0;
    }
  }
  let qe = !0;
  const Ze = [];
  function Qe() {
    Ze.push(qe), qe = !1;
  }
  function Ke() {
    const e = Ze.pop();
    qe = void 0 === e || e;
  }
  function Xe(e, t, n) {
    if (qe && He) {
      let t = Ye.get(e);
      t || Ye.set(e, t = new Map());
      let r = t.get(n);
      r || t.set(n, r = $e()), Je(r);
    }
  }
  function Je(e, t) {
    let n = !1;
    ze <= Fe ? Ue(e) || (e.n |= je, n = !Pe(e)) : n = !e.has(He), n && (e.add(He), He.deps.push(e));
  }
  function et(e, t, n, r, i, s) {
    const o = Ye.get(e);
    if (!o) return;
    let a = [];
    if ("clear" === t) a = [...o.values()];else if ("length" === n && se(e)) {
      const e = Number(r);
      o.forEach((t, n) => {
        ("length" === n || n >= e) && a.push(t);
      });
    } else switch (void 0 !== n && a.push(o.get(n)), t) {
      case "add":
        se(e) ? ye(n) && a.push(o.get("length")) : (a.push(o.get(We)), oe(e) && a.push(o.get(Ve)));
        break;
      case "delete":
        se(e) || (a.push(o.get(We)), oe(e) && a.push(o.get(Ve)));
        break;
      case "set":
        oe(e) && a.push(o.get(We));
    }
    if (1 === a.length) a[0] && tt(a[0]);else {
      const e = [];
      for (const t of a) t && e.push(...t);
      tt($e(e));
    }
  }
  function tt(e, t) {
    const n = se(e) ? e : [...e];
    for (const e of n) e.computed && nt(e);
    for (const e of n) e.computed || nt(e);
  }
  function nt(e, t) {
    (e !== He || e.allowRecurse) && (e.scheduler ? e.scheduler() : e.run());
  }
  const rt = I("__proto__,__v_isRef,__isVue"),
    it = new Set(Object.getOwnPropertyNames(Symbol).filter(e => "arguments" !== e && "caller" !== e).map(e => Symbol[e]).filter(de)),
    st = ut(),
    ot = ut(!1, !0),
    at = ut(!0),
    lt = function () {
      const e = {};
      return ["includes", "indexOf", "lastIndexOf"].forEach(t => {
        e[t] = function () {
          const e = Bt(this);
          for (let t = 0, n = this.length; t < n; t++) Xe(e, 0, t + "");
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
          const s = e[t](...r);
          return -1 === s || !1 === s ? e[t](...r.map(Bt)) : s;
        };
      }), ["push", "pop", "shift", "unshift", "splice"].forEach(t => {
        e[t] = function () {
          Qe();
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
          const i = Bt(this)[t].apply(this, n);
          return Ke(), i;
        };
      }), e;
    }();
  function ct(e) {
    const t = Bt(this);
    return Xe(t, 0, e), t.hasOwnProperty(e);
  }
  function ut() {
    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
      t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return function (n, r, i) {
      if ("__v_isReactive" === r) return !e;
      if ("__v_isReadonly" === r) return e;
      if ("__v_isShallow" === r) return t;
      if ("__v_raw" === r && i === (e ? t ? Ut : Pt : t ? $t : It).get(n)) return n;
      const s = se(n);
      if (!e) {
        if (s && ie(lt, r)) return Reflect.get(lt, r, i);
        if ("hasOwnProperty" === r) return ct;
      }
      const o = Reflect.get(n, r, i);
      return (de(r) ? it.has(r) : rt(r)) ? o : (e || Xe(n, 0, r), t ? o : Xt(o) ? s && ye(r) ? o : o.value : he(o) ? e ? zt(o) : Yt(o) : o);
    };
  }
  function dt() {
    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    return function (t, n, r, i) {
      let s = t[n];
      if (Ht(s) && Xt(s) && !Xt(r)) return !1;
      if (!e && (Wt(r) || Ht(r) || (s = Bt(s), r = Bt(r)), !se(t) && Xt(s) && !Xt(r))) return s.value = r, !0;
      const o = se(t) && ye(n) ? Number(n) < t.length : ie(t, n),
        a = Reflect.set(t, n, r, i);
      return t === Bt(i) && (o ? Me(r, s) && et(t, "set", n, r) : et(t, "add", n, r)), a;
    };
  }
  const ht = {
      get: st,
      set: dt(),
      deleteProperty: function (e, t) {
        const n = ie(e, t),
          r = Reflect.deleteProperty(e, t);
        return r && n && et(e, "delete", t, void 0), r;
      },
      has: function (e, t) {
        const n = Reflect.has(e, t);
        return de(t) && it.has(t) || Xe(e, 0, t), n;
      },
      ownKeys: function (e) {
        return Xe(e, 0, se(e) ? "length" : We), Reflect.ownKeys(e);
      }
    },
    ft = {
      get: at,
      set: (e, t) => !0,
      deleteProperty: (e, t) => !0
    },
    pt = te({}, ht, {
      get: ot,
      set: dt(!0)
    }),
    mt = e => e,
    gt = e => Reflect.getPrototypeOf(e);
  function vt(e, t) {
    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    const i = Bt(e = e.__v_raw),
      s = Bt(t);
    n || (t !== s && Xe(i, 0, t), Xe(i, 0, s));
    const {
        has: o
      } = gt(i),
      a = r ? mt : n ? Zt : qt;
    return o.call(i, t) ? a(e.get(t)) : o.call(i, s) ? a(e.get(s)) : void (e !== i && e.get(t));
  }
  function yt(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    const n = this.__v_raw,
      r = Bt(n),
      i = Bt(e);
    return t || (e !== i && Xe(r, 0, e), Xe(r, 0, i)), e === i ? n.has(e) : n.has(e) || n.has(i);
  }
  function _t(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return e = e.__v_raw, !t && Xe(Bt(e), 0, We), Reflect.get(e, "size", e);
  }
  function wt(e) {
    e = Bt(e);
    const t = Bt(this);
    return gt(t).has.call(t, e) || (t.add(e), et(t, "add", e, e)), this;
  }
  function kt(e, t) {
    t = Bt(t);
    const n = Bt(this),
      {
        has: r,
        get: i
      } = gt(n);
    let s = r.call(n, e);
    s || (e = Bt(e), s = r.call(n, e));
    const o = i.call(n, e);
    return n.set(e, t), s ? Me(t, o) && et(n, "set", e, t) : et(n, "add", e, t), this;
  }
  function bt(e) {
    const t = Bt(this),
      {
        has: n,
        get: r
      } = gt(t);
    let i = n.call(t, e);
    i || (e = Bt(e), i = n.call(t, e)), r && r.call(t, e);
    const s = t.delete(e);
    return i && et(t, "delete", e, void 0), s;
  }
  function xt() {
    const e = Bt(this),
      t = 0 !== e.size,
      n = e.clear();
    return t && et(e, "clear", void 0, void 0), n;
  }
  function St(e, t) {
    return function (n, r) {
      const i = this,
        s = i.__v_raw,
        o = Bt(s),
        a = t ? mt : e ? Zt : qt;
      return !e && Xe(o, 0, We), s.forEach((e, t) => n.call(r, a(e), a(t), i));
    };
  }
  function Tt(e, t, n) {
    return function () {
      const r = this.__v_raw,
        i = Bt(r),
        s = oe(i),
        o = "entries" === e || e === Symbol.iterator && s,
        a = "keys" === e && s,
        l = r[e](...arguments),
        c = n ? mt : t ? Zt : qt;
      return !t && Xe(i, 0, a ? Ve : We), {
        next() {
          const {
            value: e,
            done: t
          } = l.next();
          return t ? {
            value: e,
            done: t
          } : {
            value: o ? [c(e[0]), c(e[1])] : c(e),
            done: t
          };
        },
        [Symbol.iterator]() {
          return this;
        }
      };
    };
  }
  function Ct(e) {
    return function () {
      return "delete" !== e && this;
    };
  }
  const [Mt, Ot, Dt, Rt] = function () {
    const e = {
        get(e) {
          return vt(this, e);
        },
        get size() {
          return _t(this);
        },
        has: yt,
        add: wt,
        set: kt,
        delete: bt,
        clear: xt,
        forEach: St(!1, !1)
      },
      t = {
        get(e) {
          return vt(this, e, !1, !0);
        },
        get size() {
          return _t(this);
        },
        has: yt,
        add: wt,
        set: kt,
        delete: bt,
        clear: xt,
        forEach: St(!1, !0)
      },
      n = {
        get(e) {
          return vt(this, e, !0);
        },
        get size() {
          return _t(this, !0);
        },
        has(e) {
          return yt.call(this, e, !0);
        },
        add: Ct("add"),
        set: Ct("set"),
        delete: Ct("delete"),
        clear: Ct("clear"),
        forEach: St(!0, !1)
      },
      r = {
        get(e) {
          return vt(this, e, !0, !0);
        },
        get size() {
          return _t(this, !0);
        },
        has(e) {
          return yt.call(this, e, !0);
        },
        add: Ct("add"),
        set: Ct("set"),
        delete: Ct("delete"),
        clear: Ct("clear"),
        forEach: St(!0, !0)
      };
    return ["keys", "values", "entries", Symbol.iterator].forEach(i => {
      e[i] = Tt(i, !1, !1), n[i] = Tt(i, !0, !1), t[i] = Tt(i, !1, !0), r[i] = Tt(i, !0, !0);
    }), [e, n, t, r];
  }();
  function Et(e, t) {
    const n = t ? e ? Rt : Dt : e ? Ot : Mt;
    return (t, r, i) => "__v_isReactive" === r ? !e : "__v_isReadonly" === r ? e : "__v_raw" === r ? t : Reflect.get(ie(n, r) && r in t ? n : t, r, i);
  }
  const At = {
      get: Et(!1, !1)
    },
    Lt = {
      get: Et(!1, !0)
    },
    Nt = {
      get: Et(!0, !1)
    },
    It = new WeakMap(),
    $t = new WeakMap(),
    Pt = new WeakMap(),
    Ut = new WeakMap();
  function Yt(e) {
    return Ht(e) ? e : jt(e, !1, ht, At, It);
  }
  function zt(e) {
    return jt(e, !0, ft, Nt, Pt);
  }
  function jt(e, t, n, r, i) {
    if (!he(e)) return e;
    if (e.__v_raw && (!t || !e.__v_isReactive)) return e;
    const s = i.get(e);
    if (s) return s;
    const o = (a = e).__v_skip || !Object.isExtensible(a) ? 0 : function (e) {
      switch (e) {
        case "Object":
        case "Array":
          return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
          return 2;
        default:
          return 0;
      }
    }(ge(a));
    var a;
    if (0 === o) return e;
    const l = new Proxy(e, 2 === o ? r : n);
    return i.set(e, l), l;
  }
  function Ft(e) {
    return Ht(e) ? Ft(e.__v_raw) : !(!e || !e.__v_isReactive);
  }
  function Ht(e) {
    return !(!e || !e.__v_isReadonly);
  }
  function Wt(e) {
    return !(!e || !e.__v_isShallow);
  }
  function Vt(e) {
    return Ft(e) || Ht(e);
  }
  function Bt(e) {
    const t = e && e.__v_raw;
    return t ? Bt(t) : e;
  }
  function Gt(e) {
    return De(e, "__v_skip", !0), e;
  }
  const qt = e => he(e) ? Yt(e) : e,
    Zt = e => he(e) ? zt(e) : e;
  function Qt(e) {
    qe && He && Je((e = Bt(e)).dep || (e.dep = $e()));
  }
  function Kt(e, t) {
    const n = (e = Bt(e)).dep;
    n && tt(n);
  }
  function Xt(e) {
    return !(!e || !0 !== e.__v_isRef);
  }
  function Jt(e) {
    return tn(e, !1);
  }
  function en(e) {
    return tn(e, !0);
  }
  function tn(e, t) {
    return Xt(e) ? e : new nn(e, t);
  }
  class nn {
    constructor(e, t) {
      this.__v_isShallow = t, this.dep = void 0, this.__v_isRef = !0, this._rawValue = t ? e : Bt(e), this._value = t ? e : qt(e);
    }
    get value() {
      return Qt(this), this._value;
    }
    set value(e) {
      const t = this.__v_isShallow || Wt(e) || Ht(e);
      e = t ? e : Bt(e), Me(e, this._rawValue) && (this._rawValue = e, this._value = t ? e : qt(e), Kt(this));
    }
  }
  function rn(e) {
    return Xt(e) ? e.value : e;
  }
  const sn = {
    get: (e, t, n) => rn(Reflect.get(e, t, n)),
    set: (e, t, n, r) => {
      const i = e[t];
      return Xt(i) && !Xt(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
    }
  };
  function on(e) {
    return Ft(e) ? e : new Proxy(e, sn);
  }
  var an;
  class ln {
    constructor(e, t, n, r) {
      this._setter = t, this.dep = void 0, this.__v_isRef = !0, this[an] = !1, this._dirty = !0, this.effect = new Be(e, () => {
        this._dirty || (this._dirty = !0, Kt(this));
      }), this.effect.computed = this, this.effect.active = this._cacheable = !r, this.__v_isReadonly = n;
    }
    get value() {
      const e = Bt(this);
      return Qt(e), !e._dirty && e._cacheable || (e._dirty = !1, e._value = e.effect.run()), e._value;
    }
    set value(e) {
      this._setter(e);
    }
  }
  function cn(e, t, n, r) {
    let i;
    try {
      i = r ? e(...r) : e();
    } catch (e) {
      dn(e, t, n);
    }
    return i;
  }
  function un(e, t, n, r) {
    if (ce(e)) {
      const i = cn(e, t, n, r);
      return i && fe(i) && i.catch(e => {
        dn(e, t, n);
      }), i;
    }
    const i = [];
    for (let s = 0; s < e.length; s++) i.push(un(e[s], t, n, r));
    return i;
  }
  function dn(e, t, n) {
    t && t.vnode;
    if (t) {
      let r = t.parent;
      const i = t.proxy,
        s = n;
      for (; r;) {
        const t = r.ec;
        if (t) for (let n = 0; n < t.length; n++) if (!1 === t[n](e, i, s)) return;
        r = r.parent;
      }
      const o = t.appContext.config.errorHandler;
      if (o) return void cn(o, null, 10, [e, i, s]);
    }
    !function (e, t, n) {
      console.error(e);
    }(e);
  }
  an = "__v_isReadonly";
  let hn = !1,
    fn = !1;
  const pn = [];
  let mn = 0;
  const gn = [];
  let vn = null,
    yn = 0;
  const _n = Promise.resolve();
  let wn = null;
  function kn(e) {
    const t = wn || _n;
    return e ? t.then(this ? e.bind(this) : e) : t;
  }
  function bn(e) {
    pn.length && pn.includes(e, hn && e.allowRecurse ? mn + 1 : mn) || (null == e.id ? pn.push(e) : pn.splice(function (e) {
      let t = mn + 1,
        n = pn.length;
      for (; t < n;) {
        const r = t + n >>> 1;
        Cn(pn[r]) < e ? t = r + 1 : n = r;
      }
      return t;
    }(e.id), 0, e), xn());
  }
  function xn() {
    hn || fn || (fn = !0, wn = _n.then(On));
  }
  function Sn(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : hn ? mn + 1 : 0;
    for (; t < pn.length; t++) {
      const e = pn[t];
      e && e.pre && (pn.splice(t, 1), t--, e());
    }
  }
  function Tn(e) {
    if (gn.length) {
      const e = [...new Set(gn)];
      if (gn.length = 0, vn) return void vn.push(...e);
      for (vn = e, vn.sort((e, t) => Cn(e) - Cn(t)), yn = 0; yn < vn.length; yn++) vn[yn]();
      vn = null, yn = 0;
    }
  }
  const Cn = e => null == e.id ? 1 / 0 : e.id,
    Mn = (e, t) => {
      const n = Cn(e) - Cn(t);
      if (0 === n) {
        if (e.pre && !t.pre) return -1;
        if (t.pre && !e.pre) return 1;
      }
      return n;
    };
  function On(e) {
    fn = !1, hn = !0, pn.sort(Mn);
    try {
      for (mn = 0; mn < pn.length; mn++) {
        const e = pn[mn];
        e && !1 !== e.active && cn(e, null, 14);
      }
    } finally {
      mn = 0, pn.length = 0, Tn(), hn = !1, wn = null, (pn.length || gn.length) && On();
    }
  }
  function Dn(e, t) {
    if (e.isUnmounted) return;
    const n = e.vnode.props || q;
    for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++) i[s - 2] = arguments[s];
    let o = i;
    const a = t.startsWith("update:"),
      l = a && t.slice(7);
    if (l && l in n) {
      const e = `${"modelValue" === l ? "model" : l}Modifiers`,
        {
          number: t,
          trim: r
        } = n[e] || q;
      r && (o = i.map(e => ue(e) ? e.trim() : e)), t && (o = i.map(Re));
    }
    let c,
      u = n[c = Ce(t)] || n[c = Ce(be(t))];
    !u && a && (u = n[c = Ce(Se(t))]), u && un(u, e, 6, o);
    const d = n[c + "Once"];
    if (d) {
      if (e.emitted) {
        if (e.emitted[c]) return;
      } else e.emitted = {};
      e.emitted[c] = !0, un(d, e, 6, o);
    }
  }
  function Rn(e, t) {
    const n = t.emitsCache,
      r = n.get(e);
    if (void 0 !== r) return r;
    const i = e.emits;
    let s = {};
    return i ? (se(i) ? i.forEach(e => s[e] = null) : te(s, i), he(e) && n.set(e, s), s) : (he(e) && n.set(e, null), null);
  }
  function En(e, t) {
    return !(!e || !J(t)) && (t = t.slice(2).replace(/Once$/, ""), ie(e, t[0].toLowerCase() + t.slice(1)) || ie(e, Se(t)) || ie(e, t));
  }
  let An = null,
    Ln = null;
  function Nn(e) {
    const t = An;
    return An = e, Ln = e && e.type.__scopeId || null, t;
  }
  function In(e) {
    const {
      type: t,
      vnode: n,
      proxy: r,
      withProxy: i,
      props: s,
      propsOptions: [o],
      slots: a,
      attrs: l,
      emit: c,
      render: u,
      renderCache: d,
      data: h,
      setupState: f,
      ctx: p,
      inheritAttrs: m
    } = e;
    let g, v;
    const y = Nn(e);
    try {
      if (4 & n.shapeFlag) {
        const e = i || r;
        g = oi(u.call(e, e, d, s, f, h, p)), v = l;
      } else {
        const e = t;
        g = oi(e.length > 1 ? e(s, {
          attrs: l,
          slots: a,
          emit: c
        }) : e(s, null)), v = t.props ? l : $n(l);
      }
    } catch (t) {
      Fr.length = 0, dn(t, e, 1), g = ni(zr);
    }
    let _ = g;
    if (v && !1 !== m) {
      const e = Object.keys(v),
        {
          shapeFlag: t
        } = _;
      e.length && 7 & t && (o && e.some(ee) && (v = Pn(v, o)), _ = ri(_, v));
    }
    return n.dirs && (_ = ri(_), _.dirs = _.dirs ? _.dirs.concat(n.dirs) : n.dirs), n.transition && (_.transition = n.transition), g = _, Nn(y), g;
  }
  const $n = e => {
      let t;
      for (const n in e) ("class" === n || "style" === n || J(n)) && ((t || (t = {}))[n] = e[n]);
      return t;
    },
    Pn = (e, t) => {
      const n = {};
      for (const r in e) ee(r) && r.slice(9) in t || (n[r] = e[r]);
      return n;
    };
  function Un(e, t, n) {
    const r = Object.keys(t);
    if (r.length !== Object.keys(e).length) return !0;
    for (let i = 0; i < r.length; i++) {
      const s = r[i];
      if (t[s] !== e[s] && !En(n, s)) return !0;
    }
    return !1;
  }
  const Yn = e => e.__isSuspense;
  function zn(e, t) {
    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    const r = hi || An;
    if (r) {
      const i = null == r.parent ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides;
      if (i && e in i) return i[e];
      if (arguments.length > 1) return n && ce(t) ? t.call(r.proxy) : t;
    }
  }
  function jn(e, t) {
    return Wn(e, null, t);
  }
  const Fn = {};
  function Hn(e, t, n) {
    return Wn(e, t, n);
  }
  function Wn(e, t) {
    let {
      immediate: n,
      deep: r,
      flush: i,
      onTrack: s,
      onTrigger: o
    } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : q;
    const a = Ie() === (null == hi ? void 0 : hi.scope) ? hi : null;
    let l,
      c,
      u = !1,
      d = !1;
    if (Xt(e) ? (l = () => e.value, u = Wt(e)) : Ft(e) ? (l = () => e, r = !0) : se(e) ? (d = !0, u = e.some(e => Ft(e) || Wt(e)), l = () => e.map(e => Xt(e) ? e.value : Ft(e) ? Vn(e) : ce(e) ? cn(e, a, 2) : void 0)) : l = ce(e) ? t ? () => cn(e, a, 2) : () => {
      if (!a || !a.isUnmounted) return c && c(), un(e, a, 3, [f]);
    } : Q, t && r) {
      const e = l;
      l = () => Vn(e());
    }
    let h,
      f = e => {
        c = v.onStop = () => {
          cn(e, a, 4);
        };
      };
    if (yi) {
      if (f = Q, t ? n && un(t, a, 3, [l(), d ? [] : void 0, f]) : l(), "sync" !== i) return Q;
      {
        const e = Ti();
        h = e.__watcherHandles || (e.__watcherHandles = []);
      }
    }
    let p = d ? new Array(e.length).fill(Fn) : Fn;
    const m = () => {
      if (v.active) if (t) {
        const e = v.run();
        (r || u || (d ? e.some((e, t) => Me(e, p[t])) : Me(e, p))) && (c && c(), un(t, a, 3, [e, p === Fn ? void 0 : d && p[0] === Fn ? [] : p, f]), p = e);
      } else v.run();
    };
    let g;
    m.allowRecurse = !!t, "sync" === i ? g = m : "post" === i ? g = () => Lr(m, a && a.suspense) : (m.pre = !0, a && (m.id = a.uid), g = () => bn(m));
    const v = new Be(l, g);
    t ? n ? m() : p = v.run() : "post" === i ? Lr(v.run.bind(v), a && a.suspense) : v.run();
    const y = () => {
      v.stop(), a && a.scope && ne(a.scope.effects, v);
    };
    return h && h.push(y), y;
  }
  function Vn(e, t) {
    if (!he(e) || e.__v_skip) return e;
    if ((t = t || new Set()).has(e)) return e;
    if (t.add(e), Xt(e)) Vn(e.value, t);else if (se(e)) for (let n = 0; n < e.length; n++) Vn(e[n], t);else if (ae(e) || oe(e)) e.forEach(e => {
      Vn(e, t);
    });else if (ve(e)) for (const n in e) Vn(e[n], t);
    return e;
  }
  function Bn(e) {
    return ce(e) ? {
      setup: e,
      name: e.name
    } : e;
  }
  const Gn = e => !!e.type.__asyncLoader,
    qn = e => e.type.__isKeepAlive,
    Zn = e => function (t) {
      return (!yi || "sp" === e) && function (e, t) {
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : hi,
          r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        if (n) {
          const i = n[e] || (n[e] = []),
            s = t.__weh || (t.__weh = function () {
              if (n.isUnmounted) return;
              Qe(), pi(n);
              for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++) i[s] = arguments[s];
              const o = un(t, n, e, i);
              return mi(), Ke(), o;
            });
          return r ? i.unshift(s) : i.push(s), s;
        }
      }(e, function () {
        return t(...arguments);
      }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : hi);
    },
    Qn = Zn("m"),
    Kn = Zn("bum"),
    Xn = Zn("um");
  function Jn(e, t) {
    const n = An;
    if (null === n) return e;
    const r = ki(n) || n.proxy,
      i = e.dirs || (e.dirs = []);
    for (let e = 0; e < t.length; e++) {
      let [n, s, o, a = q] = t[e];
      n && (ce(n) && (n = {
        mounted: n,
        updated: n
      }), n.deep && Vn(s), i.push({
        dir: n,
        instance: r,
        value: s,
        oldValue: void 0,
        arg: o,
        modifiers: a
      }));
    }
    return e;
  }
  function er(e, t, n, r) {
    const i = e.dirs,
      s = t && t.dirs;
    for (let o = 0; o < i.length; o++) {
      const a = i[o];
      s && (a.oldValue = s[o].value);
      let l = a.dir[r];
      l && (Qe(), un(l, n, 8, [e.el, a, e, t]), Ke());
    }
  }
  const tr = "components";
  const nr = Symbol();
  function rr(e, t) {
    return e && (e[t] || e[be(t)] || e[Te(be(t))]);
  }
  function ir(e, t, n, r) {
    let i;
    const s = n && n[r];
    if (se(e) || ue(e)) {
      i = new Array(e.length);
      for (let n = 0, r = e.length; n < r; n++) i[n] = t(e[n], n, void 0, s && s[n]);
    } else if ("number" == typeof e) {
      i = new Array(e);
      for (let n = 0; n < e; n++) i[n] = t(n + 1, n, void 0, s && s[n]);
    } else if (he(e)) {
      if (e[Symbol.iterator]) i = Array.from(e, (e, n) => t(e, n, void 0, s && s[n]));else {
        const n = Object.keys(e);
        i = new Array(n.length);
        for (let r = 0, o = n.length; r < o; r++) {
          const o = n[r];
          i[r] = t(e[o], o, r, s && s[r]);
        }
      }
    } else i = [];
    return n && (n[r] = i), i;
  }
  const sr = e => e ? gi(e) ? ki(e) || e.proxy : sr(e.parent) : null,
    or = te(Object.create(null), {
      $: e => e,
      $el: e => e.vnode.el,
      $data: e => e.data,
      $props: e => e.props,
      $attrs: e => e.attrs,
      $slots: e => e.slots,
      $refs: e => e.refs,
      $parent: e => sr(e.parent),
      $root: e => sr(e.root),
      $emit: e => e.emit,
      $options: e => e.type,
      $forceUpdate: e => e.f || (e.f = () => bn(e.update)),
      $nextTick: e => e.n || (e.n = kn.bind(e.proxy)),
      $watch: e => Q
    }),
    ar = (e, t) => e !== q && !e.__isScriptSetup && ie(e, t),
    lr = {
      get(e, t) {
        let {
          _: n
        } = e;
        const {
          ctx: r,
          setupState: i,
          data: s,
          props: o,
          accessCache: a,
          type: l,
          appContext: c
        } = n;
        let u;
        if ("$" !== t[0]) {
          const e = a[t];
          if (void 0 !== e) switch (e) {
            case 1:
              return i[t];
            case 2:
              return s[t];
            case 4:
              return r[t];
            case 3:
              return o[t];
          } else {
            if (ar(i, t)) return a[t] = 1, i[t];
            if (s !== q && ie(s, t)) return a[t] = 2, s[t];
            if ((u = n.propsOptions[0]) && ie(u, t)) return a[t] = 3, o[t];
            if (r !== q && ie(r, t)) return a[t] = 4, r[t];
            a[t] = 0;
          }
        }
        const d = or[t];
        let h, f;
        return d ? ("$attrs" === t && Xe(n, 0, t), d(n)) : (h = l.__cssModules) && (h = h[t]) ? h : r !== q && ie(r, t) ? (a[t] = 4, r[t]) : (f = c.config.globalProperties, ie(f, t) ? f[t] : void 0);
      },
      set(e, t, n) {
        let {
          _: r
        } = e;
        const {
          data: i,
          setupState: s,
          ctx: o
        } = r;
        return ar(s, t) ? (s[t] = n, !0) : i !== q && ie(i, t) ? (i[t] = n, !0) : !(ie(r.props, t) || "$" === t[0] && t.slice(1) in r || (o[t] = n, 0));
      },
      has(e, t) {
        let n,
          {
            _: {
              data: r,
              setupState: i,
              accessCache: s,
              ctx: o,
              appContext: a,
              propsOptions: l
            }
          } = e;
        return !!s[t] || r !== q && ie(r, t) || ar(i, t) || (n = l[0]) && ie(n, t) || ie(o, t) || ie(or, t) || ie(a.config.globalProperties, t);
      },
      defineProperty(e, t, n) {
        return null != n.get ? e._.accessCache[t] = 0 : ie(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
      }
    };
  function cr(e, t, n) {
    let r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    const {
      mixins: i,
      extends: s
    } = t;
    s && cr(e, s, n, !0), i && i.forEach(t => cr(e, t, n, !0));
    for (const i in t) if (r && "expose" === i) ;else {
      const r = ur[i] || n && n[i];
      e[i] = r ? r(e[i], t[i]) : t[i];
    }
    return e;
  }
  const ur = {
    data: dr,
    props: pr,
    emits: pr,
    methods: pr,
    computed: pr,
    beforeCreate: fr,
    created: fr,
    beforeMount: fr,
    mounted: fr,
    beforeUpdate: fr,
    updated: fr,
    beforeDestroy: fr,
    beforeUnmount: fr,
    destroyed: fr,
    unmounted: fr,
    activated: fr,
    deactivated: fr,
    errorCaptured: fr,
    serverPrefetch: fr,
    components: pr,
    directives: pr,
    watch: function (e, t) {
      if (!e) return t;
      if (!t) return e;
      const n = te(Object.create(null), e);
      for (const r in t) n[r] = fr(e[r], t[r]);
      return n;
    },
    provide: dr,
    inject: function (e, t) {
      return pr(hr(e), hr(t));
    }
  };
  function dr(e, t) {
    return t ? e ? function () {
      return te(ce(e) ? e.call(this, this) : e, ce(t) ? t.call(this, this) : t);
    } : t : e;
  }
  function hr(e) {
    if (se(e)) {
      const t = {};
      for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
      return t;
    }
    return e;
  }
  function fr(e, t) {
    return e ? [...new Set([].concat(e, t))] : t;
  }
  function pr(e, t) {
    return e ? te(te(Object.create(null), e), t) : t;
  }
  function mr(e, t, n, r) {
    const [i, s] = e.propsOptions;
    let o,
      a = !1;
    if (t) for (let l in t) {
      if (_e(l)) continue;
      const c = t[l];
      let u;
      i && ie(i, u = be(l)) ? s && s.includes(u) ? (o || (o = {}))[u] = c : n[u] = c : En(e.emitsOptions, l) || l in r && c === r[l] || (r[l] = c, a = !0);
    }
    if (s) {
      const t = Bt(n),
        r = o || q;
      for (let o = 0; o < s.length; o++) {
        const a = s[o];
        n[a] = gr(i, t, a, r[a], e, !ie(r, a));
      }
    }
    return a;
  }
  function gr(e, t, n, r, i, s) {
    const o = e[n];
    if (null != o) {
      const e = ie(o, "default");
      if (e && void 0 === r) {
        const e = o.default;
        if (o.type !== Function && ce(e)) {
          const {
            propsDefaults: s
          } = i;
          n in s ? r = s[n] : (pi(i), r = s[n] = e.call(null, t), mi());
        } else r = e;
      }
      o[0] && (s && !e ? r = !1 : !o[1] || "" !== r && r !== Se(n) || (r = !0));
    }
    return r;
  }
  function vr(e, t) {
    const n = t.propsCache,
      r = n.get(e);
    if (r) return r;
    const i = e.props,
      s = {},
      o = [];
    if (!i) return he(e) && n.set(e, Z), Z;
    if (se(i)) for (let e = 0; e < i.length; e++) {
      const t = be(i[e]);
      yr(t) && (s[t] = q);
    } else if (i) for (const e in i) {
      const t = be(e);
      if (yr(t)) {
        const n = i[e],
          r = s[t] = se(n) || ce(n) ? {
            type: n
          } : Object.assign({}, n);
        if (r) {
          const e = kr(Boolean, r.type),
            n = kr(String, r.type);
          r[0] = e > -1, r[1] = n < 0 || e < n, (e > -1 || ie(r, "default")) && o.push(t);
        }
      }
    }
    const a = [s, o];
    return he(e) && n.set(e, a), a;
  }
  function yr(e) {
    return "$" !== e[0];
  }
  function _r(e) {
    const t = e && e.toString().match(/^\s*(function|class) (\w+)/);
    return t ? t[2] : null === e ? "null" : "";
  }
  function wr(e, t) {
    return _r(e) === _r(t);
  }
  function kr(e, t) {
    return se(t) ? t.findIndex(t => wr(t, e)) : ce(t) && wr(t, e) ? 0 : -1;
  }
  const br = e => "_" === e[0] || "$stable" === e,
    xr = e => se(e) ? e.map(oi) : [oi(e)],
    Sr = (e, t, n) => {
      if (t._n) return t;
      const r = function (e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : An;
        if (!t) return e;
        if (e._n) return e;
        const n = function () {
          n._d && Br(-1);
          const r = Nn(t);
          let i;
          try {
            i = e(...arguments);
          } finally {
            Nn(r), n._d && Br(1);
          }
          return i;
        };
        return n._n = !0, n._c = !0, n._d = !0, n;
      }(function () {
        return xr(t(...arguments));
      }, n);
      return r._c = !1, r;
    },
    Tr = (e, t, n) => {
      const r = e._ctx;
      for (const n in e) {
        if (br(n)) continue;
        const i = e[n];
        if (ce(i)) t[n] = Sr(0, i, r);else if (null != i) {
          const e = xr(i);
          t[n] = () => e;
        }
      }
    },
    Cr = (e, t) => {
      const n = xr(t);
      e.slots.default = () => n;
    },
    Mr = (e, t) => {
      if (32 & e.vnode.shapeFlag) {
        const n = t._;
        n ? (e.slots = Bt(t), De(t, "_", n)) : Tr(t, e.slots = {});
      } else e.slots = {}, t && Cr(e, t);
      De(e.slots, Xr, 1);
    },
    Or = (e, t, n) => {
      const {
        vnode: r,
        slots: i
      } = e;
      let s = !0,
        o = q;
      if (32 & r.shapeFlag) {
        const e = t._;
        e ? n && 1 === e ? s = !1 : (te(i, t), n || 1 !== e || delete i._) : (s = !t.$stable, Tr(t, i)), o = t;
      } else t && (Cr(e, t), o = {
        default: 1
      });
      if (s) for (const e in i) br(e) || e in o || delete i[e];
    };
  function Dr() {
    return {
      app: null,
      config: {
        isNativeTag: K,
        performance: !1,
        globalProperties: {},
        optionMergeStrategies: {},
        errorHandler: void 0,
        warnHandler: void 0,
        compilerOptions: {}
      },
      mixins: [],
      components: {},
      directives: {},
      provides: Object.create(null),
      optionsCache: new WeakMap(),
      propsCache: new WeakMap(),
      emitsCache: new WeakMap()
    };
  }
  let Rr = 0;
  function Er(e, t) {
    return function (n) {
      let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      ce(n) || (n = Object.assign({}, n)), null == r || he(r) || (r = null);
      const i = Dr(),
        s = new Set();
      let o = !1;
      const a = i.app = {
        _uid: Rr++,
        _component: n,
        _props: r,
        _container: null,
        _context: i,
        _instance: null,
        version: Ci,
        get config() {
          return i.config;
        },
        set config(e) {},
        use(e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          return s.has(e) || (e && ce(e.install) ? (s.add(e), e.install(a, ...n)) : ce(e) && (s.add(e), e(a, ...n))), a;
        },
        mixin: e => a,
        component: (e, t) => t ? (i.components[e] = t, a) : i.components[e],
        directive: (e, t) => t ? (i.directives[e] = t, a) : i.directives[e],
        mount(s, l, c) {
          if (!o) {
            const u = ni(n, r);
            return u.appContext = i, l && t ? t(u, s) : e(u, s, c), o = !0, a._container = s, s.__vue_app__ = a, ki(u.component) || u.component.proxy;
          }
        },
        unmount() {
          o && (e(null, a._container), delete a._container.__vue_app__);
        },
        provide: (e, t) => (i.provides[e] = t, a)
      };
      return a;
    };
  }
  function Ar(e, t, n, r) {
    let i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
    if (se(e)) return void e.forEach((e, s) => Ar(e, t && (se(t) ? t[s] : t), n, r, i));
    if (Gn(r) && !i) return;
    const s = 4 & r.shapeFlag ? ki(r.component) || r.component.proxy : r.el,
      o = i ? null : s,
      {
        i: a,
        r: l
      } = e,
      c = t && t.r,
      u = a.refs === q ? a.refs = {} : a.refs,
      d = a.setupState;
    if (null != c && c !== l && (ue(c) ? (u[c] = null, ie(d, c) && (d[c] = null)) : Xt(c) && (c.value = null)), ce(l)) cn(l, a, 12, [o, u]);else {
      const t = ue(l),
        r = Xt(l);
      if (t || r) {
        const a = () => {
          if (e.f) {
            const n = t ? ie(d, l) ? d[l] : u[l] : l.value;
            i ? se(n) && ne(n, s) : se(n) ? n.includes(s) || n.push(s) : t ? (u[l] = [s], ie(d, l) && (d[l] = u[l])) : (l.value = [s], e.k && (u[e.k] = l.value));
          } else t ? (u[l] = o, ie(d, l) && (d[l] = o)) : r && (l.value = o, e.k && (u[e.k] = o));
        };
        o ? (a.id = -1, Lr(a, n)) : a();
      }
    }
  }
  const Lr = function (e, t) {
    var n;
    t && t.pendingBranch ? se(e) ? t.effects.push(...e) : t.effects.push(e) : (se(n = e) ? gn.push(...n) : vn && vn.includes(n, n.allowRecurse ? yn + 1 : yn) || gn.push(n), xn());
  };
  function Nr(e) {
    return function (e, t) {
      Ae().__VUE__ = !0;
      const {
          insert: n,
          remove: r,
          patchProp: i,
          createElement: s,
          createText: o,
          createComment: a,
          setText: l,
          setElementText: c,
          parentNode: u,
          nextSibling: d,
          setScopeId: h = Q,
          insertStaticContent: f
        } = e,
        p = function (e, t, n) {
          let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
            i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
            s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
            o = arguments.length > 6 && void 0 !== arguments[6] && arguments[6],
            a = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null,
            l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : !!t.dynamicChildren;
          if (e === t) return;
          e && !Kr(e, t) && (r = j(e), $(e, i, s, !0), e = null), -2 === t.patchFlag && (l = !1, t.dynamicChildren = null);
          const {
            type: c,
            ref: u,
            shapeFlag: d
          } = t;
          switch (c) {
            case Yr:
              m(e, t, n, r);
              break;
            case zr:
              g(e, t, n, r);
              break;
            case jr:
              null == e && v(t, n, r, o);
              break;
            case Ur:
              C(e, t, n, r, i, s, o, a, l);
              break;
            default:
              1 & d ? _(e, t, n, r, i, s, o, a, l) : 6 & d ? M(e, t, n, r, i, s, o, a, l) : (64 & d || 128 & d) && c.process(e, t, n, r, i, s, o, a, l, H);
          }
          null != u && i && Ar(u, e && e.ref, s, t || e, !t);
        },
        m = (e, t, r, i) => {
          if (null == e) n(t.el = o(t.children), r, i);else {
            const n = t.el = e.el;
            t.children !== e.children && l(n, t.children);
          }
        },
        g = (e, t, r, i) => {
          null == e ? n(t.el = a(t.children || ""), r, i) : t.el = e.el;
        },
        v = (e, t, n, r) => {
          [e.el, e.anchor] = f(e.children, t, n, r, e.el, e.anchor);
        },
        y = (e, t, r) => {
          let i,
            {
              el: s,
              anchor: o
            } = e;
          for (; s && s !== o;) i = d(s), n(s, t, r), s = i;
          n(o, t, r);
        },
        _ = (e, t, n, r, i, s, o, a, l) => {
          o = o || "svg" === t.type, null == e ? w(t, n, r, i, s, o, a, l) : x(e, t, i, s, o, a, l);
        },
        w = (e, t, r, o, a, l, u, d) => {
          let h, f;
          const {
            type: p,
            props: m,
            shapeFlag: g,
            transition: v,
            dirs: y
          } = e;
          if (h = e.el = s(e.type, l, m && m.is, m), 8 & g ? c(h, e.children) : 16 & g && b(e.children, h, null, o, a, l && "foreignObject" !== p, u, d), y && er(e, null, o, "created"), k(h, e, e.scopeId, u, o), m) {
            for (const t in m) "value" === t || _e(t) || i(h, t, null, m[t], l, e.children, o, a, z);
            "value" in m && i(h, "value", null, m.value), (f = m.onVnodeBeforeMount) && ci(f, o, e);
          }
          y && er(e, null, o, "beforeMount");
          const _ = (!a || a && !a.pendingBranch) && v && !v.persisted;
          _ && v.beforeEnter(h), n(h, t, r), ((f = m && m.onVnodeMounted) || _ || y) && Lr(() => {
            f && ci(f, o, e), _ && v.enter(h), y && er(e, null, o, "mounted");
          }, a);
        },
        k = (e, t, n, r, i) => {
          if (n && h(e, n), r) for (let t = 0; t < r.length; t++) h(e, r[t]);
          if (i && t === i.subTree) {
            const t = i.vnode;
            k(e, t, t.scopeId, t.slotScopeIds, i.parent);
          }
        },
        b = function (e, t, n, r, i, s, o, a) {
          for (let l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0; l < e.length; l++) {
            const c = e[l] = a ? ai(e[l]) : oi(e[l]);
            p(null, c, t, n, r, i, s, o, a);
          }
        },
        x = (e, t, n, r, s, o, a) => {
          const l = t.el = e.el;
          let {
            patchFlag: u,
            dynamicChildren: d,
            dirs: h
          } = t;
          u |= 16 & e.patchFlag;
          const f = e.props || q,
            p = t.props || q;
          let m;
          n && Ir(n, !1), (m = p.onVnodeBeforeUpdate) && ci(m, n, t, e), h && er(t, e, n, "beforeUpdate"), n && Ir(n, !0);
          const g = s && "foreignObject" !== t.type;
          if (d ? S(e.dynamicChildren, d, l, n, r, g, o) : a || A(e, t, l, null, n, r, g, o, !1), u > 0) {
            if (16 & u) T(l, t, f, p, n, r, s);else if (2 & u && f.class !== p.class && i(l, "class", null, p.class, s), 4 & u && i(l, "style", f.style, p.style, s), 8 & u) {
              const o = t.dynamicProps;
              for (let t = 0; t < o.length; t++) {
                const a = o[t],
                  c = f[a],
                  u = p[a];
                u === c && "value" !== a || i(l, a, c, u, s, e.children, n, r, z);
              }
            }
            1 & u && e.children !== t.children && c(l, t.children);
          } else a || null != d || T(l, t, f, p, n, r, s);
          ((m = p.onVnodeUpdated) || h) && Lr(() => {
            m && ci(m, n, t, e), h && er(t, e, n, "updated");
          }, r);
        },
        S = (e, t, n, r, i, s, o) => {
          for (let a = 0; a < t.length; a++) {
            const l = e[a],
              c = t[a],
              d = l.el && (l.type === Ur || !Kr(l, c) || 70 & l.shapeFlag) ? u(l.el) : n;
            p(l, c, d, null, r, i, s, o, !0);
          }
        },
        T = (e, t, n, r, s, o, a) => {
          if (n !== r) {
            if (n !== q) for (const l in n) _e(l) || l in r || i(e, l, n[l], null, a, t.children, s, o, z);
            for (const l in r) {
              if (_e(l)) continue;
              const c = r[l],
                u = n[l];
              c !== u && "value" !== l && i(e, l, u, c, a, t.children, s, o, z);
            }
            "value" in r && i(e, "value", n.value, r.value);
          }
        },
        C = (e, t, r, i, s, a, l, c, u) => {
          const d = t.el = e ? e.el : o(""),
            h = t.anchor = e ? e.anchor : o("");
          let {
            patchFlag: f,
            dynamicChildren: p,
            slotScopeIds: m
          } = t;
          m && (c = c ? c.concat(m) : m), null == e ? (n(d, r, i), n(h, r, i), b(t.children, r, h, s, a, l, c, u)) : f > 0 && 64 & f && p && e.dynamicChildren ? (S(e.dynamicChildren, p, r, s, a, l, c), (null != t.key || s && t === s.subTree) && $r(e, t, !0)) : A(e, t, r, h, s, a, l, c, u);
        },
        M = (e, t, n, r, i, s, o, a, l) => {
          t.slotScopeIds = a, null == e ? 512 & t.shapeFlag ? i.ctx.activate(t, n, r, o, l) : O(t, n, r, i, s, o, l) : D(e, t, l);
        },
        O = (e, t, n, r, i, s, o) => {
          const a = e.component = function (e, t, n) {
            const r = e.type,
              i = (t ? t.appContext : e.appContext) || ui,
              s = {
                uid: di++,
                vnode: e,
                type: r,
                parent: t,
                appContext: i,
                root: null,
                next: null,
                subTree: null,
                effect: null,
                update: null,
                scope: new Ne(!0),
                render: null,
                proxy: null,
                exposed: null,
                exposeProxy: null,
                withProxy: null,
                provides: t ? t.provides : Object.create(i.provides),
                accessCache: null,
                renderCache: [],
                components: null,
                directives: null,
                propsOptions: vr(r, i),
                emitsOptions: Rn(r, i),
                emit: null,
                emitted: null,
                propsDefaults: q,
                inheritAttrs: r.inheritAttrs,
                ctx: q,
                data: q,
                props: q,
                attrs: q,
                slots: q,
                refs: q,
                setupState: q,
                setupContext: null,
                suspense: n,
                suspenseId: n ? n.pendingId : 0,
                asyncDep: null,
                asyncResolved: !1,
                isMounted: !1,
                isUnmounted: !1,
                isDeactivated: !1,
                bc: null,
                c: null,
                bm: null,
                m: null,
                bu: null,
                u: null,
                um: null,
                bum: null,
                da: null,
                a: null,
                rtg: null,
                rtc: null,
                ec: null,
                sp: null
              };
            return s.ctx = {
              _: s
            }, s.root = t ? t.root : s, s.emit = Dn.bind(null, s), e.ce && e.ce(s), s;
          }(e, r, i);
          if (qn(e) && (a.ctx.renderer = H), function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            yi = t;
            const {
                props: n,
                children: r
              } = e.vnode,
              i = gi(e);
            (function (e, t, n) {
              let r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
              const i = {},
                s = {};
              De(s, Xr, 1), e.propsDefaults = Object.create(null), mr(e, t, i, s);
              for (const t in e.propsOptions[0]) t in i || (i[t] = void 0);
              n ? e.props = r ? i : jt(i, !1, pt, Lt, $t) : e.type.props ? e.props = i : e.props = s, e.attrs = s;
            })(e, n, i, t), Mr(e, r);
            i && function (e, t) {
              const n = e.type;
              e.accessCache = Object.create(null), e.proxy = Gt(new Proxy(e.ctx, lr));
              const {
                setup: r
              } = n;
              if (r) {
                const n = e.setupContext = r.length > 1 ? function (e) {
                  let t;
                  return {
                    get attrs() {
                      return t || (t = function (e) {
                        return new Proxy(e.attrs, {
                          get: (t, n) => (Xe(e, 0, "$attrs"), t[n])
                        });
                      }(e));
                    },
                    slots: e.slots,
                    emit: e.emit,
                    expose: t => {
                      e.exposed = t || {};
                    }
                  };
                }(e) : null;
                pi(e), Qe();
                const i = cn(r, e, 0, [e.props, n]);
                if (Ke(), mi(), fe(i)) {
                  if (i.then(mi, mi), t) return i.then(n => {
                    _i(e, n, t);
                  }).catch(t => {
                    dn(t, e, 0);
                  });
                  e.asyncDep = i;
                } else _i(e, i, t);
              } else wi(e, t);
            }(e, t);
            yi = !1;
          }(a), a.asyncDep) {
            if (i && i.registerDep(a, R), !e.el) {
              const e = a.subTree = ni(zr);
              g(null, e, t, n);
            }
          } else R(a, e, t, n, i, s, o);
        },
        D = (e, t, n) => {
          const r = t.component = e.component;
          if (function (e, t, n) {
            const {
                props: r,
                children: i,
                component: s
              } = e,
              {
                props: o,
                children: a,
                patchFlag: l
              } = t,
              c = s.emitsOptions;
            if (t.dirs || t.transition) return !0;
            if (!(n && l >= 0)) return !(!i && !a || a && a.$stable) || r !== o && (r ? !o || Un(r, o, c) : !!o);
            if (1024 & l) return !0;
            if (16 & l) return r ? Un(r, o, c) : !!o;
            if (8 & l) {
              const e = t.dynamicProps;
              for (let t = 0; t < e.length; t++) {
                const n = e[t];
                if (o[n] !== r[n] && !En(c, n)) return !0;
              }
            }
            return !1;
          }(e, t, n)) {
            if (r.asyncDep && !r.asyncResolved) return void E(r, t, n);
            r.next = t, function (e) {
              const t = pn.indexOf(e);
              t > mn && pn.splice(t, 1);
            }(r.update), r.update();
          } else t.el = e.el, r.vnode = t;
        },
        R = (e, t, n, r, i, s, o) => {
          const a = e.effect = new Be(() => {
              if (e.isMounted) {
                let t,
                  {
                    next: n,
                    bu: r,
                    u: a,
                    parent: l,
                    vnode: c
                  } = e,
                  d = n;
                Ir(e, !1), n ? (n.el = c.el, E(e, n, o)) : n = c, r && Oe(r), (t = n.props && n.props.onVnodeBeforeUpdate) && ci(t, l, n, c), Ir(e, !0);
                const h = In(e),
                  f = e.subTree;
                e.subTree = h, p(f, h, u(f.el), j(f), e, i, s), n.el = h.el, null === d && function (e, t) {
                  let {
                    vnode: n,
                    parent: r
                  } = e;
                  for (; r && r.subTree === n;) (n = r.vnode).el = t, r = r.parent;
                }(e, h.el), a && Lr(a, i), (t = n.props && n.props.onVnodeUpdated) && Lr(() => ci(t, l, n, c), i);
              } else {
                let o;
                const {
                    el: a,
                    props: l
                  } = t,
                  {
                    bm: c,
                    m: u,
                    parent: d
                  } = e,
                  h = Gn(t);
                if (Ir(e, !1), c && Oe(c), !h && (o = l && l.onVnodeBeforeMount) && ci(o, d, t), Ir(e, !0), a && V) {
                  const n = () => {
                    e.subTree = In(e), V(a, e.subTree, e, i, null);
                  };
                  h ? t.type.__asyncLoader().then(() => !e.isUnmounted && n()) : n();
                } else {
                  const o = e.subTree = In(e);
                  p(null, o, n, r, e, i, s), t.el = o.el;
                }
                if (u && Lr(u, i), !h && (o = l && l.onVnodeMounted)) {
                  const e = t;
                  Lr(() => ci(o, d, e), i);
                }
                (256 & t.shapeFlag || d && Gn(d.vnode) && 256 & d.vnode.shapeFlag) && e.a && Lr(e.a, i), e.isMounted = !0, t = n = r = null;
              }
            }, () => bn(l), e.scope),
            l = e.update = () => a.run();
          l.id = e.uid, Ir(e, !0), l();
        },
        E = (e, t, n) => {
          t.component = e;
          const r = e.vnode.props;
          e.vnode = t, e.next = null, function (e, t, n, r) {
            const {
                props: i,
                attrs: s,
                vnode: {
                  patchFlag: o
                }
              } = e,
              a = Bt(i),
              [l] = e.propsOptions;
            let c = !1;
            if (!(r || o > 0) || 16 & o) {
              let r;
              mr(e, t, i, s) && (c = !0);
              for (const s in a) t && (ie(t, s) || (r = Se(s)) !== s && ie(t, r)) || (l ? !n || void 0 === n[s] && void 0 === n[r] || (i[s] = gr(l, a, s, void 0, e, !0)) : delete i[s]);
              if (s !== a) for (const e in s) t && ie(t, e) || (delete s[e], c = !0);
            } else if (8 & o) {
              const n = e.vnode.dynamicProps;
              for (let r = 0; r < n.length; r++) {
                let o = n[r];
                if (En(e.emitsOptions, o)) continue;
                const u = t[o];
                if (l) {
                  if (ie(s, o)) u !== s[o] && (s[o] = u, c = !0);else {
                    const t = be(o);
                    i[t] = gr(l, a, t, u, e, !1);
                  }
                } else u !== s[o] && (s[o] = u, c = !0);
              }
            }
            c && et(e, "set", "$attrs");
          }(e, t.props, r, n), Or(e, t.children, n), Qe(), Sn(), Ke();
        },
        A = function (e, t, n, r, i, s, o, a) {
          let l = arguments.length > 8 && void 0 !== arguments[8] && arguments[8];
          const u = e && e.children,
            d = e ? e.shapeFlag : 0,
            h = t.children,
            {
              patchFlag: f,
              shapeFlag: p
            } = t;
          if (f > 0) {
            if (128 & f) return void N(u, h, n, r, i, s, o, a, l);
            if (256 & f) return void L(u, h, n, r, i, s, o, a, l);
          }
          8 & p ? (16 & d && z(u, i, s), h !== u && c(n, h)) : 16 & d ? 16 & p ? N(u, h, n, r, i, s, o, a, l) : z(u, i, s, !0) : (8 & d && c(n, ""), 16 & p && b(h, n, r, i, s, o, a, l));
        },
        L = (e, t, n, r, i, s, o, a, l) => {
          t = t || Z;
          const c = (e = e || Z).length,
            u = t.length,
            d = Math.min(c, u);
          let h;
          for (h = 0; h < d; h++) {
            const r = t[h] = l ? ai(t[h]) : oi(t[h]);
            p(e[h], r, n, null, i, s, o, a, l);
          }
          c > u ? z(e, i, s, !0, !1, d) : b(t, n, r, i, s, o, a, l, d);
        },
        N = (e, t, n, r, i, s, o, a, l) => {
          let c = 0;
          const u = t.length;
          let d = e.length - 1,
            h = u - 1;
          for (; c <= d && c <= h;) {
            const r = e[c],
              u = t[c] = l ? ai(t[c]) : oi(t[c]);
            if (!Kr(r, u)) break;
            p(r, u, n, null, i, s, o, a, l), c++;
          }
          for (; c <= d && c <= h;) {
            const r = e[d],
              c = t[h] = l ? ai(t[h]) : oi(t[h]);
            if (!Kr(r, c)) break;
            p(r, c, n, null, i, s, o, a, l), d--, h--;
          }
          if (c > d) {
            if (c <= h) {
              const e = h + 1,
                d = e < u ? t[e].el : r;
              for (; c <= h;) p(null, t[c] = l ? ai(t[c]) : oi(t[c]), n, d, i, s, o, a, l), c++;
            }
          } else if (c > h) for (; c <= d;) $(e[c], i, s, !0), c++;else {
            const f = c,
              m = c,
              g = new Map();
            for (c = m; c <= h; c++) {
              const e = t[c] = l ? ai(t[c]) : oi(t[c]);
              null != e.key && g.set(e.key, c);
            }
            let v,
              y = 0;
            const _ = h - m + 1;
            let w = !1,
              k = 0;
            const b = new Array(_);
            for (c = 0; c < _; c++) b[c] = 0;
            for (c = f; c <= d; c++) {
              const r = e[c];
              if (y >= _) {
                $(r, i, s, !0);
                continue;
              }
              let u;
              if (null != r.key) u = g.get(r.key);else for (v = m; v <= h; v++) if (0 === b[v - m] && Kr(r, t[v])) {
                u = v;
                break;
              }
              void 0 === u ? $(r, i, s, !0) : (b[u - m] = c + 1, u >= k ? k = u : w = !0, p(r, t[u], n, null, i, s, o, a, l), y++);
            }
            const x = w ? function (e) {
              const t = e.slice(),
                n = [0];
              let r, i, s, o, a;
              const l = e.length;
              for (r = 0; r < l; r++) {
                const l = e[r];
                if (0 !== l) {
                  if (i = n[n.length - 1], e[i] < l) {
                    t[r] = i, n.push(r);
                    continue;
                  }
                  for (s = 0, o = n.length - 1; s < o;) a = s + o >> 1, e[n[a]] < l ? s = a + 1 : o = a;
                  l < e[n[s]] && (s > 0 && (t[r] = n[s - 1]), n[s] = r);
                }
              }
              for (s = n.length, o = n[s - 1]; s-- > 0;) n[s] = o, o = t[o];
              return n;
            }(b) : Z;
            for (v = x.length - 1, c = _ - 1; c >= 0; c--) {
              const e = m + c,
                d = t[e],
                h = e + 1 < u ? t[e + 1].el : r;
              0 === b[c] ? p(null, d, n, h, i, s, o, a, l) : w && (v < 0 || c !== x[v] ? I(d, n, h, 2) : v--);
            }
          }
        },
        I = function (e, t, r, i) {
          let s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
          const {
            el: o,
            type: a,
            transition: l,
            children: c,
            shapeFlag: u
          } = e;
          if (6 & u) I(e.component.subTree, t, r, i);else if (128 & u) e.suspense.move(t, r, i);else if (64 & u) a.move(e, t, r, H);else if (a !== Ur) {
            if (a !== jr) {
              if (2 !== i && 1 & u && l) {
                if (0 === i) l.beforeEnter(o), n(o, t, r), Lr(() => l.enter(o), s);else {
                  const {
                      leave: e,
                      delayLeave: i,
                      afterLeave: s
                    } = l,
                    a = () => n(o, t, r),
                    c = () => {
                      e(o, () => {
                        a(), s && s();
                      });
                    };
                  i ? i(o, a, c) : c();
                }
              } else n(o, t, r);
            } else y(e, t, r);
          } else {
            n(o, t, r);
            for (let e = 0; e < c.length; e++) I(c[e], t, r, i);
            n(e.anchor, t, r);
          }
        },
        $ = function (e, t, n) {
          let r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
          const {
            type: s,
            props: o,
            ref: a,
            children: l,
            dynamicChildren: c,
            shapeFlag: u,
            patchFlag: d,
            dirs: h
          } = e;
          if (null != a && Ar(a, null, n, e, !0), 256 & u) return void t.ctx.deactivate(e);
          const f = 1 & u && h,
            p = !Gn(e);
          let m;
          if (p && (m = o && o.onVnodeBeforeUnmount) && ci(m, t, e), 6 & u) Y(e.component, n, r);else {
            if (128 & u) return void e.suspense.unmount(n, r);
            f && er(e, null, t, "beforeUnmount"), 64 & u ? e.type.remove(e, t, n, i, H, r) : c && (s !== Ur || d > 0 && 64 & d) ? z(c, t, n, !1, !0) : (s === Ur && 384 & d || !i && 16 & u) && z(l, t, n), r && P(e);
          }
          (p && (m = o && o.onVnodeUnmounted) || f) && Lr(() => {
            m && ci(m, t, e), f && er(e, null, t, "unmounted");
          }, n);
        },
        P = e => {
          const {
            type: t,
            el: n,
            anchor: i,
            transition: s
          } = e;
          if (t === Ur) return void U(n, i);
          if (t === jr) return void (e => {
            let t,
              {
                el: n,
                anchor: i
              } = e;
            for (; n && n !== i;) t = d(n), r(n), n = t;
            r(i);
          })(e);
          const o = () => {
            r(n), s && !s.persisted && s.afterLeave && s.afterLeave();
          };
          if (1 & e.shapeFlag && s && !s.persisted) {
            const {
                leave: t,
                delayLeave: r
              } = s,
              i = () => t(n, o);
            r ? r(e.el, o, i) : i();
          } else o();
        },
        U = (e, t) => {
          let n;
          for (; e !== t;) n = d(e), r(e), e = n;
          r(t);
        },
        Y = (e, t, n) => {
          const {
            bum: r,
            scope: i,
            update: s,
            subTree: o,
            um: a
          } = e;
          r && Oe(r), i.stop(), s && (s.active = !1, $(o, e, t, n)), a && Lr(a, t), Lr(() => {
            e.isUnmounted = !0;
          }, t), t && t.pendingBranch && !t.isUnmounted && e.asyncDep && !e.asyncResolved && e.suspenseId === t.pendingId && (t.deps--, 0 === t.deps && t.resolve());
        },
        z = function (e, t, n) {
          let r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
          for (let s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0; s < e.length; s++) $(e[s], t, n, r, i);
        },
        j = e => 6 & e.shapeFlag ? j(e.component.subTree) : 128 & e.shapeFlag ? e.suspense.next() : d(e.anchor || e.el),
        F = (e, t, n) => {
          null == e ? t._vnode && $(t._vnode, null, null, !0) : p(t._vnode || null, e, t, null, null, null, n), Sn(), Tn(), t._vnode = e;
        },
        H = {
          p: p,
          um: $,
          m: I,
          r: P,
          mt: O,
          mc: b,
          pc: A,
          pbc: S,
          n: j,
          o: e
        };
      let W, V;
      return {
        render: F,
        hydrate: W,
        createApp: Er(F, W)
      };
    }(e);
  }
  function Ir(e, t) {
    let {
      effect: n,
      update: r
    } = e;
    n.allowRecurse = r.allowRecurse = t;
  }
  function $r(e, t) {
    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    const r = e.children,
      i = t.children;
    if (se(r) && se(i)) for (let e = 0; e < r.length; e++) {
      const t = r[e];
      let s = i[e];
      1 & s.shapeFlag && !s.dynamicChildren && ((s.patchFlag <= 0 || 32 === s.patchFlag) && (s = i[e] = ai(i[e]), s.el = t.el), n || $r(t, s)), s.type === Yr && (s.el = t.el);
    }
  }
  const Pr = e => e.__isTeleport,
    Ur = Symbol(void 0),
    Yr = Symbol(void 0),
    zr = Symbol(void 0),
    jr = Symbol(void 0),
    Fr = [];
  let Hr = null;
  function Wr() {
    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
    Fr.push(Hr = e ? null : []);
  }
  let Vr = 1;
  function Br(e) {
    Vr += e;
  }
  function Gr(e) {
    return e.dynamicChildren = Vr > 0 ? Hr || Z : null, Fr.pop(), Hr = Fr[Fr.length - 1] || null, Vr > 0 && Hr && Hr.push(e), e;
  }
  function qr(e, t, n, r, i, s) {
    return Gr(ti(e, t, n, r, i, s, !0));
  }
  function Zr(e, t, n, r, i) {
    return Gr(ni(e, t, n, r, i, !0));
  }
  function Qr(e) {
    return !!e && !0 === e.__v_isVNode;
  }
  function Kr(e, t) {
    return e.type === t.type && e.key === t.key;
  }
  const Xr = "__vInternal",
    Jr = e => {
      let {
        key: t
      } = e;
      return null != t ? t : null;
    },
    ei = e => {
      let {
        ref: t,
        ref_key: n,
        ref_for: r
      } = e;
      return null != t ? ue(t) || Xt(t) || ce(t) ? {
        i: An,
        r: t,
        k: n,
        f: !!r
      } : t : null;
    };
  function ti(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
      i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
      s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : e === Ur ? 0 : 1,
      o = arguments.length > 6 && void 0 !== arguments[6] && arguments[6],
      a = arguments.length > 7 && void 0 !== arguments[7] && arguments[7];
    const l = {
      __v_isVNode: !0,
      __v_skip: !0,
      type: e,
      props: t,
      key: t && Jr(t),
      ref: t && ei(t),
      scopeId: Ln,
      slotScopeIds: null,
      children: n,
      component: null,
      suspense: null,
      ssContent: null,
      ssFallback: null,
      dirs: null,
      transition: null,
      el: null,
      anchor: null,
      target: null,
      targetAnchor: null,
      staticCount: 0,
      shapeFlag: s,
      patchFlag: r,
      dynamicProps: i,
      dynamicChildren: null,
      appContext: null,
      ctx: An
    };
    return a ? (li(l, n), 128 & s && e.normalize(l)) : n && (l.shapeFlag |= ue(n) ? 8 : 16), Vr > 0 && !o && Hr && (l.patchFlag > 0 || 6 & s) && 32 !== l.patchFlag && Hr.push(l), l;
  }
  const ni = function (e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
      i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
      s = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
    if (e && e !== nr || (e = zr), Qr(e)) {
      const r = ri(e, t, !0);
      return n && li(r, n), Vr > 0 && !s && Hr && (6 & r.shapeFlag ? Hr[Hr.indexOf(e)] = r : Hr.push(r)), r.patchFlag |= -2, r;
    }
    var o;
    if (ce(o = e) && "__vccOpts" in o && (e = e.__vccOpts), t) {
      t = function (e) {
        return e ? Vt(e) || Xr in e ? te({}, e) : e : null;
      }(t);
      let {
        class: e,
        style: n
      } = t;
      e && !ue(e) && (t.class = j(e)), he(n) && (Vt(n) && !se(n) && (n = te({}, n)), t.style = $(n));
    }
    return ti(e, t, n, r, i, ue(e) ? 1 : Yn(e) ? 128 : Pr(e) ? 64 : he(e) ? 4 : ce(e) ? 2 : 0, s, !0);
  };
  function ri(e, t) {
    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    const {
        props: r,
        ref: i,
        patchFlag: s,
        children: o
      } = e,
      a = t ? function () {
        const e = {};
        for (let t = 0; t < arguments.length; t++) {
          const n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
          for (const t in n) if ("class" === t) e.class !== n.class && (e.class = j([e.class, n.class]));else if ("style" === t) e.style = $([e.style, n.style]);else if (J(t)) {
            const r = e[t],
              i = n[t];
            !i || r === i || se(r) && r.includes(i) || (e[t] = r ? [].concat(r, i) : i);
          } else "" !== t && (e[t] = n[t]);
        }
        return e;
      }(r || {}, t) : r;
    return {
      __v_isVNode: !0,
      __v_skip: !0,
      type: e.type,
      props: a,
      key: a && Jr(a),
      ref: t && t.ref ? n && i ? se(i) ? i.concat(ei(t)) : [i, ei(t)] : ei(t) : i,
      scopeId: e.scopeId,
      slotScopeIds: e.slotScopeIds,
      children: o,
      target: e.target,
      targetAnchor: e.targetAnchor,
      staticCount: e.staticCount,
      shapeFlag: e.shapeFlag,
      patchFlag: t && e.type !== Ur ? -1 === s ? 16 : 16 | s : s,
      dynamicProps: e.dynamicProps,
      dynamicChildren: e.dynamicChildren,
      appContext: e.appContext,
      dirs: e.dirs,
      transition: e.transition,
      component: e.component,
      suspense: e.suspense,
      ssContent: e.ssContent && ri(e.ssContent),
      ssFallback: e.ssFallback && ri(e.ssFallback),
      el: e.el,
      anchor: e.anchor,
      ctx: e.ctx,
      ce: e.ce
    };
  }
  function ii() {
    return ni(Yr, null, arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : " ", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0);
  }
  function si() {
    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? (Wr(), Zr(zr, null, e)) : ni(zr, null, e);
  }
  function oi(e) {
    return null == e || "boolean" == typeof e ? ni(zr) : se(e) ? ni(Ur, null, e.slice()) : "object" == typeof e ? ai(e) : ni(Yr, null, String(e));
  }
  function ai(e) {
    return null === e.el && -1 !== e.patchFlag || e.memo ? e : ri(e);
  }
  function li(e, t) {
    let n = 0;
    const {
      shapeFlag: r
    } = e;
    if (null == t) t = null;else if (se(t)) n = 16;else if ("object" == typeof t) {
      if (65 & r) {
        const n = t.default;
        return void (n && (n._c && (n._d = !1), li(e, n()), n._c && (n._d = !0)));
      }
      {
        n = 32;
        const r = t._;
        r || Xr in t ? 3 === r && An && (1 === An.slots._ ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024)) : t._ctx = An;
      }
    } else ce(t) ? (t = {
      default: t,
      _ctx: An
    }, n = 32) : (t = String(t), 64 & r ? (n = 16, t = [ii(t)]) : n = 8);
    e.children = t, e.shapeFlag |= n;
  }
  function ci(e, t, n) {
    un(e, t, 7, [n, arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null]);
  }
  const ui = Dr();
  let di = 0,
    hi = null;
  const fi = () => hi || An,
    pi = e => {
      hi = e, e.scope.on();
    },
    mi = () => {
      hi && hi.scope.off(), hi = null;
    };
  function gi(e) {
    return 4 & e.vnode.shapeFlag;
  }
  let vi,
    yi = !1;
  function _i(e, t, n) {
    ce(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : he(t) && (e.setupState = on(t)), wi(e, n);
  }
  function wi(e, t, n) {
    const r = e.type;
    if (!e.render) {
      if (!t && vi && !r.render) {
        const t = r.template || function (e) {
          const t = e.type,
            {
              mixins: n,
              extends: r
            } = t,
            {
              mixins: i,
              optionsCache: s,
              config: {
                optionMergeStrategies: o
              }
            } = e.appContext,
            a = s.get(t);
          let l;
          return a ? l = a : i.length || n || r ? (l = {}, i.length && i.forEach(e => cr(l, e, o, !0)), cr(l, t, o)) : l = t, he(t) && s.set(t, l), l;
        }(e).template;
        if (t) {
          const {
              isCustomElement: n,
              compilerOptions: i
            } = e.appContext.config,
            {
              delimiters: s,
              compilerOptions: o
            } = r,
            a = te(te({
              isCustomElement: n,
              delimiters: s
            }, i), o);
          r.render = vi(t, a);
        }
      }
      e.render = r.render || Q;
    }
  }
  function ki(e) {
    if (e.exposed) return e.exposeProxy || (e.exposeProxy = new Proxy(on(Gt(e.exposed)), {
      get: (t, n) => n in t ? t[n] : n in or ? or[n](e) : void 0,
      has: (e, t) => t in e || t in or
    }));
  }
  const bi = (e, t) => function (e, t) {
    let n,
      r,
      i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    const s = ce(e);
    return s ? (n = e, r = Q) : (n = e.get, r = e.set), new ln(n, r, s || !r, i);
  }(e, t, yi);
  function xi(e, t, n) {
    const r = arguments.length;
    return 2 === r ? he(t) && !se(t) ? Qr(t) ? ni(e, null, [t]) : ni(e, t) : ni(e, null, t) : (r > 3 ? n = Array.prototype.slice.call(arguments, 2) : 3 === r && Qr(n) && (n = [n]), ni(e, t, n));
  }
  const Si = Symbol(""),
    Ti = () => zn(Si),
    Ci = "3.2.47",
    Mi = "undefined" != typeof document ? document : null,
    Oi = Mi && Mi.createElement("template"),
    Di = {
      insert: (e, t, n) => {
        t.insertBefore(e, n || null);
      },
      remove: e => {
        const t = e.parentNode;
        t && t.removeChild(e);
      },
      createElement: (e, t, n, r) => {
        const i = t ? Mi.createElementNS("http://www.w3.org/2000/svg", e) : Mi.createElement(e, n ? {
          is: n
        } : void 0);
        return "select" === e && r && null != r.multiple && i.setAttribute("multiple", r.multiple), i;
      },
      createText: e => Mi.createTextNode(e),
      createComment: e => Mi.createComment(e),
      setText: (e, t) => {
        e.nodeValue = t;
      },
      setElementText: (e, t) => {
        e.textContent = t;
      },
      parentNode: e => e.parentNode,
      nextSibling: e => e.nextSibling,
      querySelector: e => Mi.querySelector(e),
      setScopeId(e, t) {
        e.setAttribute(t, "");
      },
      insertStaticContent(e, t, n, r, i, s) {
        const o = n ? n.previousSibling : t.lastChild;
        if (i && (i === s || i.nextSibling)) for (; t.insertBefore(i.cloneNode(!0), n), i !== s && (i = i.nextSibling););else {
          Oi.innerHTML = r ? `<svg>${e}</svg>` : e;
          const i = Oi.content;
          if (r) {
            const e = i.firstChild;
            for (; e.firstChild;) i.appendChild(e.firstChild);
            i.removeChild(e);
          }
          t.insertBefore(i, n);
        }
        return [o ? o.nextSibling : t.firstChild, n ? n.previousSibling : t.lastChild];
      }
    },
    Ri = /\s*!important$/;
  function Ei(e, t, n) {
    if (se(n)) n.forEach(n => Ei(e, t, n));else if (null == n && (n = ""), t.startsWith("--")) e.setProperty(t, n);else {
      const r = function (e, t) {
        const n = Li[t];
        if (n) return n;
        let r = be(t);
        if ("filter" !== r && r in e) return Li[t] = r;
        r = Te(r);
        for (let n = 0; n < Ai.length; n++) {
          const i = Ai[n] + r;
          if (i in e) return Li[t] = i;
        }
        return t;
      }(e, t);
      Ri.test(n) ? e.setProperty(Se(r), n.replace(Ri, ""), "important") : e[r] = n;
    }
  }
  const Ai = ["Webkit", "Moz", "ms"],
    Li = {},
    Ni = "http://www.w3.org/1999/xlink";
  function Ii(e, t, n, r) {
    e.addEventListener(t, n, r);
  }
  const $i = /(?:Once|Passive|Capture)$/;
  let Pi = 0;
  const Ui = Promise.resolve(),
    Yi = () => Pi || (Ui.then(() => Pi = 0), Pi = Date.now()),
    zi = /^on[a-z]/,
    ji = e => {
      const t = e.props["onUpdate:modelValue"] || !1;
      return se(t) ? e => Oe(t, e) : t;
    };
  function Fi(e) {
    e.target.composing = !0;
  }
  function Hi(e) {
    const t = e.target;
    t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
  }
  const Wi = {
      created(e, t, n) {
        let {
          modifiers: {
            lazy: r,
            trim: i,
            number: s
          }
        } = t;
        e._assign = ji(n);
        const o = s || n.props && "number" === n.props.type;
        Ii(e, r ? "change" : "input", t => {
          if (t.target.composing) return;
          let n = e.value;
          i && (n = n.trim()), o && (n = Re(n)), e._assign(n);
        }), i && Ii(e, "change", () => {
          e.value = e.value.trim();
        }), r || (Ii(e, "compositionstart", Fi), Ii(e, "compositionend", Hi), Ii(e, "change", Hi));
      },
      mounted(e, t) {
        let {
          value: n
        } = t;
        e.value = null == n ? "" : n;
      },
      beforeUpdate(e, t, n) {
        let {
          value: r,
          modifiers: {
            lazy: i,
            trim: s,
            number: o
          }
        } = t;
        if (e._assign = ji(n), e.composing) return;
        if (document.activeElement === e && "range" !== e.type) {
          if (i) return;
          if (s && e.value.trim() === r) return;
          if ((o || "number" === e.type) && Re(e.value) === r) return;
        }
        const a = null == r ? "" : r;
        e.value !== a && (e.value = a);
      }
    },
    Vi = {
      deep: !0,
      created(e, t, n) {
        e._assign = ji(n), Ii(e, "change", () => {
          const t = e._modelValue,
            n = Qi(e),
            r = e.checked,
            i = e._assign;
          if (se(t)) {
            const e = V(t, n),
              s = -1 !== e;
            if (r && !s) i(t.concat(n));else if (!r && s) {
              const n = [...t];
              n.splice(e, 1), i(n);
            }
          } else if (ae(t)) {
            const e = new Set(t);
            r ? e.add(n) : e.delete(n), i(e);
          } else i(Ki(e, r));
        });
      },
      mounted: Bi,
      beforeUpdate(e, t, n) {
        e._assign = ji(n), Bi(e, t, n);
      }
    };
  function Bi(e, t, n) {
    let {
      value: r,
      oldValue: i
    } = t;
    e._modelValue = r, se(r) ? e.checked = V(r, n.props.value) > -1 : ae(r) ? e.checked = r.has(n.props.value) : r !== i && (e.checked = W(r, Ki(e, !0)));
  }
  const Gi = {
      created(e, t, n) {
        let {
          value: r
        } = t;
        e.checked = W(r, n.props.value), e._assign = ji(n), Ii(e, "change", () => {
          e._assign(Qi(e));
        });
      },
      beforeUpdate(e, t, n) {
        let {
          value: r,
          oldValue: i
        } = t;
        e._assign = ji(n), r !== i && (e.checked = W(r, n.props.value));
      }
    },
    qi = {
      deep: !0,
      created(e, t, n) {
        let {
          value: r,
          modifiers: {
            number: i
          }
        } = t;
        const s = ae(r);
        Ii(e, "change", () => {
          const t = Array.prototype.filter.call(e.options, e => e.selected).map(e => i ? Re(Qi(e)) : Qi(e));
          e._assign(e.multiple ? s ? new Set(t) : t : t[0]);
        }), e._assign = ji(n);
      },
      mounted(e, t) {
        let {
          value: n
        } = t;
        Zi(e, n);
      },
      beforeUpdate(e, t, n) {
        e._assign = ji(n);
      },
      updated(e, t) {
        let {
          value: n
        } = t;
        Zi(e, n);
      }
    };
  function Zi(e, t) {
    const n = e.multiple;
    if (!n || se(t) || ae(t)) {
      for (let r = 0, i = e.options.length; r < i; r++) {
        const i = e.options[r],
          s = Qi(i);
        if (n) se(t) ? i.selected = V(t, s) > -1 : i.selected = t.has(s);else if (W(Qi(i), t)) return void (e.selectedIndex !== r && (e.selectedIndex = r));
      }
      n || -1 === e.selectedIndex || (e.selectedIndex = -1);
    }
  }
  function Qi(e) {
    return "_value" in e ? e._value : e.value;
  }
  function Ki(e, t) {
    const n = t ? "_trueValue" : "_falseValue";
    return n in e ? e[n] : t;
  }
  const Xi = {
    created(e, t, n) {
      Ji(e, t, n, null, "created");
    },
    mounted(e, t, n) {
      Ji(e, t, n, null, "mounted");
    },
    beforeUpdate(e, t, n, r) {
      Ji(e, t, n, r, "beforeUpdate");
    },
    updated(e, t, n, r) {
      Ji(e, t, n, r, "updated");
    }
  };
  function Ji(e, t, n, r, i) {
    const s = function (e, t) {
      switch (e) {
        case "SELECT":
          return qi;
        case "TEXTAREA":
          return Wi;
        default:
          switch (t) {
            case "checkbox":
              return Vi;
            case "radio":
              return Gi;
            default:
              return Wi;
          }
      }
    }(e.tagName, n.props && n.props.type)[i];
    s && s(e, t, n, r);
  }
  const es = {
    beforeMount(e, t, n) {
      let {
          value: r
        } = t,
        {
          transition: i
        } = n;
      e._vod = "none" === e.style.display ? "" : e.style.display, i && r ? i.beforeEnter(e) : ts(e, r);
    },
    mounted(e, t, n) {
      let {
          value: r
        } = t,
        {
          transition: i
        } = n;
      i && r && i.enter(e);
    },
    updated(e, t, n) {
      let {
          value: r,
          oldValue: i
        } = t,
        {
          transition: s
        } = n;
      !r != !i && (s ? r ? (s.beforeEnter(e), ts(e, !0), s.enter(e)) : s.leave(e, () => {
        ts(e, !1);
      }) : ts(e, r));
    },
    beforeUnmount(e, t) {
      let {
        value: n
      } = t;
      ts(e, n);
    }
  };
  function ts(e, t) {
    e.style.display = t ? e._vod : "none";
  }
  const ns = te({
    patchProp: function (e, t, n, r) {
      let i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
        s = arguments.length > 5 ? arguments[5] : void 0,
        o = arguments.length > 6 ? arguments[6] : void 0,
        a = arguments.length > 7 ? arguments[7] : void 0,
        l = arguments.length > 8 ? arguments[8] : void 0;
      "class" === t ? function (e, t, n) {
        const r = e._vtc;
        r && (t = (t ? [t, ...r] : [...r]).join(" ")), null == t ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
      }(e, r, i) : "style" === t ? function (e, t, n) {
        const r = e.style,
          i = ue(n);
        if (n && !i) {
          if (t && !ue(t)) for (const e in t) null == n[e] && Ei(r, e, "");
          for (const e in n) Ei(r, e, n[e]);
        } else {
          const s = r.display;
          i ? t !== n && (r.cssText = n) : t && e.removeAttribute("style"), "_vod" in e && (r.display = s);
        }
      }(e, n, r) : J(t) ? ee(t) || function (e, t, n, r) {
        let i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
        const s = e._vei || (e._vei = {}),
          o = s[t];
        if (r && o) o.value = r;else {
          const [n, a] = function (e) {
            let t;
            if ($i.test(e)) {
              let n;
              for (t = {}; n = e.match($i);) e = e.slice(0, e.length - n[0].length), t[n[0].toLowerCase()] = !0;
            }
            return [":" === e[2] ? e.slice(3) : Se(e.slice(2)), t];
          }(t);
          if (r) {
            const o = s[t] = function (e, t) {
              const n = e => {
                if (e._vts) {
                  if (e._vts <= n.attached) return;
                } else e._vts = Date.now();
                un(function (e, t) {
                  if (se(t)) {
                    const n = e.stopImmediatePropagation;
                    return e.stopImmediatePropagation = () => {
                      n.call(e), e._stopped = !0;
                    }, t.map(e => t => !t._stopped && e && e(t));
                  }
                  return t;
                }(e, n.value), t, 5, [e]);
              };
              return n.value = e, n.attached = Yi(), n;
            }(r, i);
            Ii(e, n, o, a);
          } else o && (function (e, t, n, r) {
            e.removeEventListener(t, n, r);
          }(e, n, o, a), s[t] = void 0);
        }
      }(e, t, n, r, o) : ("." === t[0] ? (t = t.slice(1), 1) : "^" === t[0] ? (t = t.slice(1), 0) : function (e, t, n, r) {
        return r ? "innerHTML" === t || "textContent" === t || !!(t in e && zi.test(t) && ce(n)) : "spellcheck" !== t && "draggable" !== t && "translate" !== t && "form" !== t && ("list" !== t || "INPUT" !== e.tagName) && ("type" !== t || "TEXTAREA" !== e.tagName) && (!zi.test(t) || !ue(n)) && t in e;
      }(e, t, r, i)) ? function (e, t, n, r, i, s, o) {
        if ("innerHTML" === t || "textContent" === t) return r && o(r, i, s), void (e[t] = null == n ? "" : n);
        if ("value" === t && "PROGRESS" !== e.tagName && !e.tagName.includes("-")) {
          e._value = n;
          const r = null == n ? "" : n;
          return e.value === r && "OPTION" !== e.tagName || (e.value = r), void (null == n && e.removeAttribute(t));
        }
        let a = !1;
        if ("" === n || null == n) {
          const r = typeof e[t];
          "boolean" === r ? n = H(n) : null == n && "string" === r ? (n = "", a = !0) : "number" === r && (n = 0, a = !0);
        }
        try {
          e[t] = n;
        } catch (e) {}
        a && e.removeAttribute(t);
      }(e, t, r, s, o, a, l) : ("true-value" === t ? e._trueValue = r : "false-value" === t && (e._falseValue = r), function (e, t, n, r, i) {
        if (r && t.startsWith("xlink:")) null == n ? e.removeAttributeNS(Ni, t.slice(6, t.length)) : e.setAttributeNS(Ni, t, n);else {
          const r = F(t);
          null == n || r && !H(n) ? e.removeAttribute(t) : e.setAttribute(t, r ? "" : n);
        }
      }(e, t, r, i));
    }
  }, Di);
  let rs;
  var is;
  const ss = "undefined" != typeof window,
    os = e => "function" == typeof e,
    as = e => "string" == typeof e,
    ls = () => {};
  function cs(e) {
    return "function" == typeof e ? e() : rn(e);
  }
  function us(e, t) {
    return function () {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
      return new Promise((n, i) => {
        Promise.resolve(e(() => t.apply(this, r), {
          fn: t,
          thisArg: this,
          args: r
        })).then(n).catch(i);
      });
    };
  }
  ss && (null == (is = null == window ? void 0 : window.navigator) ? void 0 : is.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
  const ds = e => e();
  function hs(e) {
    return !!Ie() && (function (e) {
      Le && Le.cleanups.push(e);
    }(e), !0);
  }
  var fs = Object.getOwnPropertySymbols,
    ps = Object.prototype.hasOwnProperty,
    ms = Object.prototype.propertyIsEnumerable,
    gs = (e, t) => {
      var n = {};
      for (var r in e) ps.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      if (null != e && fs) for (var r of fs(e)) t.indexOf(r) < 0 && ms.call(e, r) && (n[r] = e[r]);
      return n;
    },
    vs = Object.defineProperty,
    ys = Object.defineProperties,
    _s = Object.getOwnPropertyDescriptors,
    ws = Object.getOwnPropertySymbols,
    ks = Object.prototype.hasOwnProperty,
    bs = Object.prototype.propertyIsEnumerable,
    xs = (e, t, n) => t in e ? vs(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n,
    Ss = (e, t) => {
      for (var n in t || (t = {})) ks.call(t, n) && xs(e, n, t[n]);
      if (ws) for (var n of ws(t)) bs.call(t, n) && xs(e, n, t[n]);
      return e;
    },
    Ts = (e, t) => ys(e, _s(t)),
    Cs = (e, t) => {
      var n = {};
      for (var r in e) ks.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      if (null != e && ws) for (var r of ws(e)) t.indexOf(r) < 0 && bs.call(e, r) && (n[r] = e[r]);
      return n;
    };
  function Ms(e) {
    var t;
    const n = cs(e);
    return null != (t = null == n ? void 0 : n.$el) ? t : n;
  }
  const Os = ss ? window : void 0,
    Ds = ss ? window.document : void 0;
  function Rs() {
    let e, t, n, r;
    for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++) s[o] = arguments[o];
    if (as(s[0]) || Array.isArray(s[0]) ? ([t, n, r] = s, e = Os) : [e, t, n, r] = s, !e) return ls;
    Array.isArray(t) || (t = [t]), Array.isArray(n) || (n = [n]);
    const a = [],
      l = () => {
        a.forEach(e => e()), a.length = 0;
      },
      c = Hn(() => [Ms(e), cs(r)], e => {
        let [r, i] = e;
        l(), r && a.push(...t.flatMap(e => n.map(t => ((e, t, n, r) => (e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r)))(r, e, t, i))));
      }, {
        immediate: !0,
        flush: "post"
      }),
      u = () => {
        c(), l();
      };
    return hs(u), u;
  }
  ss && window.navigator, ss && window.location;
  const Es = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    As = "__vueuse_ssr_handlers__";
  Es[As] = Es[As] || {};
  const Ls = Es[As];
  var Ns = Object.defineProperty,
    Is = Object.getOwnPropertySymbols,
    $s = Object.prototype.hasOwnProperty,
    Ps = Object.prototype.propertyIsEnumerable,
    Us = (e, t, n) => t in e ? Ns(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n,
    Ys = (e, t) => {
      for (var n in t || (t = {})) $s.call(t, n) && Us(e, n, t[n]);
      if (Is) for (var n of Is(t)) Ps.call(t, n) && Us(e, n, t[n]);
      return e;
    };
  const zs = {
      boolean: {
        read: e => "true" === e,
        write: e => String(e)
      },
      object: {
        read: e => JSON.parse(e),
        write: e => JSON.stringify(e)
      },
      number: {
        read: e => Number.parseFloat(e),
        write: e => String(e)
      },
      any: {
        read: e => e,
        write: e => String(e)
      },
      string: {
        read: e => e,
        write: e => String(e)
      },
      map: {
        read: e => new Map(JSON.parse(e)),
        write: e => JSON.stringify(Array.from(e.entries()))
      },
      set: {
        read: e => new Set(JSON.parse(e)),
        write: e => JSON.stringify(Array.from(e))
      },
      date: {
        read: e => new Date(e),
        write: e => e.toISOString()
      }
    },
    js = "vueuse-storage";
  function Fs(e, t, n) {
    let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    var i;
    const {
        flush: s = "pre",
        deep: o = !0,
        listenToStorageChanges: a = !0,
        writeDefaults: l = !0,
        mergeDefaults: c = !1,
        shallow: u,
        window: d = Os,
        eventFilter: h,
        onError: f = e => {
          console.error(e);
        }
      } = r,
      p = (u ? en : Jt)(t);
    if (!n) try {
      n = (Ls.getDefaultStorage || (() => {
        var e;
        return null == (e = Os) ? void 0 : e.localStorage;
      }))();
    } catch (e) {
      f(e);
    }
    if (!n) return p;
    const m = cs(t),
      g = function (e) {
        return null == e ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : "boolean" == typeof e ? "boolean" : "string" == typeof e ? "string" : "object" == typeof e ? "object" : Number.isNaN(e) ? "any" : "number";
      }(m),
      v = null != (i = r.serializer) ? i : zs[g],
      {
        pause: y,
        resume: _
      } = function (e, t) {
        const n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          {
            eventFilter: r
          } = n,
          i = Cs(n, ["eventFilter"]),
          {
            eventFilter: s,
            pause: o,
            resume: a,
            isActive: l
          } = function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ds;
            const t = Jt(!0);
            return {
              isActive: zt(t),
              pause: function () {
                t.value = !1;
              },
              resume: function () {
                t.value = !0;
              },
              eventFilter: function () {
                t.value && e(...arguments);
              }
            };
          }(r),
          c = function (e, t) {
            const n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                eventFilter: r = ds
              } = n,
              i = gs(n, ["eventFilter"]);
            return Hn(e, us(r, t), i);
          }(e, t, Ts(Ss({}, i), {
            eventFilter: s
          }));
        return {
          stop: c,
          pause: o,
          resume: a,
          isActive: l
        };
      }(p, () => function (t) {
        try {
          if (null == t) n.removeItem(e);else {
            const r = v.write(t),
              i = n.getItem(e);
            i !== r && (n.setItem(e, r), d && d.dispatchEvent(new CustomEvent(js, {
              detail: {
                key: e,
                oldValue: i,
                newValue: r,
                storageArea: n
              }
            })));
          }
        } catch (e) {
          f(e);
        }
      }(p.value), {
        flush: s,
        deep: o,
        eventFilter: h
      });
    return d && a && (Rs(d, "storage", w), Rs(d, js, function (e) {
      w(e.detail);
    })), w(), p;
    function w(t) {
      if (!t || t.storageArea === n) if (t && null == t.key) p.value = m;else if (!t || t.key === e) {
        y();
        try {
          p.value = function (t) {
            const r = t ? t.newValue : n.getItem(e);
            if (null == r) return l && null !== m && n.setItem(e, v.write(m)), m;
            if (!t && c) {
              const e = v.read(r);
              return os(c) ? c(e, m) : "object" !== g || Array.isArray(e) ? e : Ys(Ys({}, m), e);
            }
            return "string" != typeof r ? r : v.read(r);
          }(t);
        } catch (e) {
          f(e);
        } finally {
          t ? kn(_) : _();
        }
      }
    }
  }
  var Hs,
    Ws,
    Vs = Object.defineProperty,
    Bs = Object.getOwnPropertySymbols,
    Gs = Object.prototype.hasOwnProperty,
    qs = Object.prototype.propertyIsEnumerable,
    Zs = (e, t, n) => t in e ? Vs(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n,
    Qs = (e, t) => {
      for (var n in t || (t = {})) Gs.call(t, n) && Zs(e, n, t[n]);
      if (Bs) for (var n of Bs(t)) qs.call(t, n) && Zs(e, n, t[n]);
      return e;
    };
  (Ws = Hs || (Hs = {})).UP = "UP", Ws.RIGHT = "RIGHT", Ws.DOWN = "DOWN", Ws.LEFT = "LEFT", Ws.NONE = "NONE";
  let Ks = 0;
  var Xs = Object.defineProperty,
    Js = Object.getOwnPropertySymbols,
    eo = Object.prototype.hasOwnProperty,
    to = Object.prototype.propertyIsEnumerable,
    no = (e, t, n) => t in e ? Xs(e, t, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: n
    }) : e[t] = n;
  ((e, t) => {
    for (var n in t || (t = {})) eo.call(t, n) && no(e, n, t[n]);
    if (Js) for (var n of Js(t)) to.call(t, n) && no(e, n, t[n]);
  })({
    linear: function (e) {
      return e;
    }
  }, {
    easeInSine: [.12, 0, .39, 0],
    easeOutSine: [.61, 1, .88, 1],
    easeInOutSine: [.37, 0, .63, 1],
    easeInQuad: [.11, 0, .5, 0],
    easeOutQuad: [.5, 1, .89, 1],
    easeInOutQuad: [.45, 0, .55, 1],
    easeInCubic: [.32, 0, .67, 0],
    easeOutCubic: [.33, 1, .68, 1],
    easeInOutCubic: [.65, 0, .35, 1],
    easeInQuart: [.5, 0, .75, 0],
    easeOutQuart: [.25, 1, .5, 1],
    easeInOutQuart: [.76, 0, .24, 1],
    easeInQuint: [.64, 0, .78, 0],
    easeOutQuint: [.22, 1, .36, 1],
    easeInOutQuint: [.83, 0, .17, 1],
    easeInExpo: [.7, 0, .84, 0],
    easeOutExpo: [.16, 1, .3, 1],
    easeInOutExpo: [.87, 0, .13, 1],
    easeInCirc: [.55, 0, 1, .45],
    easeOutCirc: [0, .55, .45, 1],
    easeInOutCirc: [.85, 0, .15, 1],
    easeInBack: [.36, 0, .66, -.56],
    easeOutBack: [.34, 1.56, .64, 1],
    easeInOutBack: [.68, -.6, .32, 1.6]
  });
  const ro = function (e) {
      let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "";
      return `${t ? `${t}/` : ""}${arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ""}${e}${n ? `.${n}` : ""}`;
    },
    io = e => {
      "AbortError" !== e.name && console.error(e.message);
    },
    so = e => e instanceof HTMLElement ? e : "string" == typeof e ? document.querySelector(e) : null,
    oo = e => e.type.includes("image"),
    ao = e => {
      const t = Array.from(e).find(oo);
      return t ? t.getAsFile() : null;
    };
  let lo = {
    async: !1,
    baseUrl: null,
    breaks: !1,
    extensions: null,
    gfm: !0,
    headerIds: !0,
    headerPrefix: "",
    highlight: null,
    langPrefix: "language-",
    mangle: !0,
    pedantic: !1,
    renderer: null,
    sanitize: !1,
    sanitizer: null,
    silent: !1,
    smartypants: !1,
    tokenizer: null,
    walkTokens: null,
    xhtml: !1
  };
  const co = /[&<>"']/,
    uo = new RegExp(co.source, "g"),
    ho = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    fo = new RegExp(ho.source, "g"),
    po = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    },
    mo = e => po[e];
  function go(e, t) {
    if (t) {
      if (co.test(e)) return e.replace(uo, mo);
    } else if (ho.test(e)) return e.replace(fo, mo);
    return e;
  }
  const vo = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
  function yo(e) {
    return e.replace(vo, (e, t) => "colon" === (t = t.toLowerCase()) ? ":" : "#" === t.charAt(0) ? "x" === t.charAt(1) ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : "");
  }
  const _o = /(^|[^\[])\^/g;
  function wo(e, t) {
    e = "string" == typeof e ? e : e.source, t = t || "";
    const n = {
      replace: (t, r) => (r = (r = r.source || r).replace(_o, "$1"), e = e.replace(t, r), n),
      getRegex: () => new RegExp(e, t)
    };
    return n;
  }
  const ko = /[^\w:]/g,
    bo = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
  function xo(e, t, n) {
    if (e) {
      let t;
      try {
        t = decodeURIComponent(yo(n)).replace(ko, "").toLowerCase();
      } catch (e) {
        return null;
      }
      if (0 === t.indexOf("javascript:") || 0 === t.indexOf("vbscript:") || 0 === t.indexOf("data:")) return null;
    }
    t && !bo.test(n) && (n = function (e, t) {
      So[" " + e] || (To.test(e) ? So[" " + e] = e + "/" : So[" " + e] = Eo(e, "/", !0));
      const n = -1 === (e = So[" " + e]).indexOf(":");
      return "//" === t.substring(0, 2) ? n ? t : e.replace(Co, "$1") + t : "/" === t.charAt(0) ? n ? t : e.replace(Mo, "$1") + t : e + t;
    }(t, n));
    try {
      n = encodeURI(n).replace(/%25/g, "%");
    } catch (e) {
      return null;
    }
    return n;
  }
  const So = {},
    To = /^[^:]+:\/*[^/]*$/,
    Co = /^([^:]+:)[\s\S]*$/,
    Mo = /^([^:]+:\/*[^/]*)[\s\S]*$/,
    Oo = {
      exec: function () {}
    };
  function Do(e) {
    let t,
      n,
      r = 1;
    for (; r < arguments.length; r++) for (n in t = arguments[r], t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    return e;
  }
  function Ro(e, t) {
    const n = e.replace(/\|/g, (e, t, n) => {
      let r = !1,
        i = t;
      for (; --i >= 0 && "\\" === n[i];) r = !r;
      return r ? "|" : " |";
    }).split(/ \|/);
    let r = 0;
    if (n[0].trim() || n.shift(), n.length > 0 && !n[n.length - 1].trim() && n.pop(), n.length > t) n.splice(t);else for (; n.length < t;) n.push("");
    for (; r < n.length; r++) n[r] = n[r].trim().replace(/\\\|/g, "|");
    return n;
  }
  function Eo(e, t, n) {
    const r = e.length;
    if (0 === r) return "";
    let i = 0;
    for (; i < r;) {
      const s = e.charAt(r - i - 1);
      if (s !== t || n) {
        if (s === t || !n) break;
        i++;
      } else i++;
    }
    return e.slice(0, r - i);
  }
  function Ao(e) {
    e && e.sanitize && !e.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
  }
  function Lo(e, t) {
    if (t < 1) return "";
    let n = "";
    for (; t > 1;) 1 & t && (n += e), t >>= 1, e += e;
    return n + e;
  }
  function No(e, t, n, r) {
    const i = t.href,
      s = t.title ? go(t.title) : null,
      o = e[1].replace(/\\([\[\]])/g, "$1");
    if ("!" !== e[0].charAt(0)) {
      r.state.inLink = !0;
      const e = {
        type: "link",
        raw: n,
        href: i,
        title: s,
        text: o,
        tokens: r.inlineTokens(o)
      };
      return r.state.inLink = !1, e;
    }
    return {
      type: "image",
      raw: n,
      href: i,
      title: s,
      text: go(o)
    };
  }
  class Io {
    constructor(e) {
      this.options = e || lo;
    }
    space(e) {
      const t = this.rules.block.newline.exec(e);
      if (t && t[0].length > 0) return {
        type: "space",
        raw: t[0]
      };
    }
    code(e) {
      const t = this.rules.block.code.exec(e);
      if (t) {
        const e = t[0].replace(/^ {1,4}/gm, "");
        return {
          type: "code",
          raw: t[0],
          codeBlockStyle: "indented",
          text: this.options.pedantic ? e : Eo(e, "\n")
        };
      }
    }
    fences(e) {
      const t = this.rules.block.fences.exec(e);
      if (t) {
        const e = t[0],
          n = function (e, t) {
            const n = e.match(/^(\s+)(?:```)/);
            if (null === n) return t;
            const r = n[1];
            return t.split("\n").map(e => {
              const t = e.match(/^\s+/);
              if (null === t) return e;
              const [n] = t;
              return n.length >= r.length ? e.slice(r.length) : e;
            }).join("\n");
          }(e, t[3] || "");
        return {
          type: "code",
          raw: e,
          lang: t[2] ? t[2].trim().replace(this.rules.inline._escapes, "$1") : t[2],
          text: n
        };
      }
    }
    heading(e) {
      const t = this.rules.block.heading.exec(e);
      if (t) {
        let e = t[2].trim();
        if (/#$/.test(e)) {
          const t = Eo(e, "#");
          this.options.pedantic ? e = t.trim() : t && !/ $/.test(t) || (e = t.trim());
        }
        return {
          type: "heading",
          raw: t[0],
          depth: t[1].length,
          text: e,
          tokens: this.lexer.inline(e)
        };
      }
    }
    hr(e) {
      const t = this.rules.block.hr.exec(e);
      if (t) return {
        type: "hr",
        raw: t[0]
      };
    }
    blockquote(e) {
      const t = this.rules.block.blockquote.exec(e);
      if (t) {
        const e = t[0].replace(/^ *>[ \t]?/gm, ""),
          n = this.lexer.state.top;
        this.lexer.state.top = !0;
        const r = this.lexer.blockTokens(e);
        return this.lexer.state.top = n, {
          type: "blockquote",
          raw: t[0],
          tokens: r,
          text: e
        };
      }
    }
    list(e) {
      let t = this.rules.block.list.exec(e);
      if (t) {
        let n,
          r,
          i,
          s,
          o,
          a,
          l,
          c,
          u,
          d,
          h,
          f,
          p = t[1].trim();
        const m = p.length > 1,
          g = {
            type: "list",
            raw: "",
            ordered: m,
            start: m ? +p.slice(0, -1) : "",
            loose: !1,
            items: []
          };
        p = m ? `\\d{1,9}\\${p.slice(-1)}` : `\\${p}`, this.options.pedantic && (p = m ? p : "[*+-]");
        const v = new RegExp(`^( {0,3}${p})((?:[\t ][^\\n]*)?(?:\\n|$))`);
        for (; e && (f = !1, t = v.exec(e)) && !this.rules.block.hr.test(e);) {
          if (n = t[0], e = e.substring(n.length), c = t[2].split("\n", 1)[0].replace(/^\t+/, e => " ".repeat(3 * e.length)), u = e.split("\n", 1)[0], this.options.pedantic ? (s = 2, h = c.trimLeft()) : (s = t[2].search(/[^ ]/), s = s > 4 ? 1 : s, h = c.slice(s), s += t[1].length), a = !1, !c && /^ *$/.test(u) && (n += u + "\n", e = e.substring(u.length + 1), f = !0), !f) {
            const t = new RegExp(`^ {0,${Math.min(3, s - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`),
              r = new RegExp(`^ {0,${Math.min(3, s - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
              i = new RegExp(`^ {0,${Math.min(3, s - 1)}}(?:\`\`\`|~~~)`),
              o = new RegExp(`^ {0,${Math.min(3, s - 1)}}#`);
            for (; e && (d = e.split("\n", 1)[0], u = d, this.options.pedantic && (u = u.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !i.test(u)) && !o.test(u) && !t.test(u) && !r.test(e);) {
              if (u.search(/[^ ]/) >= s || !u.trim()) h += "\n" + u.slice(s);else {
                if (a) break;
                if (c.search(/[^ ]/) >= 4) break;
                if (i.test(c)) break;
                if (o.test(c)) break;
                if (r.test(c)) break;
                h += "\n" + u;
              }
              a || u.trim() || (a = !0), n += d + "\n", e = e.substring(d.length + 1), c = u.slice(s);
            }
          }
          g.loose || (l ? g.loose = !0 : /\n *\n *$/.test(n) && (l = !0)), this.options.gfm && (r = /^\[[ xX]\] /.exec(h), r && (i = "[ ] " !== r[0], h = h.replace(/^\[[ xX]\] +/, ""))), g.items.push({
            type: "list_item",
            raw: n,
            task: !!r,
            checked: i,
            loose: !1,
            text: h
          }), g.raw += n;
        }
        g.items[g.items.length - 1].raw = n.trimRight(), g.items[g.items.length - 1].text = h.trimRight(), g.raw = g.raw.trimRight();
        const y = g.items.length;
        for (o = 0; o < y; o++) if (this.lexer.state.top = !1, g.items[o].tokens = this.lexer.blockTokens(g.items[o].text, []), !g.loose) {
          const e = g.items[o].tokens.filter(e => "space" === e.type),
            t = e.length > 0 && e.some(e => /\n.*\n/.test(e.raw));
          g.loose = t;
        }
        if (g.loose) for (o = 0; o < y; o++) g.items[o].loose = !0;
        return g;
      }
    }
    html(e) {
      const t = this.rules.block.html.exec(e);
      if (t) {
        const e = {
          type: "html",
          raw: t[0],
          pre: !this.options.sanitizer && ("pre" === t[1] || "script" === t[1] || "style" === t[1]),
          text: t[0]
        };
        if (this.options.sanitize) {
          const n = this.options.sanitizer ? this.options.sanitizer(t[0]) : go(t[0]);
          e.type = "paragraph", e.text = n, e.tokens = this.lexer.inline(n);
        }
        return e;
      }
    }
    def(e) {
      const t = this.rules.block.def.exec(e);
      if (t) {
        const e = t[1].toLowerCase().replace(/\s+/g, " "),
          n = t[2] ? t[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "",
          r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline._escapes, "$1") : t[3];
        return {
          type: "def",
          tag: e,
          raw: t[0],
          href: n,
          title: r
        };
      }
    }
    table(e) {
      const t = this.rules.block.table.exec(e);
      if (t) {
        const e = {
          type: "table",
          header: Ro(t[1]).map(e => ({
            text: e
          })),
          align: t[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
          rows: t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split("\n") : []
        };
        if (e.header.length === e.align.length) {
          e.raw = t[0];
          let n,
            r,
            i,
            s,
            o = e.align.length;
          for (n = 0; n < o; n++) /^ *-+: *$/.test(e.align[n]) ? e.align[n] = "right" : /^ *:-+: *$/.test(e.align[n]) ? e.align[n] = "center" : /^ *:-+ *$/.test(e.align[n]) ? e.align[n] = "left" : e.align[n] = null;
          for (o = e.rows.length, n = 0; n < o; n++) e.rows[n] = Ro(e.rows[n], e.header.length).map(e => ({
            text: e
          }));
          for (o = e.header.length, r = 0; r < o; r++) e.header[r].tokens = this.lexer.inline(e.header[r].text);
          for (o = e.rows.length, r = 0; r < o; r++) for (s = e.rows[r], i = 0; i < s.length; i++) s[i].tokens = this.lexer.inline(s[i].text);
          return e;
        }
      }
    }
    lheading(e) {
      const t = this.rules.block.lheading.exec(e);
      if (t) return {
        type: "heading",
        raw: t[0],
        depth: "=" === t[2].charAt(0) ? 1 : 2,
        text: t[1],
        tokens: this.lexer.inline(t[1])
      };
    }
    paragraph(e) {
      const t = this.rules.block.paragraph.exec(e);
      if (t) {
        const e = "\n" === t[1].charAt(t[1].length - 1) ? t[1].slice(0, -1) : t[1];
        return {
          type: "paragraph",
          raw: t[0],
          text: e,
          tokens: this.lexer.inline(e)
        };
      }
    }
    text(e) {
      const t = this.rules.block.text.exec(e);
      if (t) return {
        type: "text",
        raw: t[0],
        text: t[0],
        tokens: this.lexer.inline(t[0])
      };
    }
    escape(e) {
      const t = this.rules.inline.escape.exec(e);
      if (t) return {
        type: "escape",
        raw: t[0],
        text: go(t[1])
      };
    }
    tag(e) {
      const t = this.rules.inline.tag.exec(e);
      if (t) return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
        type: this.options.sanitize ? "text" : "html",
        raw: t[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(t[0]) : go(t[0]) : t[0]
      };
    }
    link(e) {
      const t = this.rules.inline.link.exec(e);
      if (t) {
        const e = t[2].trim();
        if (!this.options.pedantic && /^</.test(e)) {
          if (!/>$/.test(e)) return;
          const t = Eo(e.slice(0, -1), "\\");
          if ((e.length - t.length) % 2 == 0) return;
        } else {
          const e = function (e, t) {
            if (-1 === e.indexOf(t[1])) return -1;
            const n = e.length;
            let r = 0,
              i = 0;
            for (; i < n; i++) if ("\\" === e[i]) i++;else if (e[i] === t[0]) r++;else if (e[i] === t[1] && (r--, r < 0)) return i;
            return -1;
          }(t[2], "()");
          if (e > -1) {
            const n = (0 === t[0].indexOf("!") ? 5 : 4) + t[1].length + e;
            t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
          }
        }
        let n = t[2],
          r = "";
        if (this.options.pedantic) {
          const e = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(n);
          e && (n = e[1], r = e[3]);
        } else r = t[3] ? t[3].slice(1, -1) : "";
        return n = n.trim(), /^</.test(n) && (n = this.options.pedantic && !/>$/.test(e) ? n.slice(1) : n.slice(1, -1)), No(t, {
          href: n ? n.replace(this.rules.inline._escapes, "$1") : n,
          title: r ? r.replace(this.rules.inline._escapes, "$1") : r
        }, t[0], this.lexer);
      }
    }
    reflink(e, t) {
      let n;
      if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
        let e = (n[2] || n[1]).replace(/\s+/g, " ");
        if (e = t[e.toLowerCase()], !e) {
          const e = n[0].charAt(0);
          return {
            type: "text",
            raw: e,
            text: e
          };
        }
        return No(n, e, n[0], this.lexer);
      }
    }
    emStrong(e, t) {
      let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
        r = this.rules.inline.emStrong.lDelim.exec(e);
      if (!r) return;
      if (r[3] && n.match(/[\p{L}\p{N}]/u)) return;
      const i = r[1] || r[2] || "";
      if (!i || i && ("" === n || this.rules.inline.punctuation.exec(n))) {
        const n = r[0].length - 1;
        let i,
          s,
          o = n,
          a = 0;
        const l = "*" === r[0][0] ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
        for (l.lastIndex = 0, t = t.slice(-1 * e.length + n); null != (r = l.exec(t));) {
          if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
          if (s = i.length, r[3] || r[4]) {
            o += s;
            continue;
          }
          if ((r[5] || r[6]) && n % 3 && !((n + s) % 3)) {
            a += s;
            continue;
          }
          if (o -= s, o > 0) continue;
          s = Math.min(s, s + o + a);
          const t = e.slice(0, n + r.index + (r[0].length - i.length) + s);
          if (Math.min(n, s) % 2) {
            const e = t.slice(1, -1);
            return {
              type: "em",
              raw: t,
              text: e,
              tokens: this.lexer.inlineTokens(e)
            };
          }
          const l = t.slice(2, -2);
          return {
            type: "strong",
            raw: t,
            text: l,
            tokens: this.lexer.inlineTokens(l)
          };
        }
      }
    }
    codespan(e) {
      const t = this.rules.inline.code.exec(e);
      if (t) {
        let e = t[2].replace(/\n/g, " ");
        const n = /[^ ]/.test(e),
          r = /^ /.test(e) && / $/.test(e);
        return n && r && (e = e.substring(1, e.length - 1)), e = go(e, !0), {
          type: "codespan",
          raw: t[0],
          text: e
        };
      }
    }
    br(e) {
      const t = this.rules.inline.br.exec(e);
      if (t) return {
        type: "br",
        raw: t[0]
      };
    }
    del(e) {
      const t = this.rules.inline.del.exec(e);
      if (t) return {
        type: "del",
        raw: t[0],
        text: t[2],
        tokens: this.lexer.inlineTokens(t[2])
      };
    }
    autolink(e, t) {
      const n = this.rules.inline.autolink.exec(e);
      if (n) {
        let e, r;
        return "@" === n[2] ? (e = go(this.options.mangle ? t(n[1]) : n[1]), r = "mailto:" + e) : (e = go(n[1]), r = e), {
          type: "link",
          raw: n[0],
          text: e,
          href: r,
          tokens: [{
            type: "text",
            raw: e,
            text: e
          }]
        };
      }
    }
    url(e, t) {
      let n;
      if (n = this.rules.inline.url.exec(e)) {
        let e, r;
        if ("@" === n[2]) e = go(this.options.mangle ? t(n[0]) : n[0]), r = "mailto:" + e;else {
          let t;
          do {
            t = n[0], n[0] = this.rules.inline._backpedal.exec(n[0])[0];
          } while (t !== n[0]);
          e = go(n[0]), r = "www." === n[1] ? "http://" + n[0] : n[0];
        }
        return {
          type: "link",
          raw: n[0],
          text: e,
          href: r,
          tokens: [{
            type: "text",
            raw: e,
            text: e
          }]
        };
      }
    }
    inlineText(e, t) {
      const n = this.rules.inline.text.exec(e);
      if (n) {
        let e;
        return e = this.lexer.state.inRawBlock ? this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(n[0]) : go(n[0]) : n[0] : go(this.options.smartypants ? t(n[0]) : n[0]), {
          type: "text",
          raw: n[0],
          text: e
        };
      }
    }
  }
  const $o = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
    def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: Oo,
    lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/,
    _label: /(?!\s*\])(?:\\.|[^\[\]\\])+/,
    _title: /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/
  };
  $o.def = wo($o.def).replace("label", $o._label).replace("title", $o._title).getRegex(), $o.bullet = /(?:[*+-]|\d{1,9}[.)])/, $o.listItemStart = wo(/^( *)(bull) */).replace("bull", $o.bullet).getRegex(), $o.list = wo($o.list).replace(/bull/g, $o.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + $o.def.source + ")").getRegex(), $o._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", $o._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/, $o.html = wo($o.html, "i").replace("comment", $o._comment).replace("tag", $o._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), $o.paragraph = wo($o._paragraph).replace("hr", $o.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $o._tag).getRegex(), $o.blockquote = wo($o.blockquote).replace("paragraph", $o.paragraph).getRegex(), $o.normal = Do({}, $o), $o.gfm = Do({}, $o.normal, {
    table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  }), $o.gfm.table = wo($o.gfm.table).replace("hr", $o.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $o._tag).getRegex(), $o.gfm.paragraph = wo($o._paragraph).replace("hr", $o.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", $o.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $o._tag).getRegex(), $o.pedantic = Do({}, $o.normal, {
    html: wo("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", $o._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: Oo,
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: wo($o.normal._paragraph).replace("hr", $o.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", $o.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
  });
  const Po = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: Oo,
    tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: "reflink|nolink(?!\\()",
    emStrong: {
      lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
      rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
      rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
    },
    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: Oo,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^([\spunctuation])/
  };
  function Uo(e) {
    return e.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
  }
  function Yo(e) {
    let t,
      n,
      r = "";
    const i = e.length;
    for (t = 0; t < i; t++) n = e.charCodeAt(t), Math.random() > .5 && (n = "x" + n.toString(16)), r += "&#" + n + ";";
    return r;
  }
  Po._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~", Po.punctuation = wo(Po.punctuation).replace(/punctuation/g, Po._punctuation).getRegex(), Po.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g, Po.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g, Po._comment = wo($o._comment).replace("(?:--\x3e|$)", "--\x3e").getRegex(), Po.emStrong.lDelim = wo(Po.emStrong.lDelim).replace(/punct/g, Po._punctuation).getRegex(), Po.emStrong.rDelimAst = wo(Po.emStrong.rDelimAst, "g").replace(/punct/g, Po._punctuation).getRegex(), Po.emStrong.rDelimUnd = wo(Po.emStrong.rDelimUnd, "g").replace(/punct/g, Po._punctuation).getRegex(), Po._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, Po._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, Po._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, Po.autolink = wo(Po.autolink).replace("scheme", Po._scheme).replace("email", Po._email).getRegex(), Po._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, Po.tag = wo(Po.tag).replace("comment", Po._comment).replace("attribute", Po._attribute).getRegex(), Po._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, Po._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/, Po._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, Po.link = wo(Po.link).replace("label", Po._label).replace("href", Po._href).replace("title", Po._title).getRegex(), Po.reflink = wo(Po.reflink).replace("label", Po._label).replace("ref", $o._label).getRegex(), Po.nolink = wo(Po.nolink).replace("ref", $o._label).getRegex(), Po.reflinkSearch = wo(Po.reflinkSearch, "g").replace("reflink", Po.reflink).replace("nolink", Po.nolink).getRegex(), Po.normal = Do({}, Po), Po.pedantic = Do({}, Po.normal, {
    strong: {
      start: /^__|\*\*/,
      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
      endAst: /\*\*(?!\*)/g,
      endUnd: /__(?!_)/g
    },
    em: {
      start: /^_|\*/,
      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
      endAst: /\*(?!\*)/g,
      endUnd: /_(?!_)/g
    },
    link: wo(/^!?\[(label)\]\((.*?)\)/).replace("label", Po._label).getRegex(),
    reflink: wo(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", Po._label).getRegex()
  }), Po.gfm = Do({}, Po.normal, {
    escape: wo(Po.escape).replace("])", "~|])").getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
  }), Po.gfm.url = wo(Po.gfm.url, "i").replace("email", Po.gfm._extended_email).getRegex(), Po.breaks = Do({}, Po.gfm, {
    br: wo(Po.br).replace("{2,}", "*").getRegex(),
    text: wo(Po.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
  });
  class zo {
    constructor(e) {
      this.tokens = [], this.tokens.links = Object.create(null), this.options = e || lo, this.options.tokenizer = this.options.tokenizer || new Io(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
        inLink: !1,
        inRawBlock: !1,
        top: !0
      };
      const t = {
        block: $o.normal,
        inline: Po.normal
      };
      this.options.pedantic ? (t.block = $o.pedantic, t.inline = Po.pedantic) : this.options.gfm && (t.block = $o.gfm, this.options.breaks ? t.inline = Po.breaks : t.inline = Po.gfm), this.tokenizer.rules = t;
    }
    static get rules() {
      return {
        block: $o,
        inline: Po
      };
    }
    static lex(e, t) {
      return new zo(t).lex(e);
    }
    static lexInline(e, t) {
      return new zo(t).inlineTokens(e);
    }
    lex(e) {
      let t;
      for (e = e.replace(/\r\n|\r/g, "\n"), this.blockTokens(e, this.tokens); t = this.inlineQueue.shift();) this.inlineTokens(t.src, t.tokens);
      return this.tokens;
    }
    blockTokens(e) {
      let t,
        n,
        r,
        i,
        s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      for (e = this.options.pedantic ? e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e.replace(/^( *)(\t+)/gm, (e, t, n) => t + "    ".repeat(n.length)); e;) if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(n => !!(t = n.call({
        lexer: this
      }, e, s)) && (e = e.substring(t.raw.length), s.push(t), !0)))) if (t = this.tokenizer.space(e)) e = e.substring(t.raw.length), 1 === t.raw.length && s.length > 0 ? s[s.length - 1].raw += "\n" : s.push(t);else if (t = this.tokenizer.code(e)) e = e.substring(t.raw.length), n = s[s.length - 1], !n || "paragraph" !== n.type && "text" !== n.type ? s.push(t) : (n.raw += "\n" + t.raw, n.text += "\n" + t.text, this.inlineQueue[this.inlineQueue.length - 1].src = n.text);else if (t = this.tokenizer.fences(e)) e = e.substring(t.raw.length), s.push(t);else if (t = this.tokenizer.heading(e)) e = e.substring(t.raw.length), s.push(t);else if (t = this.tokenizer.hr(e)) e = e.substring(t.raw.length), s.push(t);else if (t = this.tokenizer.blockquote(e)) e = e.substring(t.raw.length), s.push(t);else if (t = this.tokenizer.list(e)) e = e.substring(t.raw.length), s.push(t);else if (t = this.tokenizer.html(e)) e = e.substring(t.raw.length), s.push(t);else if (t = this.tokenizer.def(e)) e = e.substring(t.raw.length), n = s[s.length - 1], !n || "paragraph" !== n.type && "text" !== n.type ? this.tokens.links[t.tag] || (this.tokens.links[t.tag] = {
        href: t.href,
        title: t.title
      }) : (n.raw += "\n" + t.raw, n.text += "\n" + t.raw, this.inlineQueue[this.inlineQueue.length - 1].src = n.text);else if (t = this.tokenizer.table(e)) e = e.substring(t.raw.length), s.push(t);else if (t = this.tokenizer.lheading(e)) e = e.substring(t.raw.length), s.push(t);else {
        if (r = e, this.options.extensions && this.options.extensions.startBlock) {
          let t = 1 / 0;
          const n = e.slice(1);
          let i;
          this.options.extensions.startBlock.forEach(function (e) {
            i = e.call({
              lexer: this
            }, n), "number" == typeof i && i >= 0 && (t = Math.min(t, i));
          }), t < 1 / 0 && t >= 0 && (r = e.substring(0, t + 1));
        }
        if (this.state.top && (t = this.tokenizer.paragraph(r))) n = s[s.length - 1], i && "paragraph" === n.type ? (n.raw += "\n" + t.raw, n.text += "\n" + t.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : s.push(t), i = r.length !== e.length, e = e.substring(t.raw.length);else if (t = this.tokenizer.text(e)) e = e.substring(t.raw.length), n = s[s.length - 1], n && "text" === n.type ? (n.raw += "\n" + t.raw, n.text += "\n" + t.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : s.push(t);else if (e) {
          const t = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(t);
            break;
          }
          throw new Error(t);
        }
      }
      return this.state.top = !0, s;
    }
    inline(e) {
      let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      return this.inlineQueue.push({
        src: e,
        tokens: t
      }), t;
    }
    inlineTokens(e) {
      let t,
        n,
        r,
        i,
        s,
        o,
        a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        l = e;
      if (this.tokens.links) {
        const e = Object.keys(this.tokens.links);
        if (e.length > 0) for (; null != (i = this.tokenizer.rules.inline.reflinkSearch.exec(l));) e.includes(i[0].slice(i[0].lastIndexOf("[") + 1, -1)) && (l = l.slice(0, i.index) + "[" + Lo("a", i[0].length - 2) + "]" + l.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
      }
      for (; null != (i = this.tokenizer.rules.inline.blockSkip.exec(l));) l = l.slice(0, i.index) + "[" + Lo("a", i[0].length - 2) + "]" + l.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
      for (; null != (i = this.tokenizer.rules.inline.escapedEmSt.exec(l));) l = l.slice(0, i.index + i[0].length - 2) + "++" + l.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex), this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
      for (; e;) if (s || (o = ""), s = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(n => !!(t = n.call({
        lexer: this
      }, e, a)) && (e = e.substring(t.raw.length), a.push(t), !0)))) if (t = this.tokenizer.escape(e)) e = e.substring(t.raw.length), a.push(t);else if (t = this.tokenizer.tag(e)) e = e.substring(t.raw.length), n = a[a.length - 1], n && "text" === t.type && "text" === n.type ? (n.raw += t.raw, n.text += t.text) : a.push(t);else if (t = this.tokenizer.link(e)) e = e.substring(t.raw.length), a.push(t);else if (t = this.tokenizer.reflink(e, this.tokens.links)) e = e.substring(t.raw.length), n = a[a.length - 1], n && "text" === t.type && "text" === n.type ? (n.raw += t.raw, n.text += t.text) : a.push(t);else if (t = this.tokenizer.emStrong(e, l, o)) e = e.substring(t.raw.length), a.push(t);else if (t = this.tokenizer.codespan(e)) e = e.substring(t.raw.length), a.push(t);else if (t = this.tokenizer.br(e)) e = e.substring(t.raw.length), a.push(t);else if (t = this.tokenizer.del(e)) e = e.substring(t.raw.length), a.push(t);else if (t = this.tokenizer.autolink(e, Yo)) e = e.substring(t.raw.length), a.push(t);else if (this.state.inLink || !(t = this.tokenizer.url(e, Yo))) {
        if (r = e, this.options.extensions && this.options.extensions.startInline) {
          let t = 1 / 0;
          const n = e.slice(1);
          let i;
          this.options.extensions.startInline.forEach(function (e) {
            i = e.call({
              lexer: this
            }, n), "number" == typeof i && i >= 0 && (t = Math.min(t, i));
          }), t < 1 / 0 && t >= 0 && (r = e.substring(0, t + 1));
        }
        if (t = this.tokenizer.inlineText(r, Uo)) e = e.substring(t.raw.length), "_" !== t.raw.slice(-1) && (o = t.raw.slice(-1)), s = !0, n = a[a.length - 1], n && "text" === n.type ? (n.raw += t.raw, n.text += t.text) : a.push(t);else if (e) {
          const t = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(t);
            break;
          }
          throw new Error(t);
        }
      } else e = e.substring(t.raw.length), a.push(t);
      return a;
    }
  }
  class jo {
    constructor(e) {
      this.options = e || lo;
    }
    code(e, t, n) {
      const r = (t || "").match(/\S*/)[0];
      if (this.options.highlight) {
        const t = this.options.highlight(e, r);
        null != t && t !== e && (n = !0, e = t);
      }
      return e = e.replace(/\n$/, "") + "\n", r ? '<pre><code class="' + this.options.langPrefix + go(r) + '">' + (n ? e : go(e, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? e : go(e, !0)) + "</code></pre>\n";
    }
    blockquote(e) {
      return `<blockquote>\n${e}</blockquote>\n`;
    }
    html(e) {
      return e;
    }
    heading(e, t, n, r) {
      return this.options.headerIds ? `<h${t} id="${this.options.headerPrefix + r.slug(n)}">${e}</h${t}>\n` : `<h${t}>${e}</h${t}>\n`;
    }
    hr() {
      return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
    }
    list(e, t, n) {
      const r = t ? "ol" : "ul";
      return "<" + r + (t && 1 !== n ? ' start="' + n + '"' : "") + ">\n" + e + "</" + r + ">\n";
    }
    listitem(e) {
      return `<li>${e}</li>\n`;
    }
    checkbox(e) {
      return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
    }
    paragraph(e) {
      return `<p>${e}</p>\n`;
    }
    table(e, t) {
      return t && (t = `<tbody>${t}</tbody>`), "<table>\n<thead>\n" + e + "</thead>\n" + t + "</table>\n";
    }
    tablerow(e) {
      return `<tr>\n${e}</tr>\n`;
    }
    tablecell(e, t) {
      const n = t.header ? "th" : "td";
      return (t.align ? `<${n} align="${t.align}">` : `<${n}>`) + e + `</${n}>\n`;
    }
    strong(e) {
      return `<strong>${e}</strong>`;
    }
    em(e) {
      return `<em>${e}</em>`;
    }
    codespan(e) {
      return `<code>${e}</code>`;
    }
    br() {
      return this.options.xhtml ? "<br/>" : "<br>";
    }
    del(e) {
      return `<del>${e}</del>`;
    }
    link(e, t, n) {
      if (null === (e = xo(this.options.sanitize, this.options.baseUrl, e))) return n;
      let r = '<a href="' + e + '"';
      return t && (r += ' title="' + t + '"'), r += ">" + n + "</a>", r;
    }
    image(e, t, n) {
      if (null === (e = xo(this.options.sanitize, this.options.baseUrl, e))) return n;
      let r = `<img src="${e}" alt="${n}"`;
      return t && (r += ` title="${t}"`), r += this.options.xhtml ? "/>" : ">", r;
    }
    text(e) {
      return e;
    }
  }
  class Fo {
    strong(e) {
      return e;
    }
    em(e) {
      return e;
    }
    codespan(e) {
      return e;
    }
    del(e) {
      return e;
    }
    html(e) {
      return e;
    }
    text(e) {
      return e;
    }
    link(e, t, n) {
      return "" + n;
    }
    image(e, t, n) {
      return "" + n;
    }
    br() {
      return "";
    }
  }
  class Ho {
    constructor() {
      this.seen = {};
    }
    serialize(e) {
      return e.toLowerCase().trim().replace(/<[!\/a-z].*?>/gi, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
    }
    getNextSafeSlug(e, t) {
      let n = e,
        r = 0;
      if (this.seen.hasOwnProperty(n)) {
        r = this.seen[e];
        do {
          r++, n = e + "-" + r;
        } while (this.seen.hasOwnProperty(n));
      }
      return t || (this.seen[e] = r, this.seen[n] = 0), n;
    }
    slug(e) {
      let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      const n = this.serialize(e);
      return this.getNextSafeSlug(n, t.dryrun);
    }
  }
  class Wo {
    constructor(e) {
      this.options = e || lo, this.options.renderer = this.options.renderer || new jo(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new Fo(), this.slugger = new Ho();
    }
    static parse(e, t) {
      return new Wo(t).parse(e);
    }
    static parseInline(e, t) {
      return new Wo(t).parseInline(e);
    }
    parse(e) {
      let t,
        n,
        r,
        i,
        s,
        o,
        a,
        l,
        c,
        u,
        d,
        h,
        f,
        p,
        m,
        g,
        v,
        y,
        _,
        w = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        k = "";
      const b = e.length;
      for (t = 0; t < b; t++) if (u = e[t], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[u.type] && (_ = this.options.extensions.renderers[u.type].call({
        parser: this
      }, u), !1 !== _ || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(u.type))) k += _ || "";else switch (u.type) {
        case "space":
          continue;
        case "hr":
          k += this.renderer.hr();
          continue;
        case "heading":
          k += this.renderer.heading(this.parseInline(u.tokens), u.depth, yo(this.parseInline(u.tokens, this.textRenderer)), this.slugger);
          continue;
        case "code":
          k += this.renderer.code(u.text, u.lang, u.escaped);
          continue;
        case "table":
          for (l = "", a = "", i = u.header.length, n = 0; n < i; n++) a += this.renderer.tablecell(this.parseInline(u.header[n].tokens), {
            header: !0,
            align: u.align[n]
          });
          for (l += this.renderer.tablerow(a), c = "", i = u.rows.length, n = 0; n < i; n++) {
            for (o = u.rows[n], a = "", s = o.length, r = 0; r < s; r++) a += this.renderer.tablecell(this.parseInline(o[r].tokens), {
              header: !1,
              align: u.align[r]
            });
            c += this.renderer.tablerow(a);
          }
          k += this.renderer.table(l, c);
          continue;
        case "blockquote":
          c = this.parse(u.tokens), k += this.renderer.blockquote(c);
          continue;
        case "list":
          for (d = u.ordered, h = u.start, f = u.loose, i = u.items.length, c = "", n = 0; n < i; n++) m = u.items[n], g = m.checked, v = m.task, p = "", m.task && (y = this.renderer.checkbox(g), f ? m.tokens.length > 0 && "paragraph" === m.tokens[0].type ? (m.tokens[0].text = y + " " + m.tokens[0].text, m.tokens[0].tokens && m.tokens[0].tokens.length > 0 && "text" === m.tokens[0].tokens[0].type && (m.tokens[0].tokens[0].text = y + " " + m.tokens[0].tokens[0].text)) : m.tokens.unshift({
            type: "text",
            text: y
          }) : p += y), p += this.parse(m.tokens, f), c += this.renderer.listitem(p, v, g);
          k += this.renderer.list(c, d, h);
          continue;
        case "html":
          k += this.renderer.html(u.text);
          continue;
        case "paragraph":
          k += this.renderer.paragraph(this.parseInline(u.tokens));
          continue;
        case "text":
          for (c = u.tokens ? this.parseInline(u.tokens) : u.text; t + 1 < b && "text" === e[t + 1].type;) u = e[++t], c += "\n" + (u.tokens ? this.parseInline(u.tokens) : u.text);
          k += w ? this.renderer.paragraph(c) : c;
          continue;
        default:
          {
            const e = 'Token with "' + u.type + '" type was not found.';
            if (this.options.silent) return void console.error(e);
            throw new Error(e);
          }
      }
      return k;
    }
    parseInline(e, t) {
      t = t || this.renderer;
      let n,
        r,
        i,
        s = "";
      const o = e.length;
      for (n = 0; n < o; n++) if (r = e[n], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[r.type] && (i = this.options.extensions.renderers[r.type].call({
        parser: this
      }, r), !1 !== i || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(r.type))) s += i || "";else switch (r.type) {
        case "escape":
        case "text":
          s += t.text(r.text);
          break;
        case "html":
          s += t.html(r.text);
          break;
        case "link":
          s += t.link(r.href, r.title, this.parseInline(r.tokens, t));
          break;
        case "image":
          s += t.image(r.href, r.title, r.text);
          break;
        case "strong":
          s += t.strong(this.parseInline(r.tokens, t));
          break;
        case "em":
          s += t.em(this.parseInline(r.tokens, t));
          break;
        case "codespan":
          s += t.codespan(r.text);
          break;
        case "br":
          s += t.br();
          break;
        case "del":
          s += t.del(this.parseInline(r.tokens, t));
          break;
        default:
          {
            const e = 'Token with "' + r.type + '" type was not found.';
            if (this.options.silent) return void console.error(e);
            throw new Error(e);
          }
      }
      return s;
    }
  }
  function Vo(e, t, n) {
    if (null == e) throw new Error("marked(): input parameter is undefined or null");
    if ("string" != typeof e) throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(e) + ", string expected");
    if ("function" == typeof t && (n = t, t = null), Ao(t = Do({}, Vo.defaults, t || {})), n) {
      const r = t.highlight;
      let i;
      try {
        i = zo.lex(e, t);
      } catch (e) {
        return n(e);
      }
      const s = function (e) {
        let s;
        if (!e) try {
          t.walkTokens && Vo.walkTokens(i, t.walkTokens), s = Wo.parse(i, t);
        } catch (t) {
          e = t;
        }
        return t.highlight = r, e ? n(e) : n(null, s);
      };
      if (!r || r.length < 3) return s();
      if (delete t.highlight, !i.length) return s();
      let o = 0;
      return Vo.walkTokens(i, function (e) {
        "code" === e.type && (o++, setTimeout(() => {
          r(e.text, e.lang, function (t, n) {
            if (t) return s(t);
            null != n && n !== e.text && (e.text = n, e.escaped = !0), o--, 0 === o && s();
          });
        }, 0));
      }), void (0 === o && s());
    }
    function r(e) {
      if (e.message += "\nPlease report this to https://github.com/markedjs/marked.", t.silent) return "<p>An error occurred:</p><pre>" + go(e.message + "", !0) + "</pre>";
      throw e;
    }
    try {
      const n = zo.lex(e, t);
      if (t.walkTokens) {
        if (t.async) return Promise.all(Vo.walkTokens(n, t.walkTokens)).then(() => Wo.parse(n, t)).catch(r);
        Vo.walkTokens(n, t.walkTokens);
      }
      return Wo.parse(n, t);
    } catch (e) {
      r(e);
    }
  }
  Vo.options = Vo.setOptions = function (e) {
    var t;
    return Do(Vo.defaults, e), t = Vo.defaults, lo = t, Vo;
  }, Vo.getDefaults = function () {
    return {
      async: !1,
      baseUrl: null,
      breaks: !1,
      extensions: null,
      gfm: !0,
      headerIds: !0,
      headerPrefix: "",
      highlight: null,
      langPrefix: "language-",
      mangle: !0,
      pedantic: !1,
      renderer: null,
      sanitize: !1,
      sanitizer: null,
      silent: !1,
      smartypants: !1,
      tokenizer: null,
      walkTokens: null,
      xhtml: !1
    };
  }, Vo.defaults = lo, Vo.use = function () {
    const e = Vo.defaults.extensions || {
      renderers: {},
      childTokens: {}
    };
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
    n.forEach(t => {
      const n = Do({}, t);
      if (n.async = Vo.defaults.async || n.async, t.extensions && (t.extensions.forEach(t => {
        if (!t.name) throw new Error("extension name required");
        if (t.renderer) {
          const n = e.renderers[t.name];
          e.renderers[t.name] = n ? function () {
            for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++) r[i] = arguments[i];
            let s = t.renderer.apply(this, r);
            return !1 === s && (s = n.apply(this, r)), s;
          } : t.renderer;
        }
        if (t.tokenizer) {
          if (!t.level || "block" !== t.level && "inline" !== t.level) throw new Error("extension level must be 'block' or 'inline'");
          e[t.level] ? e[t.level].unshift(t.tokenizer) : e[t.level] = [t.tokenizer], t.start && ("block" === t.level ? e.startBlock ? e.startBlock.push(t.start) : e.startBlock = [t.start] : "inline" === t.level && (e.startInline ? e.startInline.push(t.start) : e.startInline = [t.start]));
        }
        t.childTokens && (e.childTokens[t.name] = t.childTokens);
      }), n.extensions = e), t.renderer) {
        const e = Vo.defaults.renderer || new jo();
        for (const n in t.renderer) {
          const r = e[n];
          e[n] = function () {
            for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++) s[o] = arguments[o];
            let a = t.renderer[n].apply(e, s);
            return !1 === a && (a = r.apply(e, s)), a;
          };
        }
        n.renderer = e;
      }
      if (t.tokenizer) {
        const e = Vo.defaults.tokenizer || new Io();
        for (const n in t.tokenizer) {
          const r = e[n];
          e[n] = function () {
            for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++) s[o] = arguments[o];
            let a = t.tokenizer[n].apply(e, s);
            return !1 === a && (a = r.apply(e, s)), a;
          };
        }
        n.tokenizer = e;
      }
      if (t.walkTokens) {
        const e = Vo.defaults.walkTokens;
        n.walkTokens = function (n) {
          let r = [];
          return r.push(t.walkTokens.call(this, n)), e && (r = r.concat(e.call(this, n))), r;
        };
      }
      Vo.setOptions(n);
    });
  }, Vo.walkTokens = function (e, t) {
    let n = [];
    for (const r of e) switch (n = n.concat(t.call(Vo, r)), r.type) {
      case "table":
        for (const e of r.header) n = n.concat(Vo.walkTokens(e.tokens, t));
        for (const e of r.rows) for (const r of e) n = n.concat(Vo.walkTokens(r.tokens, t));
        break;
      case "list":
        n = n.concat(Vo.walkTokens(r.items, t));
        break;
      default:
        Vo.defaults.extensions && Vo.defaults.extensions.childTokens && Vo.defaults.extensions.childTokens[r.type] ? Vo.defaults.extensions.childTokens[r.type].forEach(function (e) {
          n = n.concat(Vo.walkTokens(r[e], t));
        }) : r.tokens && (n = n.concat(Vo.walkTokens(r.tokens, t)));
    }
    return n;
  }, Vo.parseInline = function (e, t) {
    if (null == e) throw new Error("marked.parseInline(): input parameter is undefined or null");
    if ("string" != typeof e) throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(e) + ", string expected");
    Ao(t = Do({}, Vo.defaults, t || {}));
    try {
      const n = zo.lexInline(e, t);
      return t.walkTokens && Vo.walkTokens(n, t.walkTokens), Wo.parseInline(n, t);
    } catch (e) {
      if (e.message += "\nPlease report this to https://github.com/markedjs/marked.", t.silent) return "<p>An error occurred:</p><pre>" + go(e.message + "", !0) + "</pre>";
      throw e;
    }
  }, Vo.Parser = Wo, Vo.parser = Wo.parse, Vo.Renderer = jo, Vo.TextRenderer = Fo, Vo.Lexer = zo, Vo.lexer = zo.lex, Vo.Tokenizer = Io, Vo.Slugger = Ho, Vo.parse = Vo;
  const Bo = /\$.*?\$/,
    Go = /^\$(.*?)\$/,
    qo = /^(?:\s{0,3})\$\$((?:[^\n]|\n[^\n])+?)\n{0,1}\$\$/,
    Zo = function () {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").replace(/:(.+?):/g, (t, n) => e[n] ? `<img class="wl-emoji" src="${e[n]}" alt="${n}">` : t);
    },
    Qo = e => e.dataset.path || e.getAttribute("id"),
    Ko = e => {
      let {
        serverURL: t,
        path: n = window.location.pathname,
        selector: r = ".waline-comment-count",
        lang: i = navigator.language
      } = e;
      const s = new AbortController(),
        o = document.querySelectorAll(r);
      return o.length && (e => {
        let {
          serverURL: t,
          lang: n,
          paths: r,
          signal: i
        } = e;
        return fetch(`${t}/comment?type=count&url=${encodeURIComponent(r.join(","))}&lang=${n}`, {
          signal: i
        }).then(e => e.json()).then(e => Array.isArray(e) ? e : [e]);
      })({
        serverURL: R(t),
        paths: Array.from(o).map(e => M(e.dataset.path || e.getAttribute("id") || n)),
        lang: i,
        signal: s.signal
      }).then(e => {
        o.forEach((t, n) => {
          t.innerText = e[n].toString();
        });
      }).catch(io), s.abort.bind(s);
    };
  e.commentCount = Ko;
  const Xo = e => {
      let {
        size: t
      } = e;
      return xi("svg", {
        class: "wl-close-icon",
        viewBox: "0 0 1024 1024",
        width: t,
        height: t
      }, [xi("path", {
        d: "M697.173 85.333h-369.92c-144.64 0-241.92 101.547-241.92 252.587v348.587c0 150.613 97.28 252.16 241.92 252.16h369.92c144.64 0 241.494-101.547 241.494-252.16V337.92c0-151.04-96.854-252.587-241.494-252.587z",
        fill: "currentColor"
      }), xi("path", {
        d: "m640.683 587.52-75.947-75.861 75.904-75.862a37.29 37.29 0 0 0 0-52.778 37.205 37.205 0 0 0-52.779 0l-75.946 75.818-75.862-75.946a37.419 37.419 0 0 0-52.821 0 37.419 37.419 0 0 0 0 52.821l75.947 75.947-75.776 75.733a37.29 37.29 0 1 0 52.778 52.821l75.776-75.776 75.947 75.947a37.376 37.376 0 0 0 52.779-52.821z",
        fill: "#888"
      })]);
    },
    Jo = () => xi("svg", {
      viewBox: "0 0 1024 1024",
      width: "24",
      height: "24"
    }, xi("path", {
      d: "m341.013 394.667 27.755 393.45h271.83l27.733-393.45h64.106l-28.01 397.952a64 64 0 0 1-63.83 59.498H368.768a64 64 0 0 1-63.83-59.52l-28.053-397.93h64.128zm139.307 19.818v298.667h-64V414.485h64zm117.013 0v298.667h-64V414.485h64zM181.333 288h640v64h-640v-64zm453.483-106.667v64h-256v-64h256z",
      fill: "red"
    })),
    ea = () => xi("svg", {
      viewBox: "0 0 1024 1024",
      width: "24",
      height: "24"
    }, xi("path", {
      d: "M563.2 463.3 677 540c1.7 1.2 3.7 1.8 5.8 1.8.7 0 1.4-.1 2-.2 2.7-.5 5.1-2.1 6.6-4.4l25.3-37.8c1.5-2.3 2.1-5.1 1.6-7.8s-2.1-5.1-4.4-6.6l-73.6-49.1 73.6-49.1c2.3-1.5 3.9-3.9 4.4-6.6.5-2.7 0-5.5-1.6-7.8l-25.3-37.8a10.1 10.1 0 0 0-6.6-4.4c-.7-.1-1.3-.2-2-.2-2.1 0-4.1.6-5.8 1.8l-113.8 76.6c-9.2 6.2-14.7 16.4-14.7 27.5.1 11 5.5 21.3 14.7 27.4zM387 348.8h-45.5c-5.7 0-10.4 4.7-10.4 10.4v153.3c0 5.7 4.7 10.4 10.4 10.4H387c5.7 0 10.4-4.7 10.4-10.4V359.2c0-5.7-4.7-10.4-10.4-10.4zm333.8 241.3-41-20a10.3 10.3 0 0 0-8.1-.5c-2.6.9-4.8 2.9-5.9 5.4-30.1 64.9-93.1 109.1-164.4 115.2-5.7.5-9.9 5.5-9.5 11.2l3.9 45.5c.5 5.3 5 9.5 10.3 9.5h.9c94.8-8 178.5-66.5 218.6-152.7 2.4-5 .3-11.2-4.8-13.6zm186-186.1c-11.9-42-30.5-81.4-55.2-117.1-24.1-34.9-53.5-65.6-87.5-91.2-33.9-25.6-71.5-45.5-111.6-59.2-41.2-14-84.1-21.1-127.8-21.1h-1.2c-75.4 0-148.8 21.4-212.5 61.7-63.7 40.3-114.3 97.6-146.5 165.8-32.2 68.1-44.3 143.6-35.1 218.4 9.3 74.8 39.4 145 87.3 203.3.1.2.3.3.4.5l36.2 38.4c1.1 1.2 2.5 2.1 3.9 2.6 73.3 66.7 168.2 103.5 267.5 103.5 73.3 0 145.2-20.3 207.7-58.7 37.3-22.9 70.3-51.5 98.1-85 27.1-32.7 48.7-69.5 64.2-109.1 15.5-39.7 24.4-81.3 26.6-123.8 2.4-43.6-2.5-87-14.5-129zm-60.5 181.1c-8.3 37-22.8 72-43 104-19.7 31.1-44.3 58.6-73.1 81.7-28.8 23.1-61 41-95.7 53.4-35.6 12.7-72.9 19.1-110.9 19.1-82.6 0-161.7-30.6-222.8-86.2l-34.1-35.8c-23.9-29.3-42.4-62.2-55.1-97.7-12.4-34.7-18.8-71-19.2-107.9-.4-36.9 5.4-73.3 17.1-108.2 12-35.8 30-69.2 53.4-99.1 31.7-40.4 71.1-72 117.2-94.1 44.5-21.3 94-32.6 143.4-32.6 49.3 0 97 10.8 141.8 32 34.3 16.3 65.3 38.1 92 64.8 26.1 26 47.5 56 63.6 89.2 16.2 33.2 26.6 68.5 31 105.1 4.6 37.5 2.7 75.3-5.6 112.3z",
      fill: "currentColor"
    })),
    ta = () => xi("svg", {
      viewBox: "0 0 1024 1024",
      width: "24",
      height: "24"
    }, [xi("path", {
      d: "M784 112H240c-88 0-160 72-160 160v480c0 88 72 160 160 160h544c88 0 160-72 160-160V272c0-88-72-160-160-160zm96 640c0 52.8-43.2 96-96 96H240c-52.8 0-96-43.2-96-96V272c0-52.8 43.2-96 96-96h544c52.8 0 96 43.2 96 96v480z",
      fill: "currentColor"
    }), xi("path", {
      d: "M352 480c52.8 0 96-43.2 96-96s-43.2-96-96-96-96 43.2-96 96 43.2 96 96 96zm0-128c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm462.4 379.2-3.2-3.2-177.6-177.6c-25.6-25.6-65.6-25.6-91.2 0l-80 80-36.8-36.8c-25.6-25.6-65.6-25.6-91.2 0L200 728c-4.8 6.4-8 14.4-8 24 0 17.6 14.4 32 32 32 9.6 0 16-3.2 22.4-9.6L380.8 640l134.4 134.4c6.4 6.4 14.4 9.6 24 9.6 17.6 0 32-14.4 32-32 0-9.6-4.8-17.6-9.6-24l-52.8-52.8 80-80L769.6 776c6.4 4.8 12.8 8 20.8 8 17.6 0 32-14.4 32-32 0-8-3.2-16-8-20.8z",
      fill: "currentColor"
    })]),
    na = () => xi("svg", {
      viewBox: "0 0 1024 1024",
      width: "24",
      height: "24"
    }, [xi("path", {
      d: "M710.816 654.301c70.323-96.639 61.084-230.578-23.705-314.843-46.098-46.098-107.183-71.109-172.28-71.109-65.008 0-126.092 25.444-172.28 71.109-45.227 46.098-70.756 107.183-70.756 172.106 0 64.923 25.444 126.007 71.194 172.106 46.099 46.098 107.184 71.109 172.28 71.109 51.414 0 100.648-16.212 142.824-47.404l126.53 126.006c7.058 7.06 16.297 10.979 26.406 10.979 10.105 0 19.343-3.919 26.402-10.979 14.467-14.467 14.467-38.172 0-52.723L710.816 654.301zm-315.107-23.265c-65.88-65.88-65.88-172.54 0-238.42 32.069-32.07 74.245-49.149 119.471-49.149 45.227 0 87.407 17.603 119.472 49.149 65.88 65.879 65.88 172.539 0 238.42-63.612 63.178-175.242 63.178-238.943 0zm0 0",
      fill: "currentColor"
    }), xi("path", {
      d: "M703.319 121.603H321.03c-109.8 0-199.469 89.146-199.469 199.38v382.034c0 109.796 89.236 199.38 199.469 199.38h207.397c20.653 0 37.384-16.645 37.384-37.299 0-20.649-16.731-37.296-37.384-37.296H321.03c-68.582 0-124.352-55.77-124.352-124.267V321.421c0-68.496 55.77-124.267 124.352-124.267h382.289c68.582 0 124.352 55.771 124.352 124.267V524.72c0 20.654 16.736 37.299 37.385 37.299 20.654 0 37.384-16.645 37.384-37.299V320.549c-.085-109.8-89.321-198.946-199.121-198.946zm0 0",
      fill: "currentColor"
    })]),
    ra = () => xi("svg", {
      width: "16",
      height: "16",
      ariaHidden: "true"
    }, xi("path", {
      d: "M14.85 3H1.15C.52 3 0 3.52 0 4.15v7.69C0 12.48.52 13 1.15 13h13.69c.64 0 1.15-.52 1.15-1.15v-7.7C16 3.52 15.48 3 14.85 3zM9 11H7V8L5.5 9.92 4 8v3H2V5h2l1.5 2L7 5h2v6zm2.99.5L9.5 8H11V5h2v3h1.5l-2.51 3.5z",
      fill: "currentColor"
    })),
    ia = () => xi("svg", {
      viewBox: "0 0 1024 1024",
      width: "24",
      height: "24"
    }, xi("path", {
      d: "M810.667 213.333a64 64 0 0 1 64 64V704a64 64 0 0 1-64 64H478.336l-146.645 96.107a21.333 21.333 0 0 1-33.024-17.856V768h-85.334a64 64 0 0 1-64-64V277.333a64 64 0 0 1 64-64h597.334zm0 64H213.333V704h149.334v63.296L459.243 704h351.424V277.333zm-271.36 213.334v64h-176.64v-64h176.64zm122.026-128v64H362.667v-64h298.666z",
      fill: "currentColor"
    })),
    sa = () => xi("svg", {
      viewBox: "0 0 1024 1024",
      width: "24",
      height: "24"
    }, xi("path", {
      d: "M813.039 318.772L480.53 651.278H360.718V531.463L693.227 198.961C697.904 194.284 704.027 192 710.157 192C716.302 192 722.436 194.284 727.114 198.961L813.039 284.88C817.72 289.561 820 295.684 820 301.825C820 307.95 817.72 314.093 813.039 318.772ZM710.172 261.888L420.624 551.431V591.376H460.561L750.109 301.825L710.172 261.888ZM490.517 291.845H240.906V771.09H720.156V521.479C720.156 504.947 733.559 491.529 750.109 491.529C766.653 491.529 780.063 504.947 780.063 521.479V791.059C780.063 813.118 762.18 831 740.125 831H220.937C198.882 831 181 813.118 181 791.059V271.872C181 249.817 198.882 231.935 220.937 231.935H490.517C507.06 231.935 520.47 245.352 520.47 261.888C520.47 278.424 507.06 291.845 490.517 291.845Z",
      fill: "currentColor"
    })),
    oa = () => xi("svg", {
      class: "verified-icon",
      viewBox: "0 0 1024 1024",
      width: "14",
      height: "14"
    }, xi("path", {
      d: "m894.4 461.56-54.4-63.2c-10.4-12-18.8-34.4-18.8-50.4v-68c0-42.4-34.8-77.2-77.2-77.2h-68c-15.6 0-38.4-8.4-50.4-18.8l-63.2-54.4c-27.6-23.6-72.8-23.6-100.8 0l-62.8 54.8c-12 10-34.8 18.4-50.4 18.4h-69.2c-42.4 0-77.2 34.8-77.2 77.2v68.4c0 15.6-8.4 38-18.4 50l-54 63.6c-23.2 27.6-23.2 72.4 0 100l54 63.6c10 12 18.4 34.4 18.4 50v68.4c0 42.4 34.8 77.2 77.2 77.2h69.2c15.6 0 38.4 8.4 50.4 18.8l63.2 54.4c27.6 23.6 72.8 23.6 100.8 0l63.2-54.4c12-10.4 34.4-18.8 50.4-18.8h68c42.4 0 77.2-34.8 77.2-77.2v-68c0-15.6 8.4-38.4 18.8-50.4l54.4-63.2c23.2-27.6 23.2-73.2-.4-100.8zm-216-25.2-193.2 193.2a30 30 0 0 1-42.4 0l-96.8-96.8a30.16 30.16 0 0 1 0-42.4c11.6-11.6 30.8-11.6 42.4 0l75.6 75.6 172-172c11.6-11.6 30.8-11.6 42.4 0 11.6 11.6 11.6 30.8 0 42.4z",
      fill: "#27ae60"
    })),
    aa = e => {
      let {
        size: t
      } = e;
      return xi("svg", {
        width: t,
        height: t,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid"
      }, xi("circle", {
        cx: 50,
        cy: 50,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "4",
        r: "40",
        "stroke-dasharray": "85 30"
      }, xi("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        repeatCount: "indefinite",
        dur: "1s",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1"
      })));
    },
    la = () => xi("svg", {
      width: 24,
      height: 24,
      fill: "currentcolor",
      viewBox: "0 0 24 24"
    }, [xi("path", {
      style: "transform: translateY(0.5px)",
      d: "M18.968 10.5H15.968V11.484H17.984V12.984H15.968V15H14.468V9H18.968V10.5V10.5ZM8.984 9C9.26533 9 9.49967 9.09367 9.687 9.281C9.87433 9.46833 9.968 9.70267 9.968 9.984V10.5H6.499V13.5H8.468V12H9.968V14.016C9.968 14.2973 9.87433 14.5317 9.687 14.719C9.49967 14.9063 9.26533 15 8.984 15H5.984C5.70267 15 5.46833 14.9063 5.281 14.719C5.09367 14.5317 5 14.2973 5 14.016V9.985C5 9.70367 5.09367 9.46933 5.281 9.282C5.46833 9.09467 5.70267 9.001 5.984 9.001H8.984V9ZM11.468 9H12.968V15H11.468V9V9Z"
    }), xi("path", {
      d: "M18.5 3H5.75C3.6875 3 2 4.6875 2 6.75V18C2 20.0625 3.6875 21.75 5.75 21.75H18.5C20.5625 21.75 22.25 20.0625 22.25 18V6.75C22.25 4.6875 20.5625 3 18.5 3ZM20.75 18C20.75 19.2375 19.7375 20.25 18.5 20.25H5.75C4.5125 20.25 3.5 19.2375 3.5 18V6.75C3.5 5.5125 4.5125 4.5 5.75 4.5H18.5C19.7375 4.5 20.75 5.5125 20.75 6.75V18Z"
    })]);
  let ca = null;
  let ua = null;
  var da = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
  function ha(e) {
    var t = {
      exports: {}
    };
    return e(t, t.exports), t.exports;
  }
  var fa = ha(function (e, t) {
      var n = da && da.__awaiter || function (e, t, n, r) {
          return new (n || (n = Promise))(function (i, s) {
            function o(e) {
              try {
                l(r.next(e));
              } catch (e) {
                s(e);
              }
            }
            function a(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                s(e);
              }
            }
            function l(e) {
              var t;
              e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(o, a);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        r = da && da.__generator || function (e, t) {
          var n,
            r,
            i,
            s,
            o = {
              label: 0,
              sent: function () {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return s = {
            next: a(0),
            throw: a(1),
            return: a(2)
          }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
            return this;
          }), s;
          function a(s) {
            return function (a) {
              return function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; o;) try {
                  if (n = 1, r && (i = 2 & s[0] ? r.return : s[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, s[1])).done) return i;
                  switch (r = 0, i && (s = [2 & s[0], i.value]), s[0]) {
                    case 0:
                    case 1:
                      i = s;
                      break;
                    case 4:
                      return o.label++, {
                        value: s[1],
                        done: !1
                      };
                    case 5:
                      o.label++, r = s[1], s = [0];
                      continue;
                    case 7:
                      s = o.ops.pop(), o.trys.pop();
                      continue;
                    default:
                      if (!((i = (i = o.trys).length > 0 && i[i.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                        o = 0;
                        continue;
                      }
                      if (3 === s[0] && (!i || s[1] > i[0] && s[1] < i[3])) {
                        o.label = s[1];
                        break;
                      }
                      if (6 === s[0] && o.label < i[1]) {
                        o.label = i[1], i = s;
                        break;
                      }
                      if (i && o.label < i[2]) {
                        o.label = i[2], o.ops.push(s);
                        break;
                      }
                      i[2] && o.ops.pop(), o.trys.pop();
                      continue;
                  }
                  s = t.call(e, o);
                } catch (e) {
                  s = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                  value: s[0] ? s[1] : void 0,
                  done: !0
                };
              }([s, a]);
            };
          }
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ReCaptchaInstance = void 0;
      var i = function () {
        function e(e, t, n) {
          this.siteKey = e, this.recaptchaID = t, this.recaptcha = n, this.styleContainer = null;
        }
        return e.prototype.execute = function (e) {
          return n(this, void 0, void 0, function () {
            return r(this, function (t) {
              return [2, this.recaptcha.enterprise ? this.recaptcha.enterprise.execute(this.recaptchaID, {
                action: e
              }) : this.recaptcha.execute(this.recaptchaID, {
                action: e
              })];
            });
          });
        }, e.prototype.getSiteKey = function () {
          return this.siteKey;
        }, e.prototype.hideBadge = function () {
          null === this.styleContainer && (this.styleContainer = document.createElement("style"), this.styleContainer.innerHTML = ".grecaptcha-badge{visibility:hidden !important;}", document.head.appendChild(this.styleContainer));
        }, e.prototype.showBadge = function () {
          null !== this.styleContainer && (document.head.removeChild(this.styleContainer), this.styleContainer = null);
        }, e;
      }();
      t.ReCaptchaInstance = i;
    }),
    pa = fa,
    ma = ha(function (e, t) {
      var n;
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.getInstance = t.load = void 0, function (e) {
        e[e.NOT_LOADED = 0] = "NOT_LOADED", e[e.LOADING = 1] = "LOADING", e[e.LOADED = 2] = "LOADED";
      }(n || (n = {}));
      var r = function () {
        function e() {}
        return e.load = function (t, r) {
          if (void 0 === r && (r = {}), "undefined" == typeof document) return Promise.reject(new Error("This is a library for the browser!"));
          if (e.getLoadingState() === n.LOADED) return e.instance.getSiteKey() === t ? Promise.resolve(e.instance) : Promise.reject(new Error("reCAPTCHA already loaded with different site key!"));
          if (e.getLoadingState() === n.LOADING) return t !== e.instanceSiteKey ? Promise.reject(new Error("reCAPTCHA already loaded with different site key!")) : new Promise(function (t, n) {
            e.successfulLoadingConsumers.push(function (e) {
              return t(e);
            }), e.errorLoadingRunnable.push(function (e) {
              return n(e);
            });
          });
          e.instanceSiteKey = t, e.setLoadingState(n.LOADING);
          var i = new e();
          return new Promise(function (s, o) {
            i.loadScript(t, r.useRecaptchaNet || !1, r.useEnterprise || !1, r.renderParameters ? r.renderParameters : {}, r.customUrl).then(function () {
              e.setLoadingState(n.LOADED);
              var o = i.doExplicitRender(grecaptcha, t, r.explicitRenderParameters ? r.explicitRenderParameters : {}, r.useEnterprise || !1),
                a = new pa.ReCaptchaInstance(t, o, grecaptcha);
              e.successfulLoadingConsumers.forEach(function (e) {
                return e(a);
              }), e.successfulLoadingConsumers = [], r.autoHideBadge && a.hideBadge(), e.instance = a, s(a);
            }).catch(function (t) {
              e.errorLoadingRunnable.forEach(function (e) {
                return e(t);
              }), e.errorLoadingRunnable = [], o(t);
            });
          });
        }, e.getInstance = function () {
          return e.instance;
        }, e.setLoadingState = function (t) {
          e.loadingState = t;
        }, e.getLoadingState = function () {
          return null === e.loadingState ? n.NOT_LOADED : e.loadingState;
        }, e.prototype.loadScript = function (t, r, i, s, o) {
          var a = this;
          void 0 === r && (r = !1), void 0 === i && (i = !1), void 0 === s && (s = {}), void 0 === o && (o = "");
          var l = document.createElement("script");
          l.setAttribute("recaptcha-v3-script", "");
          var c = "https://www.google.com/recaptcha/api.js";
          r && (c = i ? "https://recaptcha.net/recaptcha/enterprise.js" : "https://recaptcha.net/recaptcha/api.js"), i && (c = "https://www.google.com/recaptcha/enterprise.js"), o && (c = o), s.render && (s.render = void 0);
          var u = this.buildQueryString(s);
          return l.src = c + "?render=explicit" + u, new Promise(function (t, r) {
            l.addEventListener("load", a.waitForScriptToLoad(function () {
              t(l);
            }, i), !1), l.onerror = function (t) {
              e.setLoadingState(n.NOT_LOADED), r(t);
            }, document.head.appendChild(l);
          });
        }, e.prototype.buildQueryString = function (e) {
          return Object.keys(e).length < 1 ? "" : "&" + Object.keys(e).filter(function (t) {
            return !!e[t];
          }).map(function (t) {
            return t + "=" + e[t];
          }).join("&");
        }, e.prototype.waitForScriptToLoad = function (t, n) {
          var r = this;
          return function () {
            void 0 === window.grecaptcha ? setTimeout(function () {
              r.waitForScriptToLoad(t, n);
            }, e.SCRIPT_LOAD_DELAY) : n ? window.grecaptcha.enterprise.ready(function () {
              t();
            }) : window.grecaptcha.ready(function () {
              t();
            });
          };
        }, e.prototype.doExplicitRender = function (e, t, n, r) {
          var i = {
            sitekey: t,
            badge: n.badge,
            size: n.size,
            tabindex: n.tabindex
          };
          return n.container ? r ? e.enterprise.render(n.container, i) : e.render(n.container, i) : r ? e.enterprise.render(i) : e.render(i);
        }, e.loadingState = null, e.instance = null, e.instanceSiteKey = null, e.successfulLoadingConsumers = [], e.errorLoadingRunnable = [], e.SCRIPT_LOAD_DELAY = 25, e;
      }();
      t.load = r.load, t.getInstance = r.getInstance;
    }),
    ga = ma,
    va = ha(function (e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ReCaptchaInstance = t.getInstance = t.load = void 0, Object.defineProperty(t, "load", {
        enumerable: !0,
        get: function () {
          return ga.load;
        }
      }), Object.defineProperty(t, "getInstance", {
        enumerable: !0,
        get: function () {
          return ga.getInstance;
        }
      }), Object.defineProperty(t, "ReCaptchaInstance", {
        enumerable: !0,
        get: function () {
          return pa.ReCaptchaInstance;
        }
      });
    });
  const ya = {};
  let _a = null;
  const wa = () => {
      var _a2;
      return (_a2 = _a) !== null && _a2 !== void 0 ? _a2 : _a = Fs("WALINE_USER", {});
    },
    ka = {
      key: 0,
      class: "wl-reaction"
    },
    ba = ["textContent"],
    xa = {
      class: "wl-reaction-list"
    },
    Sa = ["onClick"],
    Ta = {
      class: "wl-reaction-img"
    },
    Ca = ["src", "alt"],
    Ma = ["textContent"],
    Oa = ["textContent"];
  var Da = Bn({
      __name: "ArticleReaction",
      setup(e, t) {
        var _ua;
        let {
          expose: n
        } = t;
        n();
        const r = (_ua = ua) !== null && _ua !== void 0 ? _ua : ua = Fs("WALINE_REACTION", {}),
          i = zn("config"),
          s = Jt(-1),
          o = Jt([]),
          a = bi(() => i.value.locale),
          l = bi(() => i.value.reaction.length > 0),
          c = bi(() => {
            const {
              reaction: e,
              path: t
            } = i.value;
            return e.map((e, n) => ({
              icon: e,
              desc: a.value[`reaction${n}`],
              active: r.value[t] === n
            }));
          });
        let u;
        return Qn(() => {
          Hn(() => [i.value.serverURL, i.value.path], () => {
            (async () => {
              if (l.value) {
                const {
                    serverURL: e,
                    lang: t,
                    path: n,
                    reaction: r
                  } = i.value,
                  s = new AbortController();
                u = s.abort.bind(s);
                const a = await S({
                  serverURL: e,
                  lang: t,
                  paths: [n],
                  type: r.map((e, t) => `reaction${t}`),
                  signal: s.signal
                });
                if (Array.isArray(a) || "number" == typeof a) return;
                o.value = r.map((e, t) => a[`reaction${t}`]);
              }
            })();
          }, {
            immediate: !0
          });
        }), Xn(() => {
          var _u;
          return (_u = u) === null || _u === void 0 ? void 0 : _u();
        }), (e, t) => rn(c).length ? (Wr(), qr("div", ka, [ti("div", {
          class: "wl-reaction-title",
          textContent: B(rn(a).reactionTitle)
        }, null, 8, ba), ti("ul", xa, [(Wr(!0), qr(Ur, null, ir(rn(c), (e, t) => {
          let {
            active: n,
            icon: a,
            desc: l
          } = e;
          return Wr(), qr("li", {
            key: t,
            class: j(["wl-reaction-item", {
              active: n
            }]),
            onClick: e => (async e => {
              if (-1 === s.value) {
                const {
                    serverURL: t,
                    lang: n,
                    path: a
                  } = i.value,
                  l = r.value[a];
                s.value = e, void 0 !== l && (await T({
                  serverURL: t,
                  lang: n,
                  path: a,
                  type: `reaction${l}`,
                  action: "desc"
                }), o.value[l] = Math.max(o.value[l] - 1, 0)), l !== e && (await T({
                  serverURL: t,
                  lang: n,
                  path: a,
                  type: `reaction${e}`
                }), o.value[e] = (o.value[e] || 0) + 1), l === e ? delete r.value[a] : r.value[a] = e, s.value = -1;
              }
            })(t)
          }, [ti("div", Ta, [ti("img", {
            src: a,
            alt: l
          }, null, 8, Ca), s.value === t ? (Wr(), Zr(rn(aa), {
            key: 0,
            class: "wl-reaction-loading"
          })) : (Wr(), qr("div", {
            key: 1,
            class: "wl-reaction-votes",
            textContent: B(o.value[t] || 0)
          }, null, 8, Ma))]), ti("div", {
            class: "wl-reaction-text",
            textContent: B(l)
          }, null, 8, Oa)], 10, Sa);
        }), 128))])])) : si("v-if", !0);
      }
    }),
    Ra = (e, t) => {
      const n = e.__vccOpts || e;
      for (const [e, r] of t) n[e] = r;
      return n;
    },
    Ea = Ra(Da, [["__file", "ArticleReaction.vue"]]),
    Aa = new Map();
  function La(e) {
    var t = Aa.get(e);
    t && t.destroy();
  }
  function Na(e) {
    var t = Aa.get(e);
    t && t.update();
  }
  var Ia = null;
  "undefined" == typeof window ? ((Ia = function (e) {
    return e;
  }).destroy = function (e) {
    return e;
  }, Ia.update = function (e) {
    return e;
  }) : ((Ia = function (e, t) {
    return e && Array.prototype.forEach.call(e.length ? e : [e], function (e) {
      return function (e) {
        if (e && e.nodeName && "TEXTAREA" === e.nodeName && !Aa.has(e)) {
          var t,
            n = null,
            r = window.getComputedStyle(e),
            i = (t = e.value, function () {
              o({
                testForHeightReduction: "" === t || !e.value.startsWith(t),
                restoreTextAlign: null
              }), t = e.value;
            }),
            s = function (t) {
              e.removeEventListener("autosize:destroy", s), e.removeEventListener("autosize:update", a), e.removeEventListener("input", i), window.removeEventListener("resize", a), Object.keys(t).forEach(function (n) {
                return e.style[n] = t[n];
              }), Aa.delete(e);
            }.bind(e, {
              height: e.style.height,
              resize: e.style.resize,
              textAlign: e.style.textAlign,
              overflowY: e.style.overflowY,
              overflowX: e.style.overflowX,
              wordWrap: e.style.wordWrap
            });
          e.addEventListener("autosize:destroy", s), e.addEventListener("autosize:update", a), e.addEventListener("input", i), window.addEventListener("resize", a), e.style.overflowX = "hidden", e.style.wordWrap = "break-word", Aa.set(e, {
            destroy: s,
            update: a
          }), a();
        }
        function o(t) {
          var i,
            s,
            a = t.restoreTextAlign,
            l = void 0 === a ? null : a,
            c = t.testForHeightReduction,
            u = void 0 === c || c,
            d = r.overflowY;
          if (0 !== e.scrollHeight && ("vertical" === r.resize ? e.style.resize = "none" : "both" === r.resize && (e.style.resize = "horizontal"), u && (i = function (e) {
            for (var t = []; e && e.parentNode && e.parentNode instanceof Element;) e.parentNode.scrollTop && t.push([e.parentNode, e.parentNode.scrollTop]), e = e.parentNode;
            return function () {
              return t.forEach(function (e) {
                var t = e[0],
                  n = e[1];
                t.style.scrollBehavior = "auto", t.scrollTop = n, t.style.scrollBehavior = null;
              });
            };
          }(e), e.style.height = ""), s = "content-box" === r.boxSizing ? e.scrollHeight - (parseFloat(r.paddingTop) + parseFloat(r.paddingBottom)) : e.scrollHeight + parseFloat(r.borderTopWidth) + parseFloat(r.borderBottomWidth), "none" !== r.maxHeight && s > parseFloat(r.maxHeight) ? ("hidden" === r.overflowY && (e.style.overflow = "scroll"), s = parseFloat(r.maxHeight)) : "hidden" !== r.overflowY && (e.style.overflow = "hidden"), e.style.height = s + "px", l && (e.style.textAlign = l), i && i(), n !== s && (e.dispatchEvent(new Event("autosize:resized", {
            bubbles: !0
          })), n = s), d !== r.overflow && !l)) {
            var h = r.textAlign;
            "hidden" === r.overflow && (e.style.textAlign = "start" === h ? "end" : "start"), o({
              restoreTextAlign: h,
              testForHeightReduction: !0
            });
          }
        }
        function a() {
          o({
            testForHeightReduction: !0,
            restoreTextAlign: null
          });
        }
      }(e);
    }), e;
  }).destroy = function (e) {
    return e && Array.prototype.forEach.call(e.length ? e : [e], La), e;
  }, Ia.update = function (e) {
    return e && Array.prototype.forEach.call(e.length ? e : [e], Na), e;
  });
  var $a = Ia,
    Pa = ha(function (e, t) {
      e.exports = function () {
        var t, n;
        function r() {
          return t.apply(null, arguments);
        }
        function i(e) {
          return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
        }
        function s(e) {
          return null != e && "[object Object]" === Object.prototype.toString.call(e);
        }
        function o(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }
        function a(e) {
          if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
          var t;
          for (t in e) if (o(e, t)) return !1;
          return !0;
        }
        function l(e) {
          return void 0 === e;
        }
        function c(e) {
          return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
        }
        function u(e) {
          return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
        }
        function d(e, t) {
          var n,
            r = [],
            i = e.length;
          for (n = 0; n < i; ++n) r.push(t(e[n], n));
          return r;
        }
        function h(e, t) {
          for (var n in t) o(t, n) && (e[n] = t[n]);
          return o(t, "toString") && (e.toString = t.toString), o(t, "valueOf") && (e.valueOf = t.valueOf), e;
        }
        function f(e, t, n, r) {
          return It(e, t, n, r, !0).utc();
        }
        function p(e) {
          return null == e._pf && (e._pf = {
            empty: !1,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: !1,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: !1,
            userInvalidated: !1,
            iso: !1,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: !1,
            weekdayMismatch: !1
          }), e._pf;
        }
        function m(e) {
          var t = null,
            r = !1,
            i = e._d && !isNaN(e._d.getTime());
          return i && (t = p(e), r = n.call(t.parsedDateParts, function (e) {
            return null != e;
          }), i = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r), e._strict && (i = i && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour)), null != Object.isFrozen && Object.isFrozen(e) ? i : (e._isValid = i, e._isValid);
        }
        function g(e) {
          var t = f(NaN);
          return null != e ? h(p(t), e) : p(t).userInvalidated = !0, t;
        }
        n = Array.prototype.some ? Array.prototype.some : function (e) {
          var t,
            n = Object(this),
            r = n.length >>> 0;
          for (t = 0; t < r; t++) if (t in n && e.call(this, n[t], t, n)) return !0;
          return !1;
        };
        var v = r.momentProperties = [],
          y = !1;
        function _(e, t) {
          var n,
            r,
            i,
            s = v.length;
          if (l(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), l(t._i) || (e._i = t._i), l(t._f) || (e._f = t._f), l(t._l) || (e._l = t._l), l(t._strict) || (e._strict = t._strict), l(t._tzm) || (e._tzm = t._tzm), l(t._isUTC) || (e._isUTC = t._isUTC), l(t._offset) || (e._offset = t._offset), l(t._pf) || (e._pf = p(t)), l(t._locale) || (e._locale = t._locale), s > 0) for (n = 0; n < s; n++) l(i = t[r = v[n]]) || (e[r] = i);
          return e;
        }
        function w(e) {
          _(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === y && (y = !0, r.updateOffset(this), y = !1);
        }
        function k(e) {
          return e instanceof w || null != e && null != e._isAMomentObject;
        }
        function b(e) {
          !1 === r.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
        }
        function x(e, t) {
          var n = !0;
          return h(function () {
            if (null != r.deprecationHandler && r.deprecationHandler(null, e), n) {
              var i,
                s,
                a,
                l = [],
                c = arguments.length;
              for (s = 0; s < c; s++) {
                if (i = "", "object" == typeof arguments[s]) {
                  for (a in i += "\n[" + s + "] ", arguments[0]) o(arguments[0], a) && (i += a + ": " + arguments[0][a] + ", ");
                  i = i.slice(0, -2);
                } else i = arguments[s];
                l.push(i);
              }
              b(e + "\nArguments: " + Array.prototype.slice.call(l).join("") + "\n" + new Error().stack), n = !1;
            }
            return t.apply(this, arguments);
          }, t);
        }
        var S,
          T = {};
        function C(e, t) {
          null != r.deprecationHandler && r.deprecationHandler(e, t), T[e] || (b(t), T[e] = !0);
        }
        function M(e) {
          return "undefined" != typeof Function && e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
        }
        function O(e, t) {
          var n,
            r = h({}, e);
          for (n in t) o(t, n) && (s(e[n]) && s(t[n]) ? (r[n] = {}, h(r[n], e[n]), h(r[n], t[n])) : null != t[n] ? r[n] = t[n] : delete r[n]);
          for (n in e) o(e, n) && !o(t, n) && s(e[n]) && (r[n] = h({}, r[n]));
          return r;
        }
        function D(e) {
          null != e && this.set(e);
        }
        r.suppressDeprecationWarnings = !1, r.deprecationHandler = null, S = Object.keys ? Object.keys : function (e) {
          var t,
            n = [];
          for (t in e) o(e, t) && n.push(t);
          return n;
        };
        function R(e, t, n) {
          var r = "" + Math.abs(e),
            i = t - r.length;
          return (e >= 0 ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + r;
        }
        var E = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
          A = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
          L = {},
          N = {};
        function I(e, t, n, r) {
          var i = r;
          "string" == typeof r && (i = function () {
            return this[r]();
          }), e && (N[e] = i), t && (N[t[0]] = function () {
            return R(i.apply(this, arguments), t[1], t[2]);
          }), n && (N[n] = function () {
            return this.localeData().ordinal(i.apply(this, arguments), e);
          });
        }
        function $(e) {
          return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
        }
        function P(e, t) {
          return e.isValid() ? (t = U(t, e.localeData()), L[t] = L[t] || function (e) {
            var t,
              n,
              r = e.match(E);
            for (t = 0, n = r.length; t < n; t++) N[r[t]] ? r[t] = N[r[t]] : r[t] = $(r[t]);
            return function (t) {
              var i,
                s = "";
              for (i = 0; i < n; i++) s += M(r[i]) ? r[i].call(t, e) : r[i];
              return s;
            };
          }(t), L[t](e)) : e.localeData().invalidDate();
        }
        function U(e, t) {
          var n = 5;
          function r(e) {
            return t.longDateFormat(e) || e;
          }
          for (A.lastIndex = 0; n >= 0 && A.test(e);) e = e.replace(A, r), A.lastIndex = 0, n -= 1;
          return e;
        }
        var Y = {
          D: "date",
          dates: "date",
          date: "date",
          d: "day",
          days: "day",
          day: "day",
          e: "weekday",
          weekdays: "weekday",
          weekday: "weekday",
          E: "isoWeekday",
          isoweekdays: "isoWeekday",
          isoweekday: "isoWeekday",
          DDD: "dayOfYear",
          dayofyears: "dayOfYear",
          dayofyear: "dayOfYear",
          h: "hour",
          hours: "hour",
          hour: "hour",
          ms: "millisecond",
          milliseconds: "millisecond",
          millisecond: "millisecond",
          m: "minute",
          minutes: "minute",
          minute: "minute",
          M: "month",
          months: "month",
          month: "month",
          Q: "quarter",
          quarters: "quarter",
          quarter: "quarter",
          s: "second",
          seconds: "second",
          second: "second",
          gg: "weekYear",
          weekyears: "weekYear",
          weekyear: "weekYear",
          GG: "isoWeekYear",
          isoweekyears: "isoWeekYear",
          isoweekyear: "isoWeekYear",
          w: "week",
          weeks: "week",
          week: "week",
          W: "isoWeek",
          isoweeks: "isoWeek",
          isoweek: "isoWeek",
          y: "year",
          years: "year",
          year: "year"
        };
        function z(e) {
          return "string" == typeof e ? Y[e] || Y[e.toLowerCase()] : void 0;
        }
        function j(e) {
          var t,
            n,
            r = {};
          for (n in e) o(e, n) && (t = z(n)) && (r[t] = e[n]);
          return r;
        }
        var F = {
          date: 9,
          day: 11,
          weekday: 11,
          isoWeekday: 11,
          dayOfYear: 4,
          hour: 13,
          millisecond: 16,
          minute: 14,
          month: 8,
          quarter: 7,
          second: 15,
          weekYear: 1,
          isoWeekYear: 1,
          week: 5,
          isoWeek: 5,
          year: 1
        };
        var H,
          W = /\d/,
          V = /\d\d/,
          B = /\d{3}/,
          G = /\d{4}/,
          q = /[+-]?\d{6}/,
          Z = /\d\d?/,
          Q = /\d\d\d\d?/,
          K = /\d\d\d\d\d\d?/,
          X = /\d{1,3}/,
          J = /\d{1,4}/,
          ee = /[+-]?\d{1,6}/,
          te = /\d+/,
          ne = /[+-]?\d+/,
          re = /Z|[+-]\d\d:?\d\d/gi,
          ie = /Z|[+-]\d\d(?::?\d\d)?/gi,
          se = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
          oe = /^[1-9]\d?/,
          ae = /^([1-9]\d|\d)/;
        function le(e, t, n) {
          H[e] = M(t) ? t : function (e, r) {
            return e && n ? n : t;
          };
        }
        function ce(e, t) {
          return o(H, e) ? H[e](t._strict, t._locale) : new RegExp(function (e) {
            return ue(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, r, i) {
              return t || n || r || i;
            }));
          }(e));
        }
        function ue(e) {
          return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
        }
        function de(e) {
          return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
        }
        function he(e) {
          var t = +e,
            n = 0;
          return 0 !== t && isFinite(t) && (n = de(t)), n;
        }
        H = {};
        var fe = {};
        function pe(e, t) {
          var n,
            r,
            i = t;
          for ("string" == typeof e && (e = [e]), c(t) && (i = function (e, n) {
            n[t] = he(e);
          }), r = e.length, n = 0; n < r; n++) fe[e[n]] = i;
        }
        function me(e, t) {
          pe(e, function (e, n, r, i) {
            r._w = r._w || {}, t(e, r._w, r, i);
          });
        }
        function ge(e, t, n) {
          null != t && o(fe, e) && fe[e](t, n._a, n, e);
        }
        function ve(e) {
          return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
        }
        var ye = 0,
          _e = 1,
          we = 2,
          ke = 3,
          be = 4,
          xe = 5,
          Se = 6,
          Te = 7,
          Ce = 8;
        function Me(e) {
          return ve(e) ? 366 : 365;
        }
        I("Y", 0, 0, function () {
          var e = this.year();
          return e <= 9999 ? R(e, 4) : "+" + e;
        }), I(0, ["YY", 2], 0, function () {
          return this.year() % 100;
        }), I(0, ["YYYY", 4], 0, "year"), I(0, ["YYYYY", 5], 0, "year"), I(0, ["YYYYYY", 6, !0], 0, "year"), le("Y", ne), le("YY", Z, V), le("YYYY", J, G), le("YYYYY", ee, q), le("YYYYYY", ee, q), pe(["YYYYY", "YYYYYY"], ye), pe("YYYY", function (e, t) {
          t[ye] = 2 === e.length ? r.parseTwoDigitYear(e) : he(e);
        }), pe("YY", function (e, t) {
          t[ye] = r.parseTwoDigitYear(e);
        }), pe("Y", function (e, t) {
          t[ye] = parseInt(e, 10);
        }), r.parseTwoDigitYear = function (e) {
          return he(e) + (he(e) > 68 ? 1900 : 2e3);
        };
        var Oe,
          De = Re("FullYear", !0);
        function Re(e, t) {
          return function (n) {
            return null != n ? (Ae(this, e, n), r.updateOffset(this, t), this) : Ee(this, e);
          };
        }
        function Ee(e, t) {
          if (!e.isValid()) return NaN;
          var n = e._d,
            r = e._isUTC;
          switch (t) {
            case "Milliseconds":
              return r ? n.getUTCMilliseconds() : n.getMilliseconds();
            case "Seconds":
              return r ? n.getUTCSeconds() : n.getSeconds();
            case "Minutes":
              return r ? n.getUTCMinutes() : n.getMinutes();
            case "Hours":
              return r ? n.getUTCHours() : n.getHours();
            case "Date":
              return r ? n.getUTCDate() : n.getDate();
            case "Day":
              return r ? n.getUTCDay() : n.getDay();
            case "Month":
              return r ? n.getUTCMonth() : n.getMonth();
            case "FullYear":
              return r ? n.getUTCFullYear() : n.getFullYear();
            default:
              return NaN;
          }
        }
        function Ae(e, t, n) {
          var r, i, s, o, a;
          if (e.isValid() && !isNaN(n)) {
            switch (r = e._d, i = e._isUTC, t) {
              case "Milliseconds":
                return void (i ? r.setUTCMilliseconds(n) : r.setMilliseconds(n));
              case "Seconds":
                return void (i ? r.setUTCSeconds(n) : r.setSeconds(n));
              case "Minutes":
                return void (i ? r.setUTCMinutes(n) : r.setMinutes(n));
              case "Hours":
                return void (i ? r.setUTCHours(n) : r.setHours(n));
              case "Date":
                return void (i ? r.setUTCDate(n) : r.setDate(n));
              case "FullYear":
                break;
              default:
                return;
            }
            s = n, o = e.month(), a = 29 !== (a = e.date()) || 1 !== o || ve(s) ? a : 28, i ? r.setUTCFullYear(s, o, a) : r.setFullYear(s, o, a);
          }
        }
        function Le(e, t) {
          if (isNaN(e) || isNaN(t)) return NaN;
          var n = function (e, t) {
            return (e % t + t) % t;
          }(t, 12);
          return e += (t - n) / 12, 1 === n ? ve(e) ? 29 : 28 : 31 - n % 7 % 2;
        }
        Oe = Array.prototype.indexOf ? Array.prototype.indexOf : function (e) {
          var t;
          for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
          return -1;
        }, I("M", ["MM", 2], "Mo", function () {
          return this.month() + 1;
        }), I("MMM", 0, 0, function (e) {
          return this.localeData().monthsShort(this, e);
        }), I("MMMM", 0, 0, function (e) {
          return this.localeData().months(this, e);
        }), le("M", Z, oe), le("MM", Z, V), le("MMM", function (e, t) {
          return t.monthsShortRegex(e);
        }), le("MMMM", function (e, t) {
          return t.monthsRegex(e);
        }), pe(["M", "MM"], function (e, t) {
          t[_e] = he(e) - 1;
        }), pe(["MMM", "MMMM"], function (e, t, n, r) {
          var i = n._locale.monthsParse(e, r, n._strict);
          null != i ? t[_e] = i : p(n).invalidMonth = e;
        });
        var Ne = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          Ie = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
          $e = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
          Pe = se,
          Ue = se;
        function Ye(e, t, n) {
          var r,
            i,
            s,
            o = e.toLocaleLowerCase();
          if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r) s = f([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(s, "").toLocaleLowerCase(), this._longMonthsParse[r] = this.months(s, "").toLocaleLowerCase();
          return n ? "MMM" === t ? -1 !== (i = Oe.call(this._shortMonthsParse, o)) ? i : null : -1 !== (i = Oe.call(this._longMonthsParse, o)) ? i : null : "MMM" === t ? -1 !== (i = Oe.call(this._shortMonthsParse, o)) || -1 !== (i = Oe.call(this._longMonthsParse, o)) ? i : null : -1 !== (i = Oe.call(this._longMonthsParse, o)) || -1 !== (i = Oe.call(this._shortMonthsParse, o)) ? i : null;
        }
        function ze(e, t) {
          if (!e.isValid()) return e;
          if ("string" == typeof t) if (/^\d+$/.test(t)) t = he(t);else if (!c(t = e.localeData().monthsParse(t))) return e;
          var n = t,
            r = e.date();
          return r = r < 29 ? r : Math.min(r, Le(e.year(), n)), e._isUTC ? e._d.setUTCMonth(n, r) : e._d.setMonth(n, r), e;
        }
        function je(e) {
          return null != e ? (ze(this, e), r.updateOffset(this, !0), this) : Ee(this, "Month");
        }
        function Fe() {
          function e(e, t) {
            return t.length - e.length;
          }
          var t,
            n,
            r,
            i,
            s = [],
            o = [],
            a = [];
          for (t = 0; t < 12; t++) n = f([2e3, t]), r = ue(this.monthsShort(n, "")), i = ue(this.months(n, "")), s.push(r), o.push(i), a.push(i), a.push(r);
          s.sort(e), o.sort(e), a.sort(e), this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i");
        }
        function He(e, t, n, r, i, s, o) {
          var a;
          return e < 100 && e >= 0 ? (a = new Date(e + 400, t, n, r, i, s, o), isFinite(a.getFullYear()) && a.setFullYear(e)) : a = new Date(e, t, n, r, i, s, o), a;
        }
        function We(e) {
          var t, n;
          return e < 100 && e >= 0 ? ((n = Array.prototype.slice.call(arguments))[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
        }
        function Ve(e, t, n) {
          var r = 7 + t - n;
          return -(7 + We(e, 0, r).getUTCDay() - t) % 7 + r - 1;
        }
        function Be(e, t, n, r, i) {
          var s,
            o,
            a = 1 + 7 * (t - 1) + (7 + n - r) % 7 + Ve(e, r, i);
          return a <= 0 ? o = Me(s = e - 1) + a : a > Me(e) ? (s = e + 1, o = a - Me(e)) : (s = e, o = a), {
            year: s,
            dayOfYear: o
          };
        }
        function Ge(e, t, n) {
          var r,
            i,
            s = Ve(e.year(), t, n),
            o = Math.floor((e.dayOfYear() - s - 1) / 7) + 1;
          return o < 1 ? r = o + qe(i = e.year() - 1, t, n) : o > qe(e.year(), t, n) ? (r = o - qe(e.year(), t, n), i = e.year() + 1) : (i = e.year(), r = o), {
            week: r,
            year: i
          };
        }
        function qe(e, t, n) {
          var r = Ve(e, t, n),
            i = Ve(e + 1, t, n);
          return (Me(e) - r + i) / 7;
        }
        I("w", ["ww", 2], "wo", "week"), I("W", ["WW", 2], "Wo", "isoWeek"), le("w", Z, oe), le("ww", Z, V), le("W", Z, oe), le("WW", Z, V), me(["w", "ww", "W", "WW"], function (e, t, n, r) {
          t[r.substr(0, 1)] = he(e);
        });
        function Ze(e, t) {
          return e.slice(t, 7).concat(e.slice(0, t));
        }
        I("d", 0, "do", "day"), I("dd", 0, 0, function (e) {
          return this.localeData().weekdaysMin(this, e);
        }), I("ddd", 0, 0, function (e) {
          return this.localeData().weekdaysShort(this, e);
        }), I("dddd", 0, 0, function (e) {
          return this.localeData().weekdays(this, e);
        }), I("e", 0, 0, "weekday"), I("E", 0, 0, "isoWeekday"), le("d", Z), le("e", Z), le("E", Z), le("dd", function (e, t) {
          return t.weekdaysMinRegex(e);
        }), le("ddd", function (e, t) {
          return t.weekdaysShortRegex(e);
        }), le("dddd", function (e, t) {
          return t.weekdaysRegex(e);
        }), me(["dd", "ddd", "dddd"], function (e, t, n, r) {
          var i = n._locale.weekdaysParse(e, r, n._strict);
          null != i ? t.d = i : p(n).invalidWeekday = e;
        }), me(["d", "e", "E"], function (e, t, n, r) {
          t[r] = he(e);
        });
        var Qe = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          Ke = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
          Xe = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
          Je = se,
          et = se,
          tt = se;
        function nt(e, t, n) {
          var r,
            i,
            s,
            o = e.toLocaleLowerCase();
          if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r) s = f([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(s, "").toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(s, "").toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(s, "").toLocaleLowerCase();
          return n ? "dddd" === t ? -1 !== (i = Oe.call(this._weekdaysParse, o)) ? i : null : "ddd" === t ? -1 !== (i = Oe.call(this._shortWeekdaysParse, o)) ? i : null : -1 !== (i = Oe.call(this._minWeekdaysParse, o)) ? i : null : "dddd" === t ? -1 !== (i = Oe.call(this._weekdaysParse, o)) || -1 !== (i = Oe.call(this._shortWeekdaysParse, o)) || -1 !== (i = Oe.call(this._minWeekdaysParse, o)) ? i : null : "ddd" === t ? -1 !== (i = Oe.call(this._shortWeekdaysParse, o)) || -1 !== (i = Oe.call(this._weekdaysParse, o)) || -1 !== (i = Oe.call(this._minWeekdaysParse, o)) ? i : null : -1 !== (i = Oe.call(this._minWeekdaysParse, o)) || -1 !== (i = Oe.call(this._weekdaysParse, o)) || -1 !== (i = Oe.call(this._shortWeekdaysParse, o)) ? i : null;
        }
        function rt() {
          function e(e, t) {
            return t.length - e.length;
          }
          var t,
            n,
            r,
            i,
            s,
            o = [],
            a = [],
            l = [],
            c = [];
          for (t = 0; t < 7; t++) n = f([2e3, 1]).day(t), r = ue(this.weekdaysMin(n, "")), i = ue(this.weekdaysShort(n, "")), s = ue(this.weekdays(n, "")), o.push(r), a.push(i), l.push(s), c.push(r), c.push(i), c.push(s);
          o.sort(e), a.sort(e), l.sort(e), c.sort(e), this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i");
        }
        function it() {
          return this.hours() % 12 || 12;
        }
        function st(e, t) {
          I(e, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), t);
          });
        }
        function ot(e, t) {
          return t._meridiemParse;
        }
        I("H", ["HH", 2], 0, "hour"), I("h", ["hh", 2], 0, it), I("k", ["kk", 2], 0, function () {
          return this.hours() || 24;
        }), I("hmm", 0, 0, function () {
          return "" + it.apply(this) + R(this.minutes(), 2);
        }), I("hmmss", 0, 0, function () {
          return "" + it.apply(this) + R(this.minutes(), 2) + R(this.seconds(), 2);
        }), I("Hmm", 0, 0, function () {
          return "" + this.hours() + R(this.minutes(), 2);
        }), I("Hmmss", 0, 0, function () {
          return "" + this.hours() + R(this.minutes(), 2) + R(this.seconds(), 2);
        }), st("a", !0), st("A", !1), le("a", ot), le("A", ot), le("H", Z, ae), le("h", Z, oe), le("k", Z, oe), le("HH", Z, V), le("hh", Z, V), le("kk", Z, V), le("hmm", Q), le("hmmss", K), le("Hmm", Q), le("Hmmss", K), pe(["H", "HH"], ke), pe(["k", "kk"], function (e, t, n) {
          var r = he(e);
          t[ke] = 24 === r ? 0 : r;
        }), pe(["a", "A"], function (e, t, n) {
          n._isPm = n._locale.isPM(e), n._meridiem = e;
        }), pe(["h", "hh"], function (e, t, n) {
          t[ke] = he(e), p(n).bigHour = !0;
        }), pe("hmm", function (e, t, n) {
          var r = e.length - 2;
          t[ke] = he(e.substr(0, r)), t[be] = he(e.substr(r)), p(n).bigHour = !0;
        }), pe("hmmss", function (e, t, n) {
          var r = e.length - 4,
            i = e.length - 2;
          t[ke] = he(e.substr(0, r)), t[be] = he(e.substr(r, 2)), t[xe] = he(e.substr(i)), p(n).bigHour = !0;
        }), pe("Hmm", function (e, t, n) {
          var r = e.length - 2;
          t[ke] = he(e.substr(0, r)), t[be] = he(e.substr(r));
        }), pe("Hmmss", function (e, t, n) {
          var r = e.length - 4,
            i = e.length - 2;
          t[ke] = he(e.substr(0, r)), t[be] = he(e.substr(r, 2)), t[xe] = he(e.substr(i));
        });
        var at = Re("Hours", !0);
        var lt,
          ct = {
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L"
            },
            longDateFormat: {
              LTS: "h:mm:ss A",
              LT: "h:mm A",
              L: "MM/DD/YYYY",
              LL: "MMMM D, YYYY",
              LLL: "MMMM D, YYYY h:mm A",
              LLLL: "dddd, MMMM D, YYYY h:mm A"
            },
            invalidDate: "Invalid date",
            ordinal: "%d",
            dayOfMonthOrdinalParse: /\d{1,2}/,
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              w: "a week",
              ww: "%d weeks",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years"
            },
            months: Ne,
            monthsShort: Ie,
            week: {
              dow: 0,
              doy: 6
            },
            weekdays: Qe,
            weekdaysMin: Xe,
            weekdaysShort: Ke,
            meridiemParse: /[ap]\.?m?\.?/i
          },
          ut = {},
          dt = {};
        function ht(e, t) {
          var n,
            r = Math.min(e.length, t.length);
          for (n = 0; n < r; n += 1) if (e[n] !== t[n]) return n;
          return r;
        }
        function ft(e) {
          return e ? e.toLowerCase().replace("_", "-") : e;
        }
        function pt(t) {
          var n = null;
          if (void 0 === ut[t] && e && e.exports && function (e) {
            return !(!e || !e.match("^[^/\\\\]*$"));
          }(t)) try {
            n = lt._abbr, function (e) {
              throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets option of @rollup/plugin-commonjs appropriately for this require call to behave properly.');
            }("./locale/" + t), mt(n);
          } catch (e) {
            ut[t] = null;
          }
          return ut[t];
        }
        function mt(e, t) {
          var n;
          return e && ((n = l(t) ? vt(e) : gt(e, t)) ? lt = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), lt._abbr;
        }
        function gt(e, t) {
          if (null !== t) {
            var n,
              r = ct;
            if (t.abbr = e, null != ut[e]) C("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), r = ut[e]._config;else if (null != t.parentLocale) if (null != ut[t.parentLocale]) r = ut[t.parentLocale]._config;else {
              if (null == (n = pt(t.parentLocale))) return dt[t.parentLocale] || (dt[t.parentLocale] = []), dt[t.parentLocale].push({
                name: e,
                config: t
              }), null;
              r = n._config;
            }
            return ut[e] = new D(O(r, t)), dt[e] && dt[e].forEach(function (e) {
              gt(e.name, e.config);
            }), mt(e), ut[e];
          }
          return delete ut[e], null;
        }
        function vt(e) {
          var t;
          if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return lt;
          if (!i(e)) {
            if (t = pt(e)) return t;
            e = [e];
          }
          return function (e) {
            for (var t, n, r, i, s = 0; s < e.length;) {
              for (t = (i = ft(e[s]).split("-")).length, n = (n = ft(e[s + 1])) ? n.split("-") : null; t > 0;) {
                if (r = pt(i.slice(0, t).join("-"))) return r;
                if (n && n.length >= t && ht(i, n) >= t - 1) break;
                t--;
              }
              s++;
            }
            return lt;
          }(e);
        }
        function yt(e) {
          var t,
            n = e._a;
          return n && -2 === p(e).overflow && (t = n[_e] < 0 || n[_e] > 11 ? _e : n[we] < 1 || n[we] > Le(n[ye], n[_e]) ? we : n[ke] < 0 || n[ke] > 24 || 24 === n[ke] && (0 !== n[be] || 0 !== n[xe] || 0 !== n[Se]) ? ke : n[be] < 0 || n[be] > 59 ? be : n[xe] < 0 || n[xe] > 59 ? xe : n[Se] < 0 || n[Se] > 999 ? Se : -1, p(e)._overflowDayOfYear && (t < ye || t > we) && (t = we), p(e)._overflowWeeks && -1 === t && (t = Te), p(e)._overflowWeekday && -1 === t && (t = Ce), p(e).overflow = t), e;
        }
        var _t = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
          wt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
          kt = /Z|[+-]\d\d(?::?\d\d)?/,
          bt = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/], ["YYYYMM", /\d{6}/, !1], ["YYYY", /\d{4}/, !1]],
          xt = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
          St = /^\/?Date\((-?\d+)/i,
          Tt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
          Ct = {
            UT: 0,
            GMT: 0,
            EDT: -240,
            EST: -300,
            CDT: -300,
            CST: -360,
            MDT: -360,
            MST: -420,
            PDT: -420,
            PST: -480
          };
        function Mt(e) {
          var t,
            n,
            r,
            i,
            s,
            o,
            a = e._i,
            l = _t.exec(a) || wt.exec(a),
            c = bt.length,
            u = xt.length;
          if (l) {
            for (p(e).iso = !0, t = 0, n = c; t < n; t++) if (bt[t][1].exec(l[1])) {
              i = bt[t][0], r = !1 !== bt[t][2];
              break;
            }
            if (null == i) return void (e._isValid = !1);
            if (l[3]) {
              for (t = 0, n = u; t < n; t++) if (xt[t][1].exec(l[3])) {
                s = (l[2] || " ") + xt[t][0];
                break;
              }
              if (null == s) return void (e._isValid = !1);
            }
            if (!r && null != s) return void (e._isValid = !1);
            if (l[4]) {
              if (!kt.exec(l[4])) return void (e._isValid = !1);
              o = "Z";
            }
            e._f = i + (s || "") + (o || ""), Lt(e);
          } else e._isValid = !1;
        }
        function Ot(e) {
          var t = parseInt(e, 10);
          return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
        }
        function Dt(e) {
          var t,
            n = Tt.exec(function (e) {
              return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
            }(e._i));
          if (n) {
            if (t = function (e, t, n, r, i, s) {
              var o = [Ot(e), Ie.indexOf(t), parseInt(n, 10), parseInt(r, 10), parseInt(i, 10)];
              return s && o.push(parseInt(s, 10)), o;
            }(n[4], n[3], n[2], n[5], n[6], n[7]), !function (e, t, n) {
              return !e || Ke.indexOf(e) === new Date(t[0], t[1], t[2]).getDay() || (p(n).weekdayMismatch = !0, n._isValid = !1, !1);
            }(n[1], t, e)) return;
            e._a = t, e._tzm = function (e, t, n) {
              if (e) return Ct[e];
              if (t) return 0;
              var r = parseInt(n, 10),
                i = r % 100;
              return (r - i) / 100 * 60 + i;
            }(n[8], n[9], n[10]), e._d = We.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), p(e).rfc2822 = !0;
          } else e._isValid = !1;
        }
        function Rt(e, t, n) {
          return null != e ? e : null != t ? t : n;
        }
        function Et(e) {
          var t = new Date(r.now());
          return e._useUTC ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()] : [t.getFullYear(), t.getMonth(), t.getDate()];
        }
        function At(e) {
          var t,
            n,
            r,
            i,
            s,
            o = [];
          if (!e._d) {
            for (r = Et(e), e._w && null == e._a[we] && null == e._a[_e] && function (e) {
              var t, n, r, i, s, o, a, l, c;
              null != (t = e._w).GG || null != t.W || null != t.E ? (s = 1, o = 4, n = Rt(t.GG, e._a[ye], Ge($t(), 1, 4).year), r = Rt(t.W, 1), ((i = Rt(t.E, 1)) < 1 || i > 7) && (l = !0)) : (s = e._locale._week.dow, o = e._locale._week.doy, c = Ge($t(), s, o), n = Rt(t.gg, e._a[ye], c.year), r = Rt(t.w, c.week), null != t.d ? ((i = t.d) < 0 || i > 6) && (l = !0) : null != t.e ? (i = t.e + s, (t.e < 0 || t.e > 6) && (l = !0)) : i = s), r < 1 || r > qe(n, s, o) ? p(e)._overflowWeeks = !0 : null != l ? p(e)._overflowWeekday = !0 : (a = Be(n, r, i, s, o), e._a[ye] = a.year, e._dayOfYear = a.dayOfYear);
            }(e), null != e._dayOfYear && (s = Rt(e._a[ye], r[ye]), (e._dayOfYear > Me(s) || 0 === e._dayOfYear) && (p(e)._overflowDayOfYear = !0), n = We(s, 0, e._dayOfYear), e._a[_e] = n.getUTCMonth(), e._a[we] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) e._a[t] = o[t] = r[t];
            for (; t < 7; t++) e._a[t] = o[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
            24 === e._a[ke] && 0 === e._a[be] && 0 === e._a[xe] && 0 === e._a[Se] && (e._nextDay = !0, e._a[ke] = 0), e._d = (e._useUTC ? We : He).apply(null, o), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[ke] = 24), e._w && void 0 !== e._w.d && e._w.d !== i && (p(e).weekdayMismatch = !0);
          }
        }
        function Lt(e) {
          if (e._f !== r.ISO_8601) {
            if (e._f !== r.RFC_2822) {
              e._a = [], p(e).empty = !0;
              var t,
                n,
                i,
                s,
                o,
                a,
                l,
                c = "" + e._i,
                u = c.length,
                d = 0;
              for (l = (i = U(e._f, e._locale).match(E) || []).length, t = 0; t < l; t++) s = i[t], (n = (c.match(ce(s, e)) || [])[0]) && ((o = c.substr(0, c.indexOf(n))).length > 0 && p(e).unusedInput.push(o), c = c.slice(c.indexOf(n) + n.length), d += n.length), N[s] ? (n ? p(e).empty = !1 : p(e).unusedTokens.push(s), ge(s, n, e)) : e._strict && !n && p(e).unusedTokens.push(s);
              p(e).charsLeftOver = u - d, c.length > 0 && p(e).unusedInput.push(c), e._a[ke] <= 12 && !0 === p(e).bigHour && e._a[ke] > 0 && (p(e).bigHour = void 0), p(e).parsedDateParts = e._a.slice(0), p(e).meridiem = e._meridiem, e._a[ke] = function (e, t, n) {
                var r;
                return null == n ? t : null != e.meridiemHour ? e.meridiemHour(t, n) : null != e.isPM ? ((r = e.isPM(n)) && t < 12 && (t += 12), r || 12 !== t || (t = 0), t) : t;
              }(e._locale, e._a[ke], e._meridiem), null !== (a = p(e).era) && (e._a[ye] = e._locale.erasConvertYear(a, e._a[ye])), At(e), yt(e);
            } else Dt(e);
          } else Mt(e);
        }
        function Nt(e) {
          var t = e._i,
            n = e._f;
          return e._locale = e._locale || vt(e._l), null === t || void 0 === n && "" === t ? g({
            nullInput: !0
          }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), k(t) ? new w(yt(t)) : (u(t) ? e._d = t : i(n) ? function (e) {
            var t,
              n,
              r,
              i,
              s,
              o,
              a = !1,
              l = e._f.length;
            if (0 === l) return p(e).invalidFormat = !0, void (e._d = new Date(NaN));
            for (i = 0; i < l; i++) s = 0, o = !1, t = _({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[i], Lt(t), m(t) && (o = !0), s += p(t).charsLeftOver, s += 10 * p(t).unusedTokens.length, p(t).score = s, a ? s < r && (r = s, n = t) : (null == r || s < r || o) && (r = s, n = t, o && (a = !0));
            h(e, n || t);
          }(e) : n ? Lt(e) : function (e) {
            var t = e._i;
            l(t) ? e._d = new Date(r.now()) : u(t) ? e._d = new Date(t.valueOf()) : "string" == typeof t ? function (e) {
              var t = St.exec(e._i);
              null === t ? (Mt(e), !1 === e._isValid && (delete e._isValid, Dt(e), !1 === e._isValid && (delete e._isValid, e._strict ? e._isValid = !1 : r.createFromInputFallback(e)))) : e._d = new Date(+t[1]);
            }(e) : i(t) ? (e._a = d(t.slice(0), function (e) {
              return parseInt(e, 10);
            }), At(e)) : s(t) ? function (e) {
              if (!e._d) {
                var t = j(e._i),
                  n = void 0 === t.day ? t.date : t.day;
                e._a = d([t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond], function (e) {
                  return e && parseInt(e, 10);
                }), At(e);
              }
            }(e) : c(t) ? e._d = new Date(t) : r.createFromInputFallback(e);
          }(e), m(e) || (e._d = null), e));
        }
        function It(e, t, n, r, o) {
          var l = {};
          return !0 !== t && !1 !== t || (r = t, t = void 0), !0 !== n && !1 !== n || (r = n, n = void 0), (s(e) && a(e) || i(e) && 0 === e.length) && (e = void 0), l._isAMomentObject = !0, l._useUTC = l._isUTC = o, l._l = n, l._i = e, l._f = t, l._strict = r, function (e) {
            var t = new w(yt(Nt(e)));
            return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
          }(l);
        }
        function $t(e, t, n, r) {
          return It(e, t, n, r, !1);
        }
        r.createFromInputFallback = x("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (e) {
          e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
        }), r.ISO_8601 = function () {}, r.RFC_2822 = function () {};
        var Pt = x("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
            var e = $t.apply(null, arguments);
            return this.isValid() && e.isValid() ? e < this ? this : e : g();
          }),
          Ut = x("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
            var e = $t.apply(null, arguments);
            return this.isValid() && e.isValid() ? e > this ? this : e : g();
          });
        function Yt(e, t) {
          var n, r;
          if (1 === t.length && i(t[0]) && (t = t[0]), !t.length) return $t();
          for (n = t[0], r = 1; r < t.length; ++r) t[r].isValid() && !t[r][e](n) || (n = t[r]);
          return n;
        }
        var zt = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
        function jt(e) {
          var t,
            n,
            r = !1,
            i = zt.length;
          for (t in e) if (o(e, t) && (-1 === Oe.call(zt, t) || null != e[t] && isNaN(e[t]))) return !1;
          for (n = 0; n < i; ++n) if (e[zt[n]]) {
            if (r) return !1;
            parseFloat(e[zt[n]]) !== he(e[zt[n]]) && (r = !0);
          }
          return !0;
        }
        function Ft(e) {
          var t = j(e),
            n = t.year || 0,
            r = t.quarter || 0,
            i = t.month || 0,
            s = t.week || t.isoWeek || 0,
            o = t.day || 0,
            a = t.hour || 0,
            l = t.minute || 0,
            c = t.second || 0,
            u = t.millisecond || 0;
          this._isValid = jt(t), this._milliseconds = +u + 1e3 * c + 6e4 * l + 1e3 * a * 60 * 60, this._days = +o + 7 * s, this._months = +i + 3 * r + 12 * n, this._data = {}, this._locale = vt(), this._bubble();
        }
        function Ht(e) {
          return e instanceof Ft;
        }
        function Wt(e) {
          return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
        }
        function Vt(e, t) {
          I(e, 0, 0, function () {
            var e = this.utcOffset(),
              n = "+";
            return e < 0 && (e = -e, n = "-"), n + R(~~(e / 60), 2) + t + R(~~e % 60, 2);
          });
        }
        Vt("Z", ":"), Vt("ZZ", ""), le("Z", ie), le("ZZ", ie), pe(["Z", "ZZ"], function (e, t, n) {
          n._useUTC = !0, n._tzm = Gt(ie, e);
        });
        var Bt = /([\+\-]|\d\d)/gi;
        function Gt(e, t) {
          var n,
            r,
            i = (t || "").match(e);
          return null === i ? null : 0 === (r = 60 * (n = ((i[i.length - 1] || []) + "").match(Bt) || ["-", 0, 0])[1] + he(n[2])) ? 0 : "+" === n[0] ? r : -r;
        }
        function qt(e, t) {
          var n, i;
          return t._isUTC ? (n = t.clone(), i = (k(e) || u(e) ? e.valueOf() : $t(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + i), r.updateOffset(n, !1), n) : $t(e).local();
        }
        function Zt(e) {
          return -Math.round(e._d.getTimezoneOffset());
        }
        function Qt() {
          return !!this.isValid() && this._isUTC && 0 === this._offset;
        }
        r.updateOffset = function () {};
        var Kt = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
          Xt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
        function Jt(e, t) {
          var n,
            r,
            i,
            s = e,
            a = null;
          return Ht(e) ? s = {
            ms: e._milliseconds,
            d: e._days,
            M: e._months
          } : c(e) || !isNaN(+e) ? (s = {}, t ? s[t] = +e : s.milliseconds = +e) : (a = Kt.exec(e)) ? (n = "-" === a[1] ? -1 : 1, s = {
            y: 0,
            d: he(a[we]) * n,
            h: he(a[ke]) * n,
            m: he(a[be]) * n,
            s: he(a[xe]) * n,
            ms: he(Wt(1e3 * a[Se])) * n
          }) : (a = Xt.exec(e)) ? (n = "-" === a[1] ? -1 : 1, s = {
            y: en(a[2], n),
            M: en(a[3], n),
            w: en(a[4], n),
            d: en(a[5], n),
            h: en(a[6], n),
            m: en(a[7], n),
            s: en(a[8], n)
          }) : null == s ? s = {} : "object" == typeof s && ("from" in s || "to" in s) && (i = function (e, t) {
            var n;
            return e.isValid() && t.isValid() ? (t = qt(t, e), e.isBefore(t) ? n = tn(e, t) : ((n = tn(t, e)).milliseconds = -n.milliseconds, n.months = -n.months), n) : {
              milliseconds: 0,
              months: 0
            };
          }($t(s.from), $t(s.to)), (s = {}).ms = i.milliseconds, s.M = i.months), r = new Ft(s), Ht(e) && o(e, "_locale") && (r._locale = e._locale), Ht(e) && o(e, "_isValid") && (r._isValid = e._isValid), r;
        }
        function en(e, t) {
          var n = e && parseFloat(e.replace(",", "."));
          return (isNaN(n) ? 0 : n) * t;
        }
        function tn(e, t) {
          var n = {};
          return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
        }
        function nn(e, t) {
          return function (n, r) {
            var i;
            return null === r || isNaN(+r) || (C(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), i = n, n = r, r = i), rn(this, Jt(n, r), e), this;
          };
        }
        function rn(e, t, n, i) {
          var s = t._milliseconds,
            o = Wt(t._days),
            a = Wt(t._months);
          e.isValid() && (i = null == i || i, a && ze(e, Ee(e, "Month") + a * n), o && Ae(e, "Date", Ee(e, "Date") + o * n), s && e._d.setTime(e._d.valueOf() + s * n), i && r.updateOffset(e, o || a));
        }
        Jt.fn = Ft.prototype, Jt.invalid = function () {
          return Jt(NaN);
        };
        var sn = nn(1, "add"),
          on = nn(-1, "subtract");
        function an(e) {
          return "string" == typeof e || e instanceof String;
        }
        function ln(e) {
          return k(e) || u(e) || an(e) || c(e) || function (e) {
            var t = i(e),
              n = !1;
            return t && (n = 0 === e.filter(function (t) {
              return !c(t) && an(e);
            }).length), t && n;
          }(e) || function (e) {
            var t,
              n,
              r = s(e) && !a(e),
              i = !1,
              l = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"],
              c = l.length;
            for (t = 0; t < c; t += 1) n = l[t], i = i || o(e, n);
            return r && i;
          }(e) || null == e;
        }
        function cn(e) {
          var t,
            n = s(e) && !a(e),
            r = !1,
            i = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
          for (t = 0; t < i.length; t += 1) r = r || o(e, i[t]);
          return n && r;
        }
        function un(e, t) {
          if (e.date() < t.date()) return -un(t, e);
          var n = 12 * (t.year() - e.year()) + (t.month() - e.month()),
            r = e.clone().add(n, "months");
          return -(n + (t - r < 0 ? (t - r) / (r - e.clone().add(n - 1, "months")) : (t - r) / (e.clone().add(n + 1, "months") - r))) || 0;
        }
        function dn(e) {
          var t;
          return void 0 === e ? this._locale._abbr : (null != (t = vt(e)) && (this._locale = t), this);
        }
        r.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", r.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
        var hn = x("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (e) {
          return void 0 === e ? this.localeData() : this.locale(e);
        });
        function fn() {
          return this._locale;
        }
        var pn = 1e3,
          mn = 60 * pn,
          gn = 60 * mn,
          vn = 3506328 * gn;
        function yn(e, t) {
          return (e % t + t) % t;
        }
        function _n(e, t, n) {
          return e < 100 && e >= 0 ? new Date(e + 400, t, n) - vn : new Date(e, t, n).valueOf();
        }
        function wn(e, t, n) {
          return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - vn : Date.UTC(e, t, n);
        }
        function kn(e, t) {
          return t.erasAbbrRegex(e);
        }
        function bn() {
          var e,
            t,
            n,
            r,
            i,
            s = [],
            o = [],
            a = [],
            l = [],
            c = this.eras();
          for (e = 0, t = c.length; e < t; ++e) n = ue(c[e].name), r = ue(c[e].abbr), i = ue(c[e].narrow), o.push(n), s.push(r), a.push(i), l.push(n), l.push(r), l.push(i);
          this._erasRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + a.join("|") + ")", "i");
        }
        function xn(e, t) {
          I(0, [e, e.length], 0, t);
        }
        function Sn(e, t, n, r, i) {
          var s;
          return null == e ? Ge(this, r, i).year : (t > (s = qe(e, r, i)) && (t = s), Tn.call(this, e, t, n, r, i));
        }
        function Tn(e, t, n, r, i) {
          var s = Be(e, t, n, r, i),
            o = We(s.year, 0, s.dayOfYear);
          return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
        }
        I("N", 0, 0, "eraAbbr"), I("NN", 0, 0, "eraAbbr"), I("NNN", 0, 0, "eraAbbr"), I("NNNN", 0, 0, "eraName"), I("NNNNN", 0, 0, "eraNarrow"), I("y", ["y", 1], "yo", "eraYear"), I("y", ["yy", 2], 0, "eraYear"), I("y", ["yyy", 3], 0, "eraYear"), I("y", ["yyyy", 4], 0, "eraYear"), le("N", kn), le("NN", kn), le("NNN", kn), le("NNNN", function (e, t) {
          return t.erasNameRegex(e);
        }), le("NNNNN", function (e, t) {
          return t.erasNarrowRegex(e);
        }), pe(["N", "NN", "NNN", "NNNN", "NNNNN"], function (e, t, n, r) {
          var i = n._locale.erasParse(e, r, n._strict);
          i ? p(n).era = i : p(n).invalidEra = e;
        }), le("y", te), le("yy", te), le("yyy", te), le("yyyy", te), le("yo", function (e, t) {
          return t._eraYearOrdinalRegex || te;
        }), pe(["y", "yy", "yyy", "yyyy"], ye), pe(["yo"], function (e, t, n, r) {
          var i;
          n._locale._eraYearOrdinalRegex && (i = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[ye] = n._locale.eraYearOrdinalParse(e, i) : t[ye] = parseInt(e, 10);
        }), I(0, ["gg", 2], 0, function () {
          return this.weekYear() % 100;
        }), I(0, ["GG", 2], 0, function () {
          return this.isoWeekYear() % 100;
        }), xn("gggg", "weekYear"), xn("ggggg", "weekYear"), xn("GGGG", "isoWeekYear"), xn("GGGGG", "isoWeekYear"), le("G", ne), le("g", ne), le("GG", Z, V), le("gg", Z, V), le("GGGG", J, G), le("gggg", J, G), le("GGGGG", ee, q), le("ggggg", ee, q), me(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, n, r) {
          t[r.substr(0, 2)] = he(e);
        }), me(["gg", "GG"], function (e, t, n, i) {
          t[i] = r.parseTwoDigitYear(e);
        }), I("Q", 0, "Qo", "quarter"), le("Q", W), pe("Q", function (e, t) {
          t[_e] = 3 * (he(e) - 1);
        }), I("D", ["DD", 2], "Do", "date"), le("D", Z, oe), le("DD", Z, V), le("Do", function (e, t) {
          return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
        }), pe(["D", "DD"], we), pe("Do", function (e, t) {
          t[we] = he(e.match(Z)[0]);
        });
        var Cn = Re("Date", !0);
        I("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), le("DDD", X), le("DDDD", B), pe(["DDD", "DDDD"], function (e, t, n) {
          n._dayOfYear = he(e);
        }), I("m", ["mm", 2], 0, "minute"), le("m", Z, ae), le("mm", Z, V), pe(["m", "mm"], be);
        var Mn = Re("Minutes", !1);
        I("s", ["ss", 2], 0, "second"), le("s", Z, ae), le("ss", Z, V), pe(["s", "ss"], xe);
        var On,
          Dn,
          Rn = Re("Seconds", !1);
        for (I("S", 0, 0, function () {
          return ~~(this.millisecond() / 100);
        }), I(0, ["SS", 2], 0, function () {
          return ~~(this.millisecond() / 10);
        }), I(0, ["SSS", 3], 0, "millisecond"), I(0, ["SSSS", 4], 0, function () {
          return 10 * this.millisecond();
        }), I(0, ["SSSSS", 5], 0, function () {
          return 100 * this.millisecond();
        }), I(0, ["SSSSSS", 6], 0, function () {
          return 1e3 * this.millisecond();
        }), I(0, ["SSSSSSS", 7], 0, function () {
          return 1e4 * this.millisecond();
        }), I(0, ["SSSSSSSS", 8], 0, function () {
          return 1e5 * this.millisecond();
        }), I(0, ["SSSSSSSSS", 9], 0, function () {
          return 1e6 * this.millisecond();
        }), le("S", X, W), le("SS", X, V), le("SSS", X, B), On = "SSSS"; On.length <= 9; On += "S") le(On, te);
        function En(e, t) {
          t[Se] = he(1e3 * ("0." + e));
        }
        for (On = "S"; On.length <= 9; On += "S") pe(On, En);
        Dn = Re("Milliseconds", !1), I("z", 0, 0, "zoneAbbr"), I("zz", 0, 0, "zoneName");
        var An = w.prototype;
        function Ln(e) {
          return e;
        }
        An.add = sn, An.calendar = function (e, t) {
          1 === arguments.length && (arguments[0] ? ln(arguments[0]) ? (e = arguments[0], t = void 0) : cn(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
          var n = e || $t(),
            i = qt(n, this).startOf("day"),
            s = r.calendarFormat(this, i) || "sameElse",
            o = t && (M(t[s]) ? t[s].call(this, n) : t[s]);
          return this.format(o || this.localeData().calendar(s, this, $t(n)));
        }, An.clone = function () {
          return new w(this);
        }, An.diff = function (e, t, n) {
          var r, i, s;
          if (!this.isValid()) return NaN;
          if (!(r = qt(e, this)).isValid()) return NaN;
          switch (i = 6e4 * (r.utcOffset() - this.utcOffset()), t = z(t)) {
            case "year":
              s = un(this, r) / 12;
              break;
            case "month":
              s = un(this, r);
              break;
            case "quarter":
              s = un(this, r) / 3;
              break;
            case "second":
              s = (this - r) / 1e3;
              break;
            case "minute":
              s = (this - r) / 6e4;
              break;
            case "hour":
              s = (this - r) / 36e5;
              break;
            case "day":
              s = (this - r - i) / 864e5;
              break;
            case "week":
              s = (this - r - i) / 6048e5;
              break;
            default:
              s = this - r;
          }
          return n ? s : de(s);
        }, An.endOf = function (e) {
          var t, n;
          if (void 0 === (e = z(e)) || "millisecond" === e || !this.isValid()) return this;
          switch (n = this._isUTC ? wn : _n, e) {
            case "year":
              t = n(this.year() + 1, 0, 1) - 1;
              break;
            case "quarter":
              t = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
              break;
            case "month":
              t = n(this.year(), this.month() + 1, 1) - 1;
              break;
            case "week":
              t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
              break;
            case "isoWeek":
              t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
              break;
            case "day":
            case "date":
              t = n(this.year(), this.month(), this.date() + 1) - 1;
              break;
            case "hour":
              t = this._d.valueOf(), t += gn - yn(t + (this._isUTC ? 0 : this.utcOffset() * mn), gn) - 1;
              break;
            case "minute":
              t = this._d.valueOf(), t += mn - yn(t, mn) - 1;
              break;
            case "second":
              t = this._d.valueOf(), t += pn - yn(t, pn) - 1;
          }
          return this._d.setTime(t), r.updateOffset(this, !0), this;
        }, An.format = function (e) {
          e || (e = this.isUtc() ? r.defaultFormatUtc : r.defaultFormat);
          var t = P(this, e);
          return this.localeData().postformat(t);
        }, An.from = function (e, t) {
          return this.isValid() && (k(e) && e.isValid() || $t(e).isValid()) ? Jt({
            to: this,
            from: e
          }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
        }, An.fromNow = function (e) {
          return this.from($t(), e);
        }, An.to = function (e, t) {
          return this.isValid() && (k(e) && e.isValid() || $t(e).isValid()) ? Jt({
            from: this,
            to: e
          }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
        }, An.toNow = function (e) {
          return this.to($t(), e);
        }, An.get = function (e) {
          return M(this[e = z(e)]) ? this[e]() : this;
        }, An.invalidAt = function () {
          return p(this).overflow;
        }, An.isAfter = function (e, t) {
          var n = k(e) ? e : $t(e);
          return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = z(t) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf());
        }, An.isBefore = function (e, t) {
          var n = k(e) ? e : $t(e);
          return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = z(t) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf());
        }, An.isBetween = function (e, t, n, r) {
          var i = k(e) ? e : $t(e),
            s = k(t) ? t : $t(t);
          return !!(this.isValid() && i.isValid() && s.isValid()) && ("(" === (r = r || "()")[0] ? this.isAfter(i, n) : !this.isBefore(i, n)) && (")" === r[1] ? this.isBefore(s, n) : !this.isAfter(s, n));
        }, An.isSame = function (e, t) {
          var n,
            r = k(e) ? e : $t(e);
          return !(!this.isValid() || !r.isValid()) && ("millisecond" === (t = z(t) || "millisecond") ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()));
        }, An.isSameOrAfter = function (e, t) {
          return this.isSame(e, t) || this.isAfter(e, t);
        }, An.isSameOrBefore = function (e, t) {
          return this.isSame(e, t) || this.isBefore(e, t);
        }, An.isValid = function () {
          return m(this);
        }, An.lang = hn, An.locale = dn, An.localeData = fn, An.max = Ut, An.min = Pt, An.parsingFlags = function () {
          return h({}, p(this));
        }, An.set = function (e, t) {
          if ("object" == typeof e) {
            var n,
              r = function (e) {
                var t,
                  n = [];
                for (t in e) o(e, t) && n.push({
                  unit: t,
                  priority: F[t]
                });
                return n.sort(function (e, t) {
                  return e.priority - t.priority;
                }), n;
              }(e = j(e)),
              i = r.length;
            for (n = 0; n < i; n++) this[r[n].unit](e[r[n].unit]);
          } else if (M(this[e = z(e)])) return this[e](t);
          return this;
        }, An.startOf = function (e) {
          var t, n;
          if (void 0 === (e = z(e)) || "millisecond" === e || !this.isValid()) return this;
          switch (n = this._isUTC ? wn : _n, e) {
            case "year":
              t = n(this.year(), 0, 1);
              break;
            case "quarter":
              t = n(this.year(), this.month() - this.month() % 3, 1);
              break;
            case "month":
              t = n(this.year(), this.month(), 1);
              break;
            case "week":
              t = n(this.year(), this.month(), this.date() - this.weekday());
              break;
            case "isoWeek":
              t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
              break;
            case "day":
            case "date":
              t = n(this.year(), this.month(), this.date());
              break;
            case "hour":
              t = this._d.valueOf(), t -= yn(t + (this._isUTC ? 0 : this.utcOffset() * mn), gn);
              break;
            case "minute":
              t = this._d.valueOf(), t -= yn(t, mn);
              break;
            case "second":
              t = this._d.valueOf(), t -= yn(t, pn);
          }
          return this._d.setTime(t), r.updateOffset(this, !0), this;
        }, An.subtract = on, An.toArray = function () {
          var e = this;
          return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
        }, An.toObject = function () {
          var e = this;
          return {
            years: e.year(),
            months: e.month(),
            date: e.date(),
            hours: e.hours(),
            minutes: e.minutes(),
            seconds: e.seconds(),
            milliseconds: e.milliseconds()
          };
        }, An.toDate = function () {
          return new Date(this.valueOf());
        }, An.toISOString = function (e) {
          if (!this.isValid()) return null;
          var t = !0 !== e,
            n = t ? this.clone().utc() : this;
          return n.year() < 0 || n.year() > 9999 ? P(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : M(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", P(n, "Z")) : P(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
        }, An.inspect = function () {
          if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
          var e,
            t,
            n,
            r = "moment",
            i = "";
          return this.isLocal() || (r = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", i = "Z"), e = "[" + r + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", "-MM-DD[T]HH:mm:ss.SSS", n = i + '[")]', this.format(e + t + "-MM-DD[T]HH:mm:ss.SSS" + n);
        }, "undefined" != typeof Symbol && null != Symbol.for && (An[Symbol.for("nodejs.util.inspect.custom")] = function () {
          return "Moment<" + this.format() + ">";
        }), An.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }, An.toString = function () {
          return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
        }, An.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }, An.valueOf = function () {
          return this._d.valueOf() - 6e4 * (this._offset || 0);
        }, An.creationData = function () {
          return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
          };
        }, An.eraName = function () {
          var e,
            t,
            n,
            r = this.localeData().eras();
          for (e = 0, t = r.length; e < t; ++e) {
            if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until) return r[e].name;
            if (r[e].until <= n && n <= r[e].since) return r[e].name;
          }
          return "";
        }, An.eraNarrow = function () {
          var e,
            t,
            n,
            r = this.localeData().eras();
          for (e = 0, t = r.length; e < t; ++e) {
            if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until) return r[e].narrow;
            if (r[e].until <= n && n <= r[e].since) return r[e].narrow;
          }
          return "";
        }, An.eraAbbr = function () {
          var e,
            t,
            n,
            r = this.localeData().eras();
          for (e = 0, t = r.length; e < t; ++e) {
            if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until) return r[e].abbr;
            if (r[e].until <= n && n <= r[e].since) return r[e].abbr;
          }
          return "";
        }, An.eraYear = function () {
          var e,
            t,
            n,
            i,
            s = this.localeData().eras();
          for (e = 0, t = s.length; e < t; ++e) if (n = s[e].since <= s[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), s[e].since <= i && i <= s[e].until || s[e].until <= i && i <= s[e].since) return (this.year() - r(s[e].since).year()) * n + s[e].offset;
          return this.year();
        }, An.year = De, An.isLeapYear = function () {
          return ve(this.year());
        }, An.weekYear = function (e) {
          return Sn.call(this, e, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
        }, An.isoWeekYear = function (e) {
          return Sn.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
        }, An.quarter = An.quarters = function (e) {
          return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
        }, An.month = je, An.daysInMonth = function () {
          return Le(this.year(), this.month());
        }, An.week = An.weeks = function (e) {
          var t = this.localeData().week(this);
          return null == e ? t : this.add(7 * (e - t), "d");
        }, An.isoWeek = An.isoWeeks = function (e) {
          var t = Ge(this, 1, 4).week;
          return null == e ? t : this.add(7 * (e - t), "d");
        }, An.weeksInYear = function () {
          var e = this.localeData()._week;
          return qe(this.year(), e.dow, e.doy);
        }, An.weeksInWeekYear = function () {
          var e = this.localeData()._week;
          return qe(this.weekYear(), e.dow, e.doy);
        }, An.isoWeeksInYear = function () {
          return qe(this.year(), 1, 4);
        }, An.isoWeeksInISOWeekYear = function () {
          return qe(this.isoWeekYear(), 1, 4);
        }, An.date = Cn, An.day = An.days = function (e) {
          if (!this.isValid()) return null != e ? this : NaN;
          var t = Ee(this, "Day");
          return null != e ? (e = function (e, t) {
            return "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = t.weekdaysParse(e)) ? e : null : parseInt(e, 10);
          }(e, this.localeData()), this.add(e - t, "d")) : t;
        }, An.weekday = function (e) {
          if (!this.isValid()) return null != e ? this : NaN;
          var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
          return null == e ? t : this.add(e - t, "d");
        }, An.isoWeekday = function (e) {
          if (!this.isValid()) return null != e ? this : NaN;
          if (null != e) {
            var t = function (e, t) {
              return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
            }(e, this.localeData());
            return this.day(this.day() % 7 ? t : t - 7);
          }
          return this.day() || 7;
        }, An.dayOfYear = function (e) {
          var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
          return null == e ? t : this.add(e - t, "d");
        }, An.hour = An.hours = at, An.minute = An.minutes = Mn, An.second = An.seconds = Rn, An.millisecond = An.milliseconds = Dn, An.utcOffset = function (e, t, n) {
          var i,
            s = this._offset || 0;
          if (!this.isValid()) return null != e ? this : NaN;
          if (null != e) {
            if ("string" == typeof e) {
              if (null === (e = Gt(ie, e))) return this;
            } else Math.abs(e) < 16 && !n && (e *= 60);
            return !this._isUTC && t && (i = Zt(this)), this._offset = e, this._isUTC = !0, null != i && this.add(i, "m"), s !== e && (!t || this._changeInProgress ? rn(this, Jt(e - s, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, r.updateOffset(this, !0), this._changeInProgress = null)), this;
          }
          return this._isUTC ? s : Zt(this);
        }, An.utc = function (e) {
          return this.utcOffset(0, e);
        }, An.local = function (e) {
          return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Zt(this), "m")), this;
        }, An.parseZone = function () {
          if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
            var e = Gt(re, this._i);
            null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
          }
          return this;
        }, An.hasAlignedHourOffset = function (e) {
          return !!this.isValid() && (e = e ? $t(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
        }, An.isDST = function () {
          return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
        }, An.isLocal = function () {
          return !!this.isValid() && !this._isUTC;
        }, An.isUtcOffset = function () {
          return !!this.isValid() && this._isUTC;
        }, An.isUtc = Qt, An.isUTC = Qt, An.zoneAbbr = function () {
          return this._isUTC ? "UTC" : "";
        }, An.zoneName = function () {
          return this._isUTC ? "Coordinated Universal Time" : "";
        }, An.dates = x("dates accessor is deprecated. Use date instead.", Cn), An.months = x("months accessor is deprecated. Use month instead", je), An.years = x("years accessor is deprecated. Use year instead", De), An.zone = x("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (e, t) {
          return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
        }), An.isDSTShifted = x("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
          if (!l(this._isDSTShifted)) return this._isDSTShifted;
          var e,
            t = {};
          return _(t, this), (t = Nt(t))._a ? (e = t._isUTC ? f(t._a) : $t(t._a), this._isDSTShifted = this.isValid() && function (e, t, n) {
            var r,
              i = Math.min(e.length, t.length),
              s = Math.abs(e.length - t.length),
              o = 0;
            for (r = 0; r < i; r++) (n && e[r] !== t[r] || !n && he(e[r]) !== he(t[r])) && o++;
            return o + s;
          }(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
        });
        var Nn = D.prototype;
        function In(e, t, n, r) {
          var i = vt(),
            s = f().set(r, t);
          return i[n](s, e);
        }
        function $n(e, t, n) {
          if (c(e) && (t = e, e = void 0), e = e || "", null != t) return In(e, t, n, "month");
          var r,
            i = [];
          for (r = 0; r < 12; r++) i[r] = In(e, r, n, "month");
          return i;
        }
        function Pn(e, t, n, r) {
          "boolean" == typeof e ? (c(t) && (n = t, t = void 0), t = t || "") : (n = t = e, e = !1, c(t) && (n = t, t = void 0), t = t || "");
          var i,
            s = vt(),
            o = e ? s._week.dow : 0,
            a = [];
          if (null != n) return In(t, (n + o) % 7, r, "day");
          for (i = 0; i < 7; i++) a[i] = In(t, (i + o) % 7, r, "day");
          return a;
        }
        Nn.calendar = function (e, t, n) {
          var r = this._calendar[e] || this._calendar.sameElse;
          return M(r) ? r.call(t, n) : r;
        }, Nn.longDateFormat = function (e) {
          var t = this._longDateFormat[e],
            n = this._longDateFormat[e.toUpperCase()];
          return t || !n ? t : (this._longDateFormat[e] = n.match(E).map(function (e) {
            return "MMMM" === e || "MM" === e || "DD" === e || "dddd" === e ? e.slice(1) : e;
          }).join(""), this._longDateFormat[e]);
        }, Nn.invalidDate = function () {
          return this._invalidDate;
        }, Nn.ordinal = function (e) {
          return this._ordinal.replace("%d", e);
        }, Nn.preparse = Ln, Nn.postformat = Ln, Nn.relativeTime = function (e, t, n, r) {
          var i = this._relativeTime[n];
          return M(i) ? i(e, t, n, r) : i.replace(/%d/i, e);
        }, Nn.pastFuture = function (e, t) {
          var n = this._relativeTime[e > 0 ? "future" : "past"];
          return M(n) ? n(t) : n.replace(/%s/i, t);
        }, Nn.set = function (e) {
          var t, n;
          for (n in e) o(e, n) && (M(t = e[n]) ? this[n] = t : this["_" + n] = t);
          this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
        }, Nn.eras = function (e, t) {
          var n,
            i,
            s,
            o = this._eras || vt("en")._eras;
          for (n = 0, i = o.length; n < i; ++n) switch ("string" == typeof o[n].since && (s = r(o[n].since).startOf("day"), o[n].since = s.valueOf()), typeof o[n].until) {
            case "undefined":
              o[n].until = 1 / 0;
              break;
            case "string":
              s = r(o[n].until).startOf("day").valueOf(), o[n].until = s.valueOf();
          }
          return o;
        }, Nn.erasParse = function (e, t, n) {
          var r,
            i,
            s,
            o,
            a,
            l = this.eras();
          for (e = e.toUpperCase(), r = 0, i = l.length; r < i; ++r) if (s = l[r].name.toUpperCase(), o = l[r].abbr.toUpperCase(), a = l[r].narrow.toUpperCase(), n) switch (t) {
            case "N":
            case "NN":
            case "NNN":
              if (o === e) return l[r];
              break;
            case "NNNN":
              if (s === e) return l[r];
              break;
            case "NNNNN":
              if (a === e) return l[r];
          } else if ([s, o, a].indexOf(e) >= 0) return l[r];
        }, Nn.erasConvertYear = function (e, t) {
          var n = e.since <= e.until ? 1 : -1;
          return void 0 === t ? r(e.since).year() : r(e.since).year() + (t - e.offset) * n;
        }, Nn.erasAbbrRegex = function (e) {
          return o(this, "_erasAbbrRegex") || bn.call(this), e ? this._erasAbbrRegex : this._erasRegex;
        }, Nn.erasNameRegex = function (e) {
          return o(this, "_erasNameRegex") || bn.call(this), e ? this._erasNameRegex : this._erasRegex;
        }, Nn.erasNarrowRegex = function (e) {
          return o(this, "_erasNarrowRegex") || bn.call(this), e ? this._erasNarrowRegex : this._erasRegex;
        }, Nn.months = function (e, t) {
          return e ? i(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || $e).test(t) ? "format" : "standalone"][e.month()] : i(this._months) ? this._months : this._months.standalone;
        }, Nn.monthsShort = function (e, t) {
          return e ? i(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[$e.test(t) ? "format" : "standalone"][e.month()] : i(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
        }, Nn.monthsParse = function (e, t, n) {
          var r, i, s;
          if (this._monthsParseExact) return Ye.call(this, e, t, n);
          for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
            if (i = f([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp("^" + this.months(i, "").replace(".", "") + "$", "i"), this._shortMonthsParse[r] = new RegExp("^" + this.monthsShort(i, "").replace(".", "") + "$", "i")), n || this._monthsParse[r] || (s = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[r] = new RegExp(s.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[r].test(e)) return r;
            if (n && "MMM" === t && this._shortMonthsParse[r].test(e)) return r;
            if (!n && this._monthsParse[r].test(e)) return r;
          }
        }, Nn.monthsRegex = function (e) {
          return this._monthsParseExact ? (o(this, "_monthsRegex") || Fe.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (o(this, "_monthsRegex") || (this._monthsRegex = Ue), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
        }, Nn.monthsShortRegex = function (e) {
          return this._monthsParseExact ? (o(this, "_monthsRegex") || Fe.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (o(this, "_monthsShortRegex") || (this._monthsShortRegex = Pe), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
        }, Nn.week = function (e) {
          return Ge(e, this._week.dow, this._week.doy).week;
        }, Nn.firstDayOfYear = function () {
          return this._week.doy;
        }, Nn.firstDayOfWeek = function () {
          return this._week.dow;
        }, Nn.weekdays = function (e, t) {
          var n = i(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
          return !0 === e ? Ze(n, this._week.dow) : e ? n[e.day()] : n;
        }, Nn.weekdaysMin = function (e) {
          return !0 === e ? Ze(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
        }, Nn.weekdaysShort = function (e) {
          return !0 === e ? Ze(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
        }, Nn.weekdaysParse = function (e, t, n) {
          var r, i, s;
          if (this._weekdaysParseExact) return nt.call(this, e, t, n);
          for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
            if (i = f([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp("^" + this.weekdays(i, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[r] = new RegExp("^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[r] = new RegExp("^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[r] || (s = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[r] = new RegExp(s.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[r].test(e)) return r;
            if (n && "ddd" === t && this._shortWeekdaysParse[r].test(e)) return r;
            if (n && "dd" === t && this._minWeekdaysParse[r].test(e)) return r;
            if (!n && this._weekdaysParse[r].test(e)) return r;
          }
        }, Nn.weekdaysRegex = function (e) {
          return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || rt.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (o(this, "_weekdaysRegex") || (this._weekdaysRegex = Je), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
        }, Nn.weekdaysShortRegex = function (e) {
          return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || rt.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (o(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = et), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
        }, Nn.weekdaysMinRegex = function (e) {
          return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || rt.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (o(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = tt), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
        }, Nn.isPM = function (e) {
          return "p" === (e + "").toLowerCase().charAt(0);
        }, Nn.meridiem = function (e, t, n) {
          return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
        }, mt("en", {
          eras: [{
            since: "0001-01-01",
            until: 1 / 0,
            offset: 1,
            name: "Anno Domini",
            narrow: "AD",
            abbr: "AD"
          }, {
            since: "0000-12-31",
            until: -1 / 0,
            offset: 1,
            name: "Before Christ",
            narrow: "BC",
            abbr: "BC"
          }],
          dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
          ordinal: function (e) {
            var t = e % 10;
            return e + (1 === he(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
          }
        }), r.lang = x("moment.lang is deprecated. Use moment.locale instead.", mt), r.langData = x("moment.langData is deprecated. Use moment.localeData instead.", vt);
        var Un = Math.abs;
        function Yn(e, t, n, r) {
          var i = Jt(t, n);
          return e._milliseconds += r * i._milliseconds, e._days += r * i._days, e._months += r * i._months, e._bubble();
        }
        function zn(e) {
          return e < 0 ? Math.floor(e) : Math.ceil(e);
        }
        function jn(e) {
          return 4800 * e / 146097;
        }
        function Fn(e) {
          return 146097 * e / 4800;
        }
        function Hn(e) {
          return function () {
            return this.as(e);
          };
        }
        var Wn = Hn("ms"),
          Vn = Hn("s"),
          Bn = Hn("m"),
          Gn = Hn("h"),
          qn = Hn("d"),
          Zn = Hn("w"),
          Qn = Hn("M"),
          Kn = Hn("Q"),
          Xn = Hn("y"),
          Jn = Wn;
        function er(e) {
          return function () {
            return this.isValid() ? this._data[e] : NaN;
          };
        }
        var tr = er("milliseconds"),
          nr = er("seconds"),
          rr = er("minutes"),
          ir = er("hours"),
          sr = er("days"),
          or = er("months"),
          ar = er("years");
        var lr = Math.round,
          cr = {
            ss: 44,
            s: 45,
            m: 45,
            h: 22,
            d: 26,
            w: null,
            M: 11
          };
        function ur(e, t, n, r, i) {
          return i.relativeTime(t || 1, !!n, e, r);
        }
        var dr = Math.abs;
        function hr(e) {
          return (e > 0) - (e < 0) || +e;
        }
        function fr() {
          if (!this.isValid()) return this.localeData().invalidDate();
          var e,
            t,
            n,
            r,
            i,
            s,
            o,
            a,
            l = dr(this._milliseconds) / 1e3,
            c = dr(this._days),
            u = dr(this._months),
            d = this.asSeconds();
          return d ? (e = de(l / 60), t = de(e / 60), l %= 60, e %= 60, n = de(u / 12), u %= 12, r = l ? l.toFixed(3).replace(/\.?0+$/, "") : "", i = d < 0 ? "-" : "", s = hr(this._months) !== hr(d) ? "-" : "", o = hr(this._days) !== hr(d) ? "-" : "", a = hr(this._milliseconds) !== hr(d) ? "-" : "", i + "P" + (n ? s + n + "Y" : "") + (u ? s + u + "M" : "") + (c ? o + c + "D" : "") + (t || e || l ? "T" : "") + (t ? a + t + "H" : "") + (e ? a + e + "M" : "") + (l ? a + r + "S" : "")) : "P0D";
        }
        var pr = Ft.prototype;
        return pr.isValid = function () {
          return this._isValid;
        }, pr.abs = function () {
          var e = this._data;
          return this._milliseconds = Un(this._milliseconds), this._days = Un(this._days), this._months = Un(this._months), e.milliseconds = Un(e.milliseconds), e.seconds = Un(e.seconds), e.minutes = Un(e.minutes), e.hours = Un(e.hours), e.months = Un(e.months), e.years = Un(e.years), this;
        }, pr.add = function (e, t) {
          return Yn(this, e, t, 1);
        }, pr.subtract = function (e, t) {
          return Yn(this, e, t, -1);
        }, pr.as = function (e) {
          if (!this.isValid()) return NaN;
          var t,
            n,
            r = this._milliseconds;
          if ("month" === (e = z(e)) || "quarter" === e || "year" === e) switch (t = this._days + r / 864e5, n = this._months + jn(t), e) {
            case "month":
              return n;
            case "quarter":
              return n / 3;
            case "year":
              return n / 12;
          } else switch (t = this._days + Math.round(Fn(this._months)), e) {
            case "week":
              return t / 7 + r / 6048e5;
            case "day":
              return t + r / 864e5;
            case "hour":
              return 24 * t + r / 36e5;
            case "minute":
              return 1440 * t + r / 6e4;
            case "second":
              return 86400 * t + r / 1e3;
            case "millisecond":
              return Math.floor(864e5 * t) + r;
            default:
              throw new Error("Unknown unit " + e);
          }
        }, pr.asMilliseconds = Wn, pr.asSeconds = Vn, pr.asMinutes = Bn, pr.asHours = Gn, pr.asDays = qn, pr.asWeeks = Zn, pr.asMonths = Qn, pr.asQuarters = Kn, pr.asYears = Xn, pr.valueOf = Jn, pr._bubble = function () {
          var e,
            t,
            n,
            r,
            i,
            s = this._milliseconds,
            o = this._days,
            a = this._months,
            l = this._data;
          return s >= 0 && o >= 0 && a >= 0 || s <= 0 && o <= 0 && a <= 0 || (s += 864e5 * zn(Fn(a) + o), o = 0, a = 0), l.milliseconds = s % 1e3, e = de(s / 1e3), l.seconds = e % 60, t = de(e / 60), l.minutes = t % 60, n = de(t / 60), l.hours = n % 24, o += de(n / 24), a += i = de(jn(o)), o -= zn(Fn(i)), r = de(a / 12), a %= 12, l.days = o, l.months = a, l.years = r, this;
        }, pr.clone = function () {
          return Jt(this);
        }, pr.get = function (e) {
          return e = z(e), this.isValid() ? this[e + "s"]() : NaN;
        }, pr.milliseconds = tr, pr.seconds = nr, pr.minutes = rr, pr.hours = ir, pr.days = sr, pr.weeks = function () {
          return de(this.days() / 7);
        }, pr.months = or, pr.years = ar, pr.humanize = function (e, t) {
          if (!this.isValid()) return this.localeData().invalidDate();
          var n,
            r,
            i = !1,
            s = cr;
          return "object" == typeof e && (t = e, e = !1), "boolean" == typeof e && (i = e), "object" == typeof t && (s = Object.assign({}, cr, t), null != t.s && null == t.ss && (s.ss = t.s - 1)), r = function (e, t, n, r) {
            var i = Jt(e).abs(),
              s = lr(i.as("s")),
              o = lr(i.as("m")),
              a = lr(i.as("h")),
              l = lr(i.as("d")),
              c = lr(i.as("M")),
              u = lr(i.as("w")),
              d = lr(i.as("y")),
              h = s <= n.ss && ["s", s] || s < n.s && ["ss", s] || o <= 1 && ["m"] || o < n.m && ["mm", o] || a <= 1 && ["h"] || a < n.h && ["hh", a] || l <= 1 && ["d"] || l < n.d && ["dd", l];
            return null != n.w && (h = h || u <= 1 && ["w"] || u < n.w && ["ww", u]), (h = h || c <= 1 && ["M"] || c < n.M && ["MM", c] || d <= 1 && ["y"] || ["yy", d])[2] = t, h[3] = +e > 0, h[4] = r, ur.apply(null, h);
          }(this, !i, s, n = this.localeData()), i && (r = n.pastFuture(+this, r)), n.postformat(r);
        }, pr.toISOString = fr, pr.toString = fr, pr.toJSON = fr, pr.locale = dn, pr.localeData = fn, pr.toIsoString = x("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", fr), pr.lang = hn, I("X", 0, 0, "unix"), I("x", 0, 0, "valueOf"), le("x", ne), le("X", /[+-]?\d+(\.\d{1,3})?/), pe("X", function (e, t, n) {
          n._d = new Date(1e3 * parseFloat(e));
        }), pe("x", function (e, t, n) {
          n._d = new Date(he(e));
        }),
        //! moment.js
        r.version = "2.30.1", function (e) {
          t = e;
        }($t), r.fn = An, r.min = function () {
          return Yt("isBefore", [].slice.call(arguments, 0));
        }, r.max = function () {
          return Yt("isAfter", [].slice.call(arguments, 0));
        }, r.now = function () {
          return Date.now ? Date.now() : +new Date();
        }, r.utc = f, r.unix = function (e) {
          return $t(1e3 * e);
        }, r.months = function (e, t) {
          return $n(e, t, "months");
        }, r.isDate = u, r.locale = mt, r.invalid = g, r.duration = Jt, r.isMoment = k, r.weekdays = function (e, t, n) {
          return Pn(e, t, n, "weekdays");
        }, r.parseZone = function () {
          return $t.apply(null, arguments).parseZone();
        }, r.localeData = vt, r.isDuration = Ht, r.monthsShort = function (e, t) {
          return $n(e, t, "monthsShort");
        }, r.weekdaysMin = function (e, t, n) {
          return Pn(e, t, n, "weekdaysMin");
        }, r.defineLocale = gt, r.updateLocale = function (e, t) {
          if (null != t) {
            var n,
              r,
              i = ct;
            null != ut[e] && null != ut[e].parentLocale ? ut[e].set(O(ut[e]._config, t)) : (null != (r = pt(e)) && (i = r._config), t = O(i, t), null == r && (t.abbr = e), (n = new D(t)).parentLocale = ut[e], ut[e] = n), mt(e);
          } else null != ut[e] && (null != ut[e].parentLocale ? (ut[e] = ut[e].parentLocale, e === mt() && mt(e)) : null != ut[e] && delete ut[e]);
          return ut[e];
        }, r.locales = function () {
          return S(ut);
        }, r.weekdaysShort = function (e, t, n) {
          return Pn(e, t, n, "weekdaysShort");
        }, r.normalizeUnits = z, r.relativeTimeRounding = function (e) {
          return void 0 === e ? lr : "function" == typeof e && (lr = e, !0);
        }, r.relativeTimeThreshold = function (e, t) {
          return void 0 !== cr[e] && (void 0 === t ? cr[e] : (cr[e] = t, "s" === e && (cr.ss = t - 1), !0));
        }, r.calendarFormat = function (e, t) {
          var n = e.diff(t, "days", !0);
          return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
        }, r.prototype = An, r.HTML5_FMT = {
          DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
          DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
          DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
          DATE: "YYYY-MM-DD",
          TIME: "HH:mm",
          TIME_SECONDS: "HH:mm:ss",
          TIME_MS: "HH:mm:ss.SSS",
          WEEK: "GGGG-[W]WW",
          MONTH: "YYYY-MM"
        }, r;
      }();
    }),
    Ua = Pa;
  const Ya = ["data-index"],
    za = ["src", "title", "onClick"];
  var ja = Bn({
      __name: "ImageWall",
      props: {
        items: {
          default: () => []
        },
        columnWidth: {
          default: 300
        },
        gap: {
          default: 0
        }
      },
      emits: ["insert"],
      setup(e, t) {
        let {
          expose: n
        } = t;
        const r = e;
        n();
        let i = null;
        const s = Jt(null),
          o = Jt({}),
          a = Jt([]),
          l = () => {
            const e = Math.floor((s.value.getBoundingClientRect().width + r.gap) / (r.columnWidth + r.gap));
            return e > 0 ? e : 1;
          },
          c = e => new Array(e).fill(null).map(() => []),
          u = async e => {
            var _s$value;
            if (e >= r.items.length) return;
            await kn();
            const t = Array.from(((_s$value = s.value) === null || _s$value === void 0 ? void 0 : _s$value.children) || []).reduce((e, t) => t.getBoundingClientRect().height < e.getBoundingClientRect().height ? t : e);
            a.value[Number(t.dataset.index)].push(e), await u(e + 1);
          },
          d = async function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            if (a.value.length === l() && !e) return;
            a.value = c(l());
            const t = window.scrollY;
            await u(0), window.scrollTo({
              top: t
            });
          },
          h = e => {
            o.value[e.target.src] = !0;
          };
        return Qn(() => {
          d(!0), i = new ResizeObserver(() => {
            d();
          }), i.observe(s.value), Hn(() => [r.items], () => {
            o.value = {}, d(!0);
          }), Hn(() => [r.columnWidth, r.gap], () => {
            d();
          });
        }), Kn(() => i.unobserve(s.value)), (t, n) => (Wr(), qr("div", {
          ref_key: "wall",
          ref: s,
          class: "wl-gallery",
          style: $({
            gap: `${e.gap}px`
          })
        }, [(Wr(!0), qr(Ur, null, ir(a.value, (n, r) => (Wr(), qr("div", {
          key: r,
          class: "wl-gallery-column",
          "data-index": r,
          style: $({
            gap: `${e.gap}px`
          })
        }, [(Wr(!0), qr(Ur, null, ir(n, n => (Wr(), qr(Ur, {
          key: n
        }, [o.value[e.items[n].src] ? si("v-if", !0) : (Wr(), Zr(rn(aa), {
          key: 0,
          size: 36,
          style: {
            margin: "20px auto"
          }
        })), ti("img", {
          class: "wl-gallery-item",
          src: e.items[n].src,
          title: e.items[n].title,
          loading: "lazy",
          onLoad: h,
          onClick: r => t.$emit("insert", `![](${e.items[n].src})`)
        }, null, 40, za)], 64))), 128))], 12, Ya))), 128))], 4));
      }
    }),
    Fa = Ra(ja, [["__file", "ImageWall.vue"]]),
    Ha = ha(function (e, t) {
      e.exports = function () {
        const {
          entries: e,
          setPrototypeOf: t,
          isFrozen: n,
          getPrototypeOf: r,
          getOwnPropertyDescriptor: i
        } = Object;
        let {
            freeze: s,
            seal: o,
            create: a
          } = Object,
          {
            apply: l,
            construct: c
          } = "undefined" != typeof Reflect && Reflect;
        s || (s = function (e) {
          return e;
        }), o || (o = function (e) {
          return e;
        }), l || (l = function (e, t, n) {
          return e.apply(t, n);
        }), c || (c = function (e, t) {
          return new e(...t);
        });
        const u = b(Array.prototype.forEach),
          d = b(Array.prototype.pop),
          h = b(Array.prototype.push),
          f = b(String.prototype.toLowerCase),
          p = b(String.prototype.toString),
          m = b(String.prototype.match),
          g = b(String.prototype.replace),
          v = b(String.prototype.indexOf),
          y = b(String.prototype.trim),
          _ = b(Object.prototype.hasOwnProperty),
          w = b(RegExp.prototype.test),
          k = function (e) {
            return function () {
              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              return c(e, n);
            };
          }(TypeError);
        function b(e) {
          return function (t) {
            for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
            return l(e, t, r);
          };
        }
        function x(e, r) {
          let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : f;
          t && t(e, null);
          let s = r.length;
          for (; s--;) {
            let t = r[s];
            if ("string" == typeof t) {
              const e = i(t);
              e !== t && (n(r) || (r[s] = e), t = e);
            }
            e[t] = !0;
          }
          return e;
        }
        function S(e) {
          for (let t = 0; t < e.length; t++) _(e, t) || (e[t] = null);
          return e;
        }
        function T(t) {
          const n = a(null);
          for (const [r, i] of e(t)) _(t, r) && (Array.isArray(i) ? n[r] = S(i) : i && "object" == typeof i && i.constructor === Object ? n[r] = T(i) : n[r] = i);
          return n;
        }
        function C(e, t) {
          for (; null !== e;) {
            const n = i(e, t);
            if (n) {
              if (n.get) return b(n.get);
              if ("function" == typeof n.value) return b(n.value);
            }
            e = r(e);
          }
          return function () {
            return null;
          };
        }
        const M = s(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
          O = s(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
          D = s(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
          R = s(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
          E = s(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
          A = s(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
          L = s(["#text"]),
          N = s(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]),
          I = s(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
          $ = s(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
          P = s(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
          U = o(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
          Y = o(/<%[\w\W]*|[\w\W]*%>/gm),
          z = o(/\${[\w\W]*}/gm),
          j = o(/^data-[\-\w.\u00B7-\uFFFF]/),
          F = o(/^aria-[\-\w]+$/),
          H = o(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
          W = o(/^(?:\w+script|data):/i),
          V = o(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
          B = o(/^html$/i),
          G = o(/^[a-z][.\w]*(-[.\w]+)+$/i);
        var q = Object.freeze({
          __proto__: null,
          ARIA_ATTR: F,
          ATTR_WHITESPACE: V,
          CUSTOM_ELEMENT: G,
          DATA_ATTR: j,
          DOCTYPE_NAME: B,
          ERB_EXPR: Y,
          IS_ALLOWED_URI: H,
          IS_SCRIPT_OR_DATA: W,
          MUSTACHE_EXPR: U,
          TMPLIT_EXPR: z
        });
        const Z = {
            element: 1,
            attribute: 2,
            text: 3,
            cdataSection: 4,
            entityReference: 5,
            entityNode: 6,
            progressingInstruction: 7,
            comment: 8,
            document: 9,
            documentType: 10,
            documentFragment: 11,
            notation: 12
          },
          Q = function () {
            return "undefined" == typeof window ? null : window;
          },
          K = function (e, t) {
            if ("object" != typeof e || "function" != typeof e.createPolicy) return null;
            let n = null;
            const r = "data-tt-policy-suffix";
            t && t.hasAttribute(r) && (n = t.getAttribute(r));
            const i = "dompurify" + (n ? "#" + n : "");
            try {
              return e.createPolicy(i, {
                createHTML: e => e,
                createScriptURL: e => e
              });
            } catch (e) {
              return console.warn("TrustedTypes policy " + i + " could not be created."), null;
            }
          };
        var X = function t() {
          let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Q();
          const r = e => t(e);
          if (r.version = "3.2.1", r.removed = [], !n || !n.document || n.document.nodeType !== Z.document) return r.isSupported = !1, r;
          let {
            document: i
          } = n;
          const o = i,
            l = o.currentScript,
            {
              DocumentFragment: c,
              HTMLTemplateElement: b,
              Node: S,
              Element: U,
              NodeFilter: Y,
              NamedNodeMap: z = n.NamedNodeMap || n.MozNamedAttrMap,
              HTMLFormElement: j,
              DOMParser: F,
              trustedTypes: W
            } = n,
            V = U.prototype,
            G = C(V, "cloneNode"),
            X = C(V, "remove"),
            J = C(V, "nextSibling"),
            ee = C(V, "childNodes"),
            te = C(V, "parentNode");
          if ("function" == typeof b) {
            const e = i.createElement("template");
            e.content && e.content.ownerDocument && (i = e.content.ownerDocument);
          }
          let ne,
            re = "";
          const {
              implementation: ie,
              createNodeIterator: se,
              createDocumentFragment: oe,
              getElementsByTagName: ae
            } = i,
            {
              importNode: le
            } = o;
          let ce = {};
          r.isSupported = "function" == typeof e && "function" == typeof te && ie && void 0 !== ie.createHTMLDocument;
          const {
            MUSTACHE_EXPR: ue,
            ERB_EXPR: de,
            TMPLIT_EXPR: he,
            DATA_ATTR: fe,
            ARIA_ATTR: pe,
            IS_SCRIPT_OR_DATA: me,
            ATTR_WHITESPACE: ge,
            CUSTOM_ELEMENT: ve
          } = q;
          let {
              IS_ALLOWED_URI: ye
            } = q,
            _e = null;
          const we = x({}, [...M, ...O, ...D, ...E, ...L]);
          let ke = null;
          const be = x({}, [...N, ...I, ...$, ...P]);
          let xe = Object.seal(a(null, {
              tagNameCheck: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: null
              },
              attributeNameCheck: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: null
              },
              allowCustomizedBuiltInElements: {
                writable: !0,
                configurable: !1,
                enumerable: !0,
                value: !1
              }
            })),
            Se = null,
            Te = null,
            Ce = !0,
            Me = !0,
            Oe = !1,
            De = !0,
            Re = !1,
            Ee = !0,
            Ae = !1,
            Le = !1,
            Ne = !1,
            Ie = !1,
            $e = !1,
            Pe = !1,
            Ue = !0,
            Ye = !1,
            ze = !0,
            je = !1,
            Fe = {},
            He = null;
          const We = x({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
          let Ve = null;
          const Be = x({}, ["audio", "video", "img", "source", "image", "track"]);
          let Ge = null;
          const qe = x({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
            Ze = "http://www.w3.org/1998/Math/MathML",
            Qe = "http://www.w3.org/2000/svg",
            Ke = "http://www.w3.org/1999/xhtml";
          let Xe = Ke,
            Je = !1,
            et = null;
          const tt = x({}, [Ze, Qe, Ke], p);
          let nt = x({}, ["mi", "mo", "mn", "ms", "mtext"]),
            rt = x({}, ["annotation-xml"]);
          const it = x({}, ["title", "style", "font", "a", "script"]);
          let st = null;
          const ot = ["application/xhtml+xml", "text/html"],
            at = "text/html";
          let lt = null,
            ct = null;
          const ut = i.createElement("form"),
            dt = function (e) {
              return e instanceof RegExp || e instanceof Function;
            },
            ht = function () {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              if (!ct || ct !== e) {
                if (e && "object" == typeof e || (e = {}), e = T(e), st = -1 === ot.indexOf(e.PARSER_MEDIA_TYPE) ? at : e.PARSER_MEDIA_TYPE, lt = "application/xhtml+xml" === st ? p : f, _e = _(e, "ALLOWED_TAGS") ? x({}, e.ALLOWED_TAGS, lt) : we, ke = _(e, "ALLOWED_ATTR") ? x({}, e.ALLOWED_ATTR, lt) : be, et = _(e, "ALLOWED_NAMESPACES") ? x({}, e.ALLOWED_NAMESPACES, p) : tt, Ge = _(e, "ADD_URI_SAFE_ATTR") ? x(T(qe), e.ADD_URI_SAFE_ATTR, lt) : qe, Ve = _(e, "ADD_DATA_URI_TAGS") ? x(T(Be), e.ADD_DATA_URI_TAGS, lt) : Be, He = _(e, "FORBID_CONTENTS") ? x({}, e.FORBID_CONTENTS, lt) : We, Se = _(e, "FORBID_TAGS") ? x({}, e.FORBID_TAGS, lt) : {}, Te = _(e, "FORBID_ATTR") ? x({}, e.FORBID_ATTR, lt) : {}, Fe = !!_(e, "USE_PROFILES") && e.USE_PROFILES, Ce = !1 !== e.ALLOW_ARIA_ATTR, Me = !1 !== e.ALLOW_DATA_ATTR, Oe = e.ALLOW_UNKNOWN_PROTOCOLS || !1, De = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, Re = e.SAFE_FOR_TEMPLATES || !1, Ee = !1 !== e.SAFE_FOR_XML, Ae = e.WHOLE_DOCUMENT || !1, Ie = e.RETURN_DOM || !1, $e = e.RETURN_DOM_FRAGMENT || !1, Pe = e.RETURN_TRUSTED_TYPE || !1, Ne = e.FORCE_BODY || !1, Ue = !1 !== e.SANITIZE_DOM, Ye = e.SANITIZE_NAMED_PROPS || !1, ze = !1 !== e.KEEP_CONTENT, je = e.IN_PLACE || !1, ye = e.ALLOWED_URI_REGEXP || H, Xe = e.NAMESPACE || Ke, nt = e.MATHML_TEXT_INTEGRATION_POINTS || nt, rt = e.HTML_INTEGRATION_POINTS || rt, xe = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && dt(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (xe.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && dt(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (xe.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (xe.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Re && (Me = !1), $e && (Ie = !0), Fe && (_e = x({}, L), ke = [], !0 === Fe.html && (x(_e, M), x(ke, N)), !0 === Fe.svg && (x(_e, O), x(ke, I), x(ke, P)), !0 === Fe.svgFilters && (x(_e, D), x(ke, I), x(ke, P)), !0 === Fe.mathMl && (x(_e, E), x(ke, $), x(ke, P))), e.ADD_TAGS && (_e === we && (_e = T(_e)), x(_e, e.ADD_TAGS, lt)), e.ADD_ATTR && (ke === be && (ke = T(ke)), x(ke, e.ADD_ATTR, lt)), e.ADD_URI_SAFE_ATTR && x(Ge, e.ADD_URI_SAFE_ATTR, lt), e.FORBID_CONTENTS && (He === We && (He = T(He)), x(He, e.FORBID_CONTENTS, lt)), ze && (_e["#text"] = !0), Ae && x(_e, ["html", "head", "body"]), _e.table && (x(_e, ["tbody"]), delete Se.tbody), e.TRUSTED_TYPES_POLICY) {
                  if ("function" != typeof e.TRUSTED_TYPES_POLICY.createHTML) throw k('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                  if ("function" != typeof e.TRUSTED_TYPES_POLICY.createScriptURL) throw k('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                  ne = e.TRUSTED_TYPES_POLICY, re = ne.createHTML("");
                } else void 0 === ne && (ne = K(W, l)), null !== ne && "string" == typeof re && (re = ne.createHTML(""));
                s && s(e), ct = e;
              }
            },
            ft = x({}, [...O, ...D, ...R]),
            pt = x({}, [...E, ...A]),
            mt = function (e) {
              h(r.removed, {
                element: e
              });
              try {
                te(e).removeChild(e);
              } catch (t) {
                X(e);
              }
            },
            gt = function (e, t) {
              try {
                h(r.removed, {
                  attribute: t.getAttributeNode(e),
                  from: t
                });
              } catch (e) {
                h(r.removed, {
                  attribute: null,
                  from: t
                });
              }
              if (t.removeAttribute(e), "is" === e && !ke[e]) if (Ie || $e) try {
                mt(t);
              } catch (e) {} else try {
                t.setAttribute(e, "");
              } catch (e) {}
            },
            vt = function (e) {
              let t = null,
                n = null;
              if (Ne) e = "<remove></remove>" + e;else {
                const t = m(e, /^[\r\n\t ]+/);
                n = t && t[0];
              }
              "application/xhtml+xml" === st && Xe === Ke && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
              const r = ne ? ne.createHTML(e) : e;
              if (Xe === Ke) try {
                t = new F().parseFromString(r, st);
              } catch (e) {}
              if (!t || !t.documentElement) {
                t = ie.createDocument(Xe, "template", null);
                try {
                  t.documentElement.innerHTML = Je ? re : r;
                } catch (e) {}
              }
              const s = t.body || t.documentElement;
              return e && n && s.insertBefore(i.createTextNode(n), s.childNodes[0] || null), Xe === Ke ? ae.call(t, Ae ? "html" : "body")[0] : Ae ? t.documentElement : s;
            },
            yt = function (e) {
              return se.call(e.ownerDocument || e, e, Y.SHOW_ELEMENT | Y.SHOW_COMMENT | Y.SHOW_TEXT | Y.SHOW_PROCESSING_INSTRUCTION | Y.SHOW_CDATA_SECTION, null);
            },
            _t = function (e) {
              return e instanceof j && ("string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || !(e.attributes instanceof z) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes);
            },
            wt = function (e) {
              return "function" == typeof S && e instanceof S;
            };
          function kt(e, t, n) {
            ce[e] && u(ce[e], e => {
              e.call(r, t, n, ct);
            });
          }
          const bt = function (e) {
              let t = null;
              if (kt("beforeSanitizeElements", e, null), _t(e)) return mt(e), !0;
              const n = lt(e.nodeName);
              if (kt("uponSanitizeElement", e, {
                tagName: n,
                allowedTags: _e
              }), e.hasChildNodes() && !wt(e.firstElementChild) && w(/<[/\w]/g, e.innerHTML) && w(/<[/\w]/g, e.textContent)) return mt(e), !0;
              if (e.nodeType === Z.progressingInstruction) return mt(e), !0;
              if (Ee && e.nodeType === Z.comment && w(/<[/\w]/g, e.data)) return mt(e), !0;
              if (!_e[n] || Se[n]) {
                if (!Se[n] && St(n)) {
                  if (xe.tagNameCheck instanceof RegExp && w(xe.tagNameCheck, n)) return !1;
                  if (xe.tagNameCheck instanceof Function && xe.tagNameCheck(n)) return !1;
                }
                if (ze && !He[n]) {
                  const t = te(e) || e.parentNode,
                    n = ee(e) || e.childNodes;
                  if (n && t) for (let r = n.length - 1; r >= 0; --r) {
                    const i = G(n[r], !0);
                    i.__removalCount = (e.__removalCount || 0) + 1, t.insertBefore(i, J(e));
                  }
                }
                return mt(e), !0;
              }
              return e instanceof U && !function (e) {
                let t = te(e);
                t && t.tagName || (t = {
                  namespaceURI: Xe,
                  tagName: "template"
                });
                const n = f(e.tagName),
                  r = f(t.tagName);
                return !!et[e.namespaceURI] && (e.namespaceURI === Qe ? t.namespaceURI === Ke ? "svg" === n : t.namespaceURI === Ze ? "svg" === n && ("annotation-xml" === r || nt[r]) : Boolean(ft[n]) : e.namespaceURI === Ze ? t.namespaceURI === Ke ? "math" === n : t.namespaceURI === Qe ? "math" === n && rt[r] : Boolean(pt[n]) : e.namespaceURI === Ke ? !(t.namespaceURI === Qe && !rt[r]) && !(t.namespaceURI === Ze && !nt[r]) && !pt[n] && (it[n] || !ft[n]) : !("application/xhtml+xml" !== st || !et[e.namespaceURI]));
              }(e) ? (mt(e), !0) : "noscript" !== n && "noembed" !== n && "noframes" !== n || !w(/<\/no(script|embed|frames)/i, e.innerHTML) ? (Re && e.nodeType === Z.text && (t = e.textContent, u([ue, de, he], e => {
                t = g(t, e, " ");
              }), e.textContent !== t && (h(r.removed, {
                element: e.cloneNode()
              }), e.textContent = t)), kt("afterSanitizeElements", e, null), !1) : (mt(e), !0);
            },
            xt = function (e, t, n) {
              if (Ue && ("id" === t || "name" === t) && (n in i || n in ut)) return !1;
              if (Me && !Te[t] && w(fe, t)) ;else if (Ce && w(pe, t)) ;else if (!ke[t] || Te[t]) {
                if (!(St(e) && (xe.tagNameCheck instanceof RegExp && w(xe.tagNameCheck, e) || xe.tagNameCheck instanceof Function && xe.tagNameCheck(e)) && (xe.attributeNameCheck instanceof RegExp && w(xe.attributeNameCheck, t) || xe.attributeNameCheck instanceof Function && xe.attributeNameCheck(t)) || "is" === t && xe.allowCustomizedBuiltInElements && (xe.tagNameCheck instanceof RegExp && w(xe.tagNameCheck, n) || xe.tagNameCheck instanceof Function && xe.tagNameCheck(n)))) return !1;
              } else if (Ge[t]) ;else if (w(ye, g(n, ge, ""))) ;else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== v(n, "data:") || !Ve[e]) if (Oe && !w(me, g(n, ge, ""))) ;else if (n) return !1;
              return !0;
            },
            St = function (e) {
              return "annotation-xml" !== e && m(e, ve);
            },
            Tt = function (e) {
              kt("beforeSanitizeAttributes", e, null);
              const {
                attributes: t
              } = e;
              if (!t) return;
              const n = {
                attrName: "",
                attrValue: "",
                keepAttr: !0,
                allowedAttributes: ke,
                forceKeepAttr: void 0
              };
              let i = t.length;
              for (; i--;) {
                const s = t[i],
                  {
                    name: o,
                    namespaceURI: a,
                    value: l
                  } = s,
                  c = lt(o);
                let h = "value" === o ? l : y(l);
                if (n.attrName = c, n.attrValue = h, n.keepAttr = !0, n.forceKeepAttr = void 0, kt("uponSanitizeAttribute", e, n), h = n.attrValue, !Ye || "id" !== c && "name" !== c || (gt(o, e), h = "user-content-" + h), Ee && w(/((--!?|])>)|<\/(style|title)/i, h)) {
                  gt(o, e);
                  continue;
                }
                if (n.forceKeepAttr) continue;
                if (gt(o, e), !n.keepAttr) continue;
                if (!De && w(/\/>/i, h)) {
                  gt(o, e);
                  continue;
                }
                Re && u([ue, de, he], e => {
                  h = g(h, e, " ");
                });
                const f = lt(e.nodeName);
                if (xt(f, c, h)) {
                  if (ne && "object" == typeof W && "function" == typeof W.getAttributeType) if (a) ;else switch (W.getAttributeType(f, c)) {
                    case "TrustedHTML":
                      h = ne.createHTML(h);
                      break;
                    case "TrustedScriptURL":
                      h = ne.createScriptURL(h);
                  }
                  try {
                    a ? e.setAttributeNS(a, o, h) : e.setAttribute(o, h), _t(e) ? mt(e) : d(r.removed);
                  } catch (e) {}
                }
              }
              kt("afterSanitizeAttributes", e, null);
            },
            Ct = function e(t) {
              let n = null;
              const r = yt(t);
              for (kt("beforeSanitizeShadowDOM", t, null); n = r.nextNode();) kt("uponSanitizeShadowNode", n, null), bt(n) || (n.content instanceof c && e(n.content), Tt(n));
              kt("afterSanitizeShadowDOM", t, null);
            };
          return r.sanitize = function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = null,
              i = null,
              s = null,
              a = null;
            if (Je = !e, Je && (e = "\x3c!--\x3e"), "string" != typeof e && !wt(e)) {
              if ("function" != typeof e.toString) throw k("toString is not a function");
              if ("string" != typeof (e = e.toString())) throw k("dirty is not a string, aborting");
            }
            if (!r.isSupported) return e;
            if (Le || ht(t), r.removed = [], "string" == typeof e && (je = !1), je) {
              if (e.nodeName) {
                const t = lt(e.nodeName);
                if (!_e[t] || Se[t]) throw k("root node is forbidden and cannot be sanitized in-place");
              }
            } else if (e instanceof S) n = vt("\x3c!----\x3e"), i = n.ownerDocument.importNode(e, !0), i.nodeType === Z.element && "BODY" === i.nodeName || "HTML" === i.nodeName ? n = i : n.appendChild(i);else {
              if (!Ie && !Re && !Ae && -1 === e.indexOf("<")) return ne && Pe ? ne.createHTML(e) : e;
              if (n = vt(e), !n) return Ie ? null : Pe ? re : "";
            }
            n && Ne && mt(n.firstChild);
            const l = yt(je ? e : n);
            for (; s = l.nextNode();) bt(s) || (s.content instanceof c && Ct(s.content), Tt(s));
            if (je) return e;
            if (Ie) {
              if ($e) for (a = oe.call(n.ownerDocument); n.firstChild;) a.appendChild(n.firstChild);else a = n;
              return (ke.shadowroot || ke.shadowrootmode) && (a = le.call(o, a, !0)), a;
            }
            let d = Ae ? n.outerHTML : n.innerHTML;
            return Ae && _e["!doctype"] && n.ownerDocument && n.ownerDocument.doctype && n.ownerDocument.doctype.name && w(B, n.ownerDocument.doctype.name) && (d = "<!DOCTYPE " + n.ownerDocument.doctype.name + ">\n" + d), Re && u([ue, de, he], e => {
              d = g(d, e, " ");
            }), ne && Pe ? ne.createHTML(d) : d;
          }, r.setConfig = function () {
            ht(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), Le = !0;
          }, r.clearConfig = function () {
            ct = null, Le = !1;
          }, r.isValidAttribute = function (e, t, n) {
            ct || ht({});
            const r = lt(e),
              i = lt(t);
            return xt(r, i, n);
          }, r.addHook = function (e, t) {
            "function" == typeof t && (ce[e] = ce[e] || [], h(ce[e], t));
          }, r.removeHook = function (e) {
            if (ce[e]) return d(ce[e]);
          }, r.removeHooks = function (e) {
            ce[e] && (ce[e] = []);
          }, r.removeAllHooks = function () {
            ce = {};
          }, r;
        }();
        return X;
      }();
    }),
    Wa = Ha;
  const Va = {
      class: "wl-comment"
    },
    Ba = {
      key: 0,
      class: "wl-login-info"
    },
    Ga = {
      class: "wl-avatar"
    },
    qa = ["title"],
    Za = ["title"],
    Qa = ["src"],
    Ka = ["title", "textContent"],
    Xa = {
      class: "wl-panel"
    },
    Ja = ["for", "textContent"],
    el = ["id", "onUpdate:modelValue", "name", "type"],
    tl = ["placeholder"],
    nl = {
      class: "wl-preview"
    },
    rl = ti("hr", null, null, -1),
    il = ["innerHTML"],
    sl = {
      class: "wl-footer"
    },
    ol = {
      class: "wl-actions"
    },
    al = {
      href: "https://guides.github.com/features/mastering-markdown/",
      title: "Markdown Guide",
      "aria-label": "Markdown is supported",
      class: "wl-action",
      target: "_blank",
      rel: "noopener noreferrer"
    },
    ll = ["title"],
    cl = ["title"],
    ul = ["title"],
    dl = ["title"],
    hl = {
      class: "wl-info"
    },
    fl = {
      class: "wl-text-number"
    },
    pl = {
      key: 0
    },
    ml = ["textContent"],
    gl = ["textContent"],
    vl = ["disabled"],
    yl = ["placeholder"],
    _l = {
      key: 0,
      class: "wl-loading"
    },
    wl = {
      key: 0,
      class: "wl-tab-wrapper"
    },
    kl = ["title", "onClick"],
    bl = ["src", "alt"],
    xl = {
      key: 0,
      class: "wl-tabs"
    },
    Sl = ["onClick"],
    Tl = ["src", "alt", "title"],
    Cl = ["title"];
  var Ml = Bn({
      __name: "CommentBox",
      props: {
        edit: {
          default: null
        },
        rootId: {
          default: ""
        },
        replyId: {
          default: ""
        },
        replyUser: {
          default: ""
        }
      },
      emits: ["log", "cancelEdit", "cancelReply", "submit"],
      setup(e, t) {
        let {
          expose: n,
          emit: r
        } = t;
        const i = e;
        n();
        const s = zn("config"),
          o = Fs("WALINE_COMMENT_BOX_EDITOR", ""),
          a = Fs("WALINE_USER_META", {
            nick: "",
            mail: "",
            link: ""
          }),
          l = wa(),
          c = Jt({}),
          u = Jt(null),
          d = Jt(null),
          h = Jt(null),
          f = Jt(null),
          p = Jt(null),
          m = Jt(null),
          g = Jt(null),
          v = Jt({
            tabs: [],
            map: {}
          }),
          y = Jt(0),
          _ = Jt(!1),
          w = Jt(!1),
          k = Jt(!1),
          b = Jt(""),
          x = Jt(0),
          S = Yt({
            loading: !0,
            list: []
          }),
          T = Jt(0),
          M = Jt(!1),
          D = Jt(""),
          R = Jt(!1),
          E = Jt(!1),
          A = bi(() => s.value.locale),
          L = bi(() => {
            var _l$value;
            return Boolean((_l$value = l.value) === null || _l$value === void 0 ? void 0 : _l$value.token);
          }),
          N = bi(() => !1 !== s.value.imageUploader),
          I = bi(() => Wa.sanitize(b.value)),
          $ = e => {
            const t = u.value,
              n = t.selectionStart,
              r = t.selectionEnd || 0,
              i = t.scrollTop;
            o.value = t.value.substring(0, n) + e + t.value.substring(r, t.value.length), t.focus(), t.selectionStart = n + e.length, t.selectionEnd = n + e.length, t.scrollTop = i;
          },
          P = e => {
            const t = e.key;
            (e.ctrlKey || e.metaKey) && "Enter" === t && H();
          },
          U = e => {
            const t = `![${s.value.locale.uploading} ${e.name}]()`;
            return $(t), Promise.resolve().then(() => s.value.imageUploader(e)).then(n => {
              o.value = o.value.replace(t, `\r\n![${e.name}](${n})`);
            }).catch(e => {
              alert(e.message), o.value = o.value.replace(t, "");
            });
          },
          Y = e => {
            var _e$dataTransfer;
            if ((_e$dataTransfer = e.dataTransfer) !== null && _e$dataTransfer !== void 0 && _e$dataTransfer.items) {
              const t = ao(e.dataTransfer.items);
              t && N.value && (U(t), e.preventDefault());
            }
          },
          z = e => {
            if (e.clipboardData) {
              const t = ao(e.clipboardData.items);
              t && N.value && U(t);
            }
          },
          F = () => {
            const e = d.value;
            e.files && N.value && U(e.files[0]).then(() => {
              e.value = "";
            });
          },
          H = async () => {
            var _l$value2, _l$value3;
            const {
              serverURL: e,
              lang: t,
              login: n,
              wordLimit: d,
              requiredMeta: h
            } = s.value;
            let f = "";
            s.value.recaptchaV3Key && (f = await ((e, _ya$e) => {
              const t = (_ya$e = ya[e]) !== null && _ya$e !== void 0 ? _ya$e : ya[e] = va.load(e, {
                useRecaptchaNet: !0,
                autoHideBadge: !0
              });
              return {
                execute: e => t.then(t => t.execute(e))
              };
            })(s.value.recaptchaV3Key).execute("social"));
            const p = Ua().utcOffset(8).startOf("day").valueOf(),
              m = {
                comment: D.value,
                nick: a.value.nick,
                mail: a.value.mail,
                link: a.value.link,
                ua: navigator.userAgent,
                url: s.value.path,
                recaptchaV3: f,
                curCommentTime: p
              };
            if ((_l$value2 = l.value) !== null && _l$value2 !== void 0 && _l$value2.token) m.nick = l.value.display_name, m.mail = l.value.email, m.link = l.value.url;else {
              var _c$value$nick, _c$value$mail, _u$value;
              if ("force" === n) return;
              if (h.indexOf("nick") > -1 && !m.nick) return (_c$value$nick = c.value.nick) !== null && _c$value$nick !== void 0 && _c$value$nick.focus(), alert(A.value.nickError);
              if (h.indexOf("mail") > -1 && !m.mail || m.mail && !/^\w(?:[\w._-]*\w)?@(?:\w(?:[\w-]*\w)?\.)*\w+$/.exec(m.mail)) return (_c$value$mail = c.value.mail) !== null && _c$value$mail !== void 0 && _c$value$mail.focus(), alert(A.value.mailError);
              if (!m.comment) return void ((_u$value = u.value) === null || _u$value === void 0 ? void 0 : _u$value.focus());
              m.nick || (m.nick = A.value.anonymous);
            }
            if (!M.value) return alert(A.value.wordHint.replace("$0", d[0].toString()).replace("$1", d[1].toString()).replace("$2", x.value.toString()));
            m.comment = Zo(m.comment, v.value.map), i.replyId && i.rootId && (m.pid = i.replyId, m.rid = i.rootId, m.at = i.replyUser), R.value = !0;
            const g = {
              serverURL: e,
              lang: t,
              token: (_l$value3 = l.value) === null || _l$value3 === void 0 ? void 0 : _l$value3.token,
              comment: m
            };
            (i.edit ? C({
              objectId: i.edit.objectId,
              ...g
            }) : (e => {
              let {
                serverURL: t,
                lang: n,
                token: r,
                comment: i
              } = e;
              const s = {
                "Content-Type": "application/json"
              };
              return r && (s.Authorization = `Bearer ${r}`), fetch(`${t}/comment?lang=${n}`, {
                method: "POST",
                headers: s,
                body: JSON.stringify(i)
              }).then(e => e.json());
            })(g)).then(e => {
              var _i$edit;
              if (R.value = !1, e.errmsg) return alert(e.errmsg);
              r("submit", e.data), o.value = "", b.value = "", i.replyId && r("cancelReply"), ((_i$edit = i.edit) === null || _i$edit === void 0 ? void 0 : _i$edit.objectId) && r("cancelEdit");
            }).catch(e => {
              R.value = !1, alert(e.message);
            });
          },
          W = e => {
            e.preventDefault();
            const {
              lang: t,
              serverURL: n
            } = s.value;
            (e => {
              let {
                lang: t,
                serverURL: n
              } = e;
              const r = (window.innerWidth - 450) / 2,
                i = (window.innerHeight - 450) / 2,
                s = window.open(`${n}/ui/login?lng=${encodeURIComponent(t)}`, "_blank", `width=450,height=450,left=${r},top=${i},scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`);
              return s !== null && s !== void 0 && s.postMessage({
                type: "TOKEN",
                data: null
              }, "*"), new Promise(e => {
                const t = n => {
                  let {
                    data: r
                  } = n;
                  r && "object" == typeof r && "userInfo" === r.type && r.data.token && (s !== null && s !== void 0 && s.close(), window.removeEventListener("message", t), e(r.data));
                };
                window.addEventListener("message", t);
              });
            })({
              serverURL: n,
              lang: t
            }).then(e => {
              l.value = e, (e.remember ? localStorage : sessionStorage).setItem("WALINE_USER", JSON.stringify(e)), r("log");
            });
          },
          V = () => {
            l.value = {}, localStorage.setItem("WALINE_USER", "null"), sessionStorage.setItem("WALINE_USER", "null"), r("log");
          },
          G = e => {
            e.preventDefault();
            const {
                lang: t,
                serverURL: n
              } = s.value,
              r = (window.innerWidth - 800) / 2,
              i = (window.innerHeight - 800) / 2,
              o = new URLSearchParams({
                lng: t,
                token: l.value.token
              }),
              a = window.open(`${n}/ui/profile?${o.toString()}`, "_blank", `width=800,height=800,left=${r},top=${i},scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`);
            a === null || a === void 0 ? void 0 : a.postMessage({
              type: "TOKEN",
              data: l.value.token
            }, "*");
          },
          q = e => {
            var _h$value, _f$value, _p$value, _m$value;
            (_h$value = h.value) !== null && _h$value !== void 0 && _h$value.contains(e.target) || (_f$value = f.value) !== null && _f$value !== void 0 && _f$value.contains(e.target) || (_.value = !1), ((_p$value = p.value) === null || _p$value === void 0 ? void 0 : _p$value.contains(e.target)) || ((_m$value = m.value) === null || _m$value === void 0 ? void 0 : _m$value.contains(e.target)) || (w.value = !1);
          },
          Z = async e => {
            var _g$value;
            const {
                scrollTop: t,
                clientHeight: n,
                scrollHeight: r
              } = e.target,
              i = (n + t) / r,
              o = s.value.search,
              a = ((_g$value = g.value) === null || _g$value === void 0 ? void 0 : _g$value.value) || "";
            i < .9 || S.loading || E.value || (S.loading = !0, (o.more && S.list.length ? await o.more(a, S.list.length) : await o.search(a)).length ? S.list = [...S.list, ...(o.more && S.list.length ? await o.more(a, S.list.length) : await o.search(a))] : E.value = !0, S.loading = !1, setTimeout(() => {
              e.target.scrollTop = t;
            }, 50));
          },
          Q = function (e) {
            return us(function (e) {
              let t,
                n,
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                i = ls;
              const s = e => {
                clearTimeout(e), i(), i = ls;
              };
              return o => {
                const a = cs(e),
                  l = cs(r.maxWait);
                return t && s(t), a <= 0 || void 0 !== l && l <= 0 ? (n && (s(n), n = null), Promise.resolve(o())) : new Promise((e, c) => {
                  i = r.rejectOnCancel ? c : e, l && !n && (n = setTimeout(() => {
                    t && s(t), n = null, e(o());
                  }, l)), t = setTimeout(() => {
                    n && s(n), n = null, e(o());
                  }, a);
                });
              };
            }(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 200, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}), e);
          }(e => {
            S.list = [], E.value = !1, Z(e);
          }, 300);
        Hn([s, x], e => {
          let [t, n] = e;
          const {
            wordLimit: r
          } = t;
          r ? n < r[0] && 0 !== r[0] ? (T.value = r[0], M.value = !1) : n > r[1] ? (T.value = r[1], M.value = !1) : (T.value = r[1], M.value = !0) : (T.value = 0, M.value = !0);
        }, {
          immediate: !0
        });
        const K = e => {
          let {
            data: t
          } = e;
          t && "profile" === t.type && (l.value = {
            ...l.value,
            ...t.data
          }, [localStorage, sessionStorage].filter(e => e.getItem("WALINE_USER")).forEach(e => e.setItem("WALINE_USER", JSON.stringify(l))));
        };
        return Qn(() => {
          var _i$edit2;
          document.body.addEventListener("click", q), window.addEventListener("message", K), (_i$edit2 = i.edit) !== null && _i$edit2 !== void 0 && _i$edit2.objectId && (o.value = i.edit.orig), Hn(w, async e => {
            if (!e) return;
            const t = s.value.search;
            g.value && (g.value.value = ""), S.loading = !0, S.list = t.default ? await t.default() : await t.search(""), S.loading = !1;
          }), Hn(() => o.value, e => {
            const {
              highlighter: t,
              texRenderer: n
            } = s.value;
            D.value = e, b.value = ((e, t) => {
              let {
                emojiMap: n,
                highlighter: r,
                texRenderer: i
              } = t;
              if (Vo.setOptions({
                highlight: r || void 0,
                breaks: !0,
                smartLists: !0,
                smartypants: !0
              }), i) {
                const e = (e => [{
                  name: "blockMath",
                  level: "block",
                  tokenizer(t) {
                    const n = qo.exec(t);
                    if (null !== n) return {
                      type: "html",
                      raw: n[0],
                      text: e(!0, n[1])
                    };
                  }
                }, {
                  name: "inlineMath",
                  level: "inline",
                  start(e) {
                    const t = e.search(Bo);
                    return -1 !== t ? t : e.length;
                  },
                  tokenizer(t) {
                    const n = Go.exec(t);
                    if (null !== n) return {
                      type: "html",
                      raw: n[0],
                      text: e(!1, n[1])
                    };
                  }
                }])(i);
                Vo.use({
                  extensions: e
                });
              }
              return Vo.parse(Zo(e, n));
            })(e, {
              emojiMap: v.value.map,
              highlighter: t,
              texRenderer: n
            }), x.value = e.trim().split(/\s+/u).join("").length, e ? $a(u.value) : $a.destroy(u.value);
          }, {
            immediate: !0
          }), Hn(() => s.value.emoji, e => {
            return (t = e, Promise.all(t.map(e => "string" == typeof e ? (e => {
              const t = Fs("WALINE_EMOJI", {}),
                n = Boolean(/@[0-9]+\.[0-9]+\.[0-9]+/.test(e));
              if (n) {
                const n = t.value[e];
                if (n) return Promise.resolve(n);
              }
              return fetch(`${e}/info.json`).then(e => e.json()).then(r => {
                const i = {
                  folder: e,
                  ...r
                };
                return n && (t.value[e] = i), i;
              });
            })(O(e)) : Promise.resolve(e))).then(e => {
              const t = {
                tabs: [],
                map: {}
              };
              return e.forEach(e => {
                const {
                  name: n,
                  folder: r,
                  icon: i,
                  prefix: s,
                  type: o,
                  items: a
                } = e;
                t.tabs.push({
                  name: n,
                  icon: ro(i, r, s, o),
                  items: a.map(e => {
                    const n = `${s || ""}${e}`;
                    return t.map[n] = ro(e, r, s, o), n;
                  })
                });
              }), t;
            })).then(e => {
              v.value = e;
            });
            var t;
          }, {
            immediate: !0
          });
        }), Xn(() => {
          document.body.removeEventListener("click", q), window.removeEventListener("message", K);
        }), (t, n) => {
          var _e$edit, _e$edit2;
          return Wr(), qr("div", Va, ["disable" !== rn(s).login && rn(L) && !((_e$edit = e.edit) !== null && _e$edit !== void 0 && _e$edit.objectId) ? (Wr(), qr("div", Ba, [ti("div", Ga, [ti("button", {
            type: "submit",
            class: "wl-logout-btn",
            title: rn(A).logout,
            onClick: V
          }, [ni(rn(Xo), {
            size: 14
          })], 8, qa), ti("a", {
            href: "#",
            class: "wl-login-nick",
            "aria-label": "Profile",
            title: rn(A).profile,
            onClick: G
          }, [ti("img", {
            src: rn(l).avatar,
            alt: "avatar"
          }, null, 8, Qa)], 8, Za)]), ti("a", {
            href: "#",
            class: "wl-login-nick",
            "aria-label": "Profile",
            title: rn(A).profile,
            onClick: G,
            textContent: B(rn(l).display_name)
          }, null, 8, Ka)])) : si("v-if", !0), ti("div", Xa, ["force" !== rn(s).login && rn(s).meta.length && !rn(L) ? (Wr(), qr("div", {
            key: 0,
            class: j(["wl-header", `item${rn(s).meta.length}`])
          }, [(Wr(!0), qr(Ur, null, ir(rn(s).meta, e => (Wr(), qr("div", {
            key: e,
            class: "wl-header-item"
          }, [ti("label", {
            for: `wl-${e} ${rn(s).requiredMeta.includes(e) ? "required" : ""}`,
            textContent: B(rn(A)[e] + (rn(s).requiredMeta.includes(e) || !rn(s).requiredMeta.length ? "" : `(${rn(A).optional})`))
          }, null, 8, Ja), Jn(ti("input", {
            id: `wl-${e}`,
            ref_for: !0,
            ref: t => {
              t && (c.value[e] = t);
            },
            "onUpdate:modelValue": t => rn(a)[e] = t,
            class: j(["wl-input", `wl-${e}`]),
            name: e,
            type: "mail" === e ? "email" : "text"
          }, null, 10, el), [[Xi, rn(a)[e]]])]))), 128))], 2)) : si("v-if", !0), Jn(ti("textarea", {
            id: "wl-edit",
            ref_key: "editorRef",
            ref: u,
            "onUpdate:modelValue": n[0] || (n[0] = e => Xt(o) ? o.value = e : null),
            class: "wl-editor",
            placeholder: e.replyUser ? `@${e.replyUser}` : rn(A).placeholder,
            onKeydown: P,
            onDrop: Y,
            onPaste: z
          }, null, 40, tl), [[Wi, rn(o)]]), Jn(ti("div", nl, [rl, ti("h4", null, B(rn(A).preview) + ":", 1), ti("div", {
            class: "wl-content",
            innerHTML: rn(I)
          }, null, 8, il)], 512), [[es, k.value]]), ti("div", sl, [ti("div", ol, [ti("a", al, [ni(rn(ra))]), Jn(ti("button", {
            ref_key: "emojiButtonRef",
            ref: h,
            type: "button",
            class: j(["wl-action", {
              active: _.value
            }]),
            title: rn(A).emoji,
            onClick: n[1] || (n[1] = e => _.value = !_.value)
          }, [ni(rn(ea))], 10, ll), [[es, v.value.tabs.length]]), rn(s).search ? (Wr(), qr("button", {
            key: 0,
            ref_key: "gifButtonRef",
            ref: p,
            type: "button",
            class: j(["wl-action", {
              active: w.value
            }]),
            title: rn(A).gif,
            onClick: n[2] || (n[2] = e => w.value = !w.value)
          }, [ni(rn(la))], 10, cl)) : si("v-if", !0), ti("input", {
            id: "wl-image-upload",
            ref_key: "imageUploadRef",
            ref: d,
            class: "upload",
            type: "file",
            accept: ".png,.jpg,.jpeg,.webp,.bmp,.gif",
            onChange: F
          }, null, 544), rn(N) ? (Wr(), qr("label", {
            key: 1,
            for: "wl-image-upload",
            class: "wl-action",
            title: rn(A).uploadImage
          }, [ni(rn(ta))], 8, ul)) : si("v-if", !0), ti("button", {
            type: "button",
            class: j(["wl-action", {
              active: k.value
            }]),
            title: rn(A).preview,
            onClick: n[3] || (n[3] = e => k.value = !k.value)
          }, [ni(rn(na))], 10, dl)]), ti("div", hl, [ti("div", fl, [ii(B(x.value) + " ", 1), rn(s).wordLimit ? (Wr(), qr("span", pl, [ii("  /  "), ti("span", {
            class: j({
              illegal: !M.value
            }),
            textContent: B(T.value)
          }, null, 10, ml)])) : si("v-if", !0), ii("  " + B(rn(A).word), 1)]), "disable" === rn(s).login || rn(L) ? si("v-if", !0) : (Wr(), qr("button", {
            key: 0,
            type: "button",
            class: "wl-btn",
            onClick: W,
            textContent: B(rn(A).login)
          }, null, 8, gl)), "force" !== rn(s).login || rn(L) ? (Wr(), qr("button", {
            key: 1,
            type: "submit",
            class: "primary wl-btn",
            title: "Cmd|Ctrl + Enter",
            disabled: R.value,
            onClick: H
          }, [R.value ? (Wr(), Zr(rn(aa), {
            key: 0,
            size: 16
          })) : (Wr(), qr(Ur, {
            key: 1
          }, [ii(B(rn(A).submit), 1)], 64))], 8, vl)) : si("v-if", !0)]), ti("div", {
            ref_key: "gifPopupRef",
            ref: m,
            class: j(["wl-gif-popup", {
              display: w.value
            }])
          }, [ti("input", {
            ref_key: "gifSearchInputRef",
            ref: g,
            type: "text",
            placeholder: rn(A).gifSearchPlaceholder,
            onInput: n[4] || (n[4] = function () {
              return rn(Q) && rn(Q)(...arguments);
            })
          }, null, 40, yl), ni(Fa, {
            items: S.list,
            "column-width": 200,
            gap: 6,
            onInsert: n[5] || (n[5] = e => $(e)),
            onScroll: Z
          }, null, 8, ["items"]), S.loading ? (Wr(), qr("div", _l, [ni(rn(aa), {
            size: 30
          })])) : si("v-if", !0)], 2), ti("div", {
            ref_key: "emojiPopupRef",
            ref: f,
            class: j(["wl-emoji-popup", {
              display: _.value
            }])
          }, [(Wr(!0), qr(Ur, null, ir(v.value.tabs, (e, t) => (Wr(), qr(Ur, {
            key: e.name
          }, [t === y.value ? (Wr(), qr("div", wl, [(Wr(!0), qr(Ur, null, ir(e.items, e => (Wr(), qr("button", {
            key: e,
            type: "button",
            title: e,
            onClick: t => $(`:${e}:`)
          }, [_.value ? (Wr(), qr("img", {
            key: 0,
            class: "wl-emoji",
            src: v.value.map[e],
            alt: e,
            loading: "lazy",
            referrerPolicy: "no-referrer"
          }, null, 8, bl)) : si("v-if", !0)], 8, kl))), 128))])) : si("v-if", !0)], 64))), 128)), v.value.tabs.length > 1 ? (Wr(), qr("div", xl, [(Wr(!0), qr(Ur, null, ir(v.value.tabs, (e, t) => (Wr(), qr("button", {
            key: e.name,
            type: "button",
            class: j(["wl-tab", {
              active: y.value === t
            }]),
            onClick: e => y.value = t
          }, [ti("img", {
            class: "wl-emoji",
            src: e.icon,
            alt: e.name,
            title: e.name,
            loading: "lazy",
            referrerPolicy: "no-referrer"
          }, null, 8, Tl)], 10, Sl))), 128))])) : si("v-if", !0)], 2)])]), e.replyId || (_e$edit2 = e.edit) !== null && _e$edit2 !== void 0 && _e$edit2.objectId ? (Wr(), qr("button", {
            key: 1,
            type: "button",
            class: "wl-close",
            title: rn(A).cancelReply,
            onClick: n[6] || (n[6] = n => t.$emit(e.replyId ? "cancelReply" : "cancelEdit"))
          }, [ni(rn(Xo), {
            size: 24
          })], 8, Cl)) : si("v-if", !0)]);
        };
      }
    }),
    Ol = Ra(Ml, [["__file", "CommentBox.vue"]]);
  const Dl = ["id"],
    Rl = {
      class: "wl-user",
      "aria-hidden": "true"
    },
    El = ["src"],
    Al = {
      class: "wl-card"
    },
    Ll = {
      class: "wl-head"
    },
    Nl = ["href"],
    Il = {
      key: 1,
      class: "wl-nick"
    },
    $l = ["textContent"],
    Pl = ["textContent"],
    Ul = ["textContent"],
    Yl = ["textContent"],
    zl = ["textContent"],
    jl = {
      class: "wl-comment-actions"
    },
    Fl = ["title"],
    Hl = {
      class: "wl-meta",
      "aria-hidden": "true"
    },
    Wl = ["data-value", "textContent"],
    Vl = ["data-value", "textContent"],
    Bl = ["data-value", "textContent"],
    Gl = ["innerHTML"],
    ql = {
      key: 1,
      class: "wl-admin-actions"
    },
    Zl = {
      class: "wl-comment-status"
    },
    Ql = ["disabled", "onClick", "textContent"],
    Kl = {
      key: 3,
      class: "wl-quote"
    };
  var Xl = Ra(Bn({
    __name: "CommentCard",
    props: {
      comment: null,
      edit: {
        default: null
      },
      rootId: null,
      reply: {
        default: null
      }
    },
    emits: ["log", "submit", "delete", "edit", "like", "status", "sticky", "reply"],
    setup(e) {
      const t = e,
        n = ["approved", "waiting", "spam"],
        r = zn("config"),
        i = function () {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          const {
              controls: t = !1,
              interval: n = "requestAnimationFrame"
            } = e,
            r = Jt(new Date()),
            i = () => r.value = new Date(),
            s = "requestAnimationFrame" === n ? function (e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              const {
                  immediate: n = !0,
                  window: r = Os
                } = t,
                i = Jt(!1);
              let s = 0,
                o = null;
              function a(t) {
                i.value && r && (e({
                  delta: t - s,
                  timestamp: t
                }), s = t, o = r.requestAnimationFrame(a));
              }
              function l() {
                !i.value && r && (i.value = !0, o = r.requestAnimationFrame(a));
              }
              function c() {
                i.value = !1, null != o && r && (r.cancelAnimationFrame(o), o = null);
              }
              return n && l(), hs(c), {
                isActive: zt(i),
                pause: c,
                resume: l
              };
            }(i, {
              immediate: !0
            }) : function (e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e3,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              const {
                immediate: r = !0,
                immediateCallback: i = !1
              } = n;
              let s = null;
              const o = Jt(!1);
              function a() {
                s && (clearInterval(s), s = null);
              }
              function l() {
                o.value = !1, a();
              }
              function c() {
                const n = cs(t);
                n <= 0 || (o.value = !0, i && e(), a(), s = setInterval(e, n));
              }
              return r && ss && c(), (Xt(t) || os(t)) && hs(Hn(t, () => {
                o.value && ss && c();
              })), hs(l), {
                isActive: o,
                pause: l,
                resume: c
              };
            }(i, n, {
              immediate: !0
            });
          return t ? Qs({
            now: r
          }, s) : r;
        }(),
        s = wa(),
        o = bi(() => r.value.locale),
        a = bi(() => {
          const {
            link: e
          } = t.comment;
          return e ? D(e) ? e : `https://${e}` : "";
        }),
        l = bi(() => ((e, t, n) => {
          if (!e) return "";
          const r = "string" == typeof e ? new Date(-1 !== e.indexOf(" ") ? e.replace(/-/g, "/") : e) : e,
            i = t.getTime() - r.getTime(),
            s = Math.floor(i / 864e5);
          if (0 === s) {
            const e = i % 864e5,
              t = Math.floor(e / 36e5);
            if (0 === t) {
              const t = e % 36e5,
                r = Math.floor(t / 6e4);
              if (0 === r) {
                const e = t % 6e4;
                return `${Math.round(e / 1e3)} ${n.seconds}`;
              }
              return `${r} ${n.minutes}`;
            }
            return `${t} ${n.hours}`;
          }
          return s < 0 ? n.now : s < 8 ? `${s} ${n.days}` : (e => {
            const t = N(e.getDate(), 2),
              n = N(e.getMonth() + 1, 2);
            return `${N(e.getFullYear(), 2)}-${n}-${t}`;
          })(r);
        })(t.comment.insertedAt, i.value, o.value)),
        c = bi(() => "administrator" === s.value.type),
        u = bi(() => t.comment.user_id && s.value.objectId === t.comment.user_id),
        d = bi(() => {
          var _t$reply;
          return t.comment.objectId === ((_t$reply = t.reply) === null || _t$reply === void 0 ? void 0 : _t$reply.objectId);
        }),
        h = bi(() => {
          var _t$edit;
          return t.comment.objectId === ((_t$edit = t.edit) === null || _t$edit === void 0 ? void 0 : _t$edit.objectId);
        });
      return (t, r) => {
        var _e$reply;
        const i = function (e, t) {
          return function (e, t) {
            let n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
            const r = An || hi;
            if (r) {
              const i = r.type;
              if (e === tr) {
                const e = function (e) {
                  let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                  return ce(e) ? e.displayName || e.name : e.name || t && e.__name;
                }(i, !1);
                if (e && (e === t || e === be(t) || e === Te(be(t)))) return i;
              }
              const s = rr(r[e] || i[e], t) || rr(r.appContext[e], t);
              return !s && n ? i : s;
            }
          }(tr, e, !0, t) || e;
        }("CommentCard", !0);
        return Wr(), qr("div", {
          id: e.comment.objectId,
          class: "wl-card-item"
        }, [ti("div", Rl, [e.comment.avatar ? (Wr(), qr("img", {
          key: 0,
          src: e.comment.avatar
        }, null, 8, El)) : si("v-if", !0), e.comment.type ? (Wr(), Zr(rn(oa), {
          key: 1
        })) : si("v-if", !0)]), ti("div", Al, [ti("div", Ll, [rn(a) ? (Wr(), qr("a", {
          key: 0,
          class: "wl-nick",
          href: rn(a),
          target: "_blank",
          rel: "noopener noreferrer"
        }, B(e.comment.nick), 9, Nl)) : (Wr(), qr("span", Il, B(e.comment.nick), 1)), "administrator" === e.comment.type ? (Wr(), qr("span", {
          key: 2,
          class: "wl-badge",
          textContent: B(rn(o).admin)
        }, null, 8, $l)) : si("v-if", !0), e.comment.label ? (Wr(), qr("span", {
          key: 3,
          class: "wl-badge",
          textContent: B(e.comment.label)
        }, null, 8, Pl)) : si("v-if", !0), e.comment.sticky ? (Wr(), qr("span", {
          key: 4,
          class: "wl-badge",
          textContent: B(rn(o).sticky)
        }, null, 8, Ul)) : si("v-if", !0), void 0 !== e.comment.level && e.comment.level >= 0 ? (Wr(), qr("span", {
          key: 5,
          class: j(`wl-badge level${e.comment.level}`),
          textContent: B(rn(o)[`level${e.comment.level}`] || `Level ${e.comment.level}`)
        }, null, 10, Yl)) : si("v-if", !0), ti("span", {
          class: "wl-time",
          textContent: B(rn(l))
        }, null, 8, zl), ti("div", jl, [rn(c) || rn(u) ? (Wr(), qr("button", {
          key: 0,
          type: "button",
          class: "wl-edit",
          onClick: r[0] || (r[0] = () => t.$emit("edit", e.comment))
        }, [ni(rn(sa))])) : si("v-if", !0), rn(c) || rn(u) ? (Wr(), qr("button", {
          key: 1,
          type: "button",
          class: "wl-delete",
          onClick: r[1] || (r[1] = n => t.$emit("delete", e.comment))
        }, [ni(rn(Jo))])) : si("v-if", !0), ti("button", {
          type: "button",
          class: j(["wl-reply", {
            active: rn(d)
          }]),
          title: rn(d) ? rn(o).cancelReply : rn(o).reply,
          onClick: r[2] || (r[2] = n => t.$emit("reply", rn(d) ? null : e.comment))
        }, [ni(rn(ia))], 10, Fl)])]), ti("div", Hl, [e.comment.addr ? (Wr(), qr("span", {
          key: 0,
          class: "wl-addr",
          "data-value": e.comment.addr,
          textContent: B(e.comment.addr)
        }, null, 8, Wl)) : si("v-if", !0), e.comment.browser ? (Wr(), qr("span", {
          key: 1,
          class: "wl-browser",
          "data-value": e.comment.browser,
          textContent: B(e.comment.browser)
        }, null, 8, Vl)) : si("v-if", !0), e.comment.os ? (Wr(), qr("span", {
          key: 2,
          class: "wl-os",
          "data-value": e.comment.os,
          textContent: B(e.comment.os)
        }, null, 8, Bl)) : si("v-if", !0)]), rn(h) ? si("v-if", !0) : (Wr(), qr("div", {
          key: 0,
          class: "wl-content",
          innerHTML: e.comment.comment
        }, null, 8, Gl)), rn(c) && !rn(h) ? (Wr(), qr("div", ql, [ti("span", Zl, [(Wr(), qr(Ur, null, ir(n, n => ti("button", {
          key: n,
          type: "submit",
          class: j(`wl-btn wl-${n}`),
          disabled: e.comment.status === n,
          onClick: r => t.$emit("status", {
            status: n,
            comment: e.comment
          }),
          textContent: B(rn(o)[n])
        }, null, 10, Ql)), 64))]), rn(c) && !e.comment.rid ? (Wr(), qr("button", {
          key: 0,
          type: "submit",
          class: "wl-btn wl-sticky",
          onClick: r[3] || (r[3] = n => t.$emit("sticky", e.comment))
        }, B(e.comment.sticky ? rn(o).unsticky : rn(o).sticky), 1)) : si("v-if", !0)])) : si("v-if", !0), rn(d) || rn(h) ? (Wr(), qr("div", {
          key: 2,
          class: j({
            "wl-reply-wrapper": rn(d),
            "wl-edit-wrapper": rn(h)
          })
        }, [ni(Ol, {
          edit: e.edit,
          "reply-id": (_e$reply = e.reply) === null || _e$reply === void 0 ? void 0 : _e$reply.objectId,
          "reply-user": e.comment.nick,
          "root-id": e.rootId,
          onLog: r[4] || (r[4] = e => t.$emit("log")),
          onCancelReply: r[5] || (r[5] = e => t.$emit("reply", null)),
          onCancelEdit: r[6] || (r[6] = e => t.$emit("edit", null)),
          onSubmit: r[7] || (r[7] = e => t.$emit("submit", e))
        }, null, 8, ["edit", "reply-id", "reply-user", "root-id"])], 2)) : si("v-if", !0), e.comment.children ? (Wr(), qr("div", Kl, [(Wr(!0), qr(Ur, null, ir(e.comment.children, n => (Wr(), Zr(i, {
          key: n.objectId,
          comment: n,
          reply: e.reply,
          edit: e.edit,
          "root-id": e.rootId,
          onLog: r[8] || (r[8] = e => t.$emit("log")),
          onDelete: r[9] || (r[9] = e => t.$emit("delete", e)),
          onEdit: r[10] || (r[10] = e => t.$emit("edit", e)),
          onLike: r[11] || (r[11] = e => t.$emit("like", e)),
          onReply: r[12] || (r[12] = e => t.$emit("reply", e)),
          onStatus: r[13] || (r[13] = e => t.$emit("status", e)),
          onSticky: r[14] || (r[14] = e => t.$emit("sticky", e)),
          onSubmit: r[15] || (r[15] = e => t.$emit("submit", e))
        }, null, 8, ["comment", "reply", "edit", "root-id"]))), 128))])) : si("v-if", !0)])], 8, Dl);
      };
    }
  }), [["__file", "CommentCard.vue"]]);
  const Jl = "1.0.14";
  e.version = Jl;
  const ec = {
      "data-waline": ""
    },
    tc = {
      class: "wl-meta-head"
    },
    nc = {
      class: "wl-count"
    },
    rc = ["textContent"],
    ic = {
      class: "wl-sort"
    },
    sc = ["onClick"],
    oc = {
      class: "wl-cards"
    },
    ac = {
      key: 1,
      class: "wl-operation"
    },
    lc = ["textContent"],
    cc = {
      key: 0,
      class: "wl-loading"
    },
    uc = ["textContent"],
    dc = {
      key: 2,
      class: "wl-operation"
    },
    hc = ["textContent"],
    fc = {
      key: 3,
      class: "wl-power"
    },
    pc = ti("a", {
      href: "https://github.com/walinejs/waline",
      target: "_blank",
      rel: "noopener noreferrer"
    }, " Waline ", -1);
  var mc = Bn({
      __name: "WalineComment",
      props: ["serverURL", "path", "meta", "requiredMeta", "dark", "commentSorting", "lang", "locale", "pageSize", "wordLimit", "emoji", "login", "highlighter", "texRenderer", "imageUploader", "search", "copyright", "recaptchaV3Key", "reaction"],
      setup(e) {
        const t = e,
          c = {
            latest: "insertedAt_desc",
            oldest: "insertedAt_asc"
          },
          u = Object.keys(c),
          d = wa(),
          f = ca || (ca = Fs("WALINE_LIKE", [])),
          p = Jt("loading"),
          m = Jt(0),
          g = Jt(1),
          v = Jt(0),
          y = bi(() => (e => {
            let {
              serverURL: t,
              path: c = location.pathname,
              lang: u = "undefined" == typeof navigator ? "en-US" : navigator.language,
              locale: d,
              emoji: f = r,
              meta: p = ["nick", "mail", "link"],
              requiredMeta: m = [],
              dark: g = !1,
              pageSize: v = 10,
              wordLimit: y,
              imageUploader: _,
              highlighter: w,
              texRenderer: b,
              copyright: x = !0,
              login: S = "enable",
              search: T,
              reaction: C,
              recaptchaV3Key: O = "",
              commentSorting: D = "latest",
              ...L
            } = e;
            return {
              serverURL: R(t),
              path: M(c),
              locale: {
                ...(k[u] || k[i]),
                ...("object" == typeof d ? d : {})
              },
              wordLimit: E(y),
              meta: n(p),
              requiredMeta: n(m),
              imageUploader: A(_, s),
              highlighter: A(w, h),
              texRenderer: A(b, o),
              lang: Object.keys(k).includes(u) ? u : "en-US",
              dark: g,
              emoji: "boolean" == typeof f ? f ? r : [] : f,
              pageSize: v,
              login: S,
              copyright: x,
              search: !1 !== T && ("object" == typeof T ? T : a(u)),
              recaptchaV3Key: O,
              reaction: Array.isArray(C) ? C : !0 === C ? l : [],
              commentSorting: D,
              ...L
            };
          })(t)),
          _ = Jt(y.value.commentSorting),
          w = Jt([]),
          b = Jt(null),
          S = Jt(null),
          T = bi(() => {
            return "string" == typeof (e = y.value.dark) ? "auto" === e ? `@media(prefers-color-scheme:dark){body${L}}` : `${e}${L}` : !0 === e ? `:root${L}` : "";
            var e;
          }),
          O = bi(() => y.value.locale);
        let D;
        !function (e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          const n = Jt(!1),
            {
              document: r = Ds,
              immediate: i = !0,
              manual: s = !1,
              id: o = "vueuse_styletag_" + ++Ks
            } = t,
            a = Jt(e);
          let l = () => {};
          const c = () => {
              if (!r) return;
              const e = r.getElementById(o) || r.createElement("style");
              e.isConnected || (e.type = "text/css", e.id = o, t.media && (e.media = t.media), r.head.appendChild(e)), n.value || (l = Hn(a, t => {
                e.textContent = t;
              }, {
                immediate: !0
              }), n.value = !0);
            },
            u = () => {
              r && n.value && (l(), r.head.removeChild(r.getElementById(o)), n.value = !1);
            };
          i && !s && function (e) {
            let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            fi() ? Qn(e) : t ? e() : kn(e);
          }(c), s || hs(u), zt(n);
        }(T);
        const N = e => {
            var _D, _d$value;
            const {
                serverURL: t,
                path: n,
                pageSize: r
              } = y.value,
              i = new AbortController();
            p.value = "loading", (_D = D) !== null && _D !== void 0 && _D(), (e => {
              let {
                serverURL: t,
                lang: n,
                path: r,
                page: i,
                pageSize: s,
                sortBy: o,
                signal: a,
                token: l
              } = e;
              const c = {};
              return l && (c.Authorization = `Bearer ${l}`), fetch(`${t}/comment?path=${encodeURIComponent(r)}&pageSize=${s}&page=${i}&lang=${n}&sortBy=${o}`, {
                signal: a,
                headers: c
              }).then(e => e.json()).then(e => x(e, "Get comment data"));
            })({
              serverURL: t,
              lang: y.value.lang,
              path: n,
              pageSize: r,
              sortBy: c[_.value],
              page: e,
              signal: i.signal,
              token: (_d$value = d.value) === null || _d$value === void 0 ? void 0 : _d$value.token
            }).then(t => {
              p.value = "success", m.value = t.count, w.value.push(...t.data), g.value = e, v.value = t.totalPages;
            }).catch(e => {
              "AbortError" !== e.name && (console.error(e.message), p.value = "error");
            }), D = i.abort.bind(i);
          },
          I = () => N(g.value + 1),
          $ = () => {
            m.value = 0, w.value = [], N(1);
          },
          P = e => {
            b.value = e;
          },
          U = e => {
            S.value = e;
          },
          Y = e => {
            if (S.value) S.value.comment = e.comment, S.value.orig = e.orig;else if (e.rid) {
              const t = w.value.find(t => {
                let {
                  objectId: n
                } = t;
                return n === e.rid;
              });
              if (!t) return;
              Array.isArray(t.children) || (t.children = []), t.children.push(e);
            } else w.value.unshift(e);
            m.value += 1;
          },
          z = async e => {
            var _d$value2;
            let {
              comment: t,
              status: n
            } = e;
            if (t.status === n) return;
            const {
              serverURL: r,
              lang: i
            } = y.value;
            await C({
              serverURL: r,
              lang: i,
              token: (_d$value2 = d.value) === null || _d$value2 === void 0 ? void 0 : _d$value2.token,
              objectId: t.objectId,
              comment: {
                status: n
              }
            }), t.status = n;
          },
          F = async e => {
            var _d$value3;
            if (e.rid) return;
            const {
              serverURL: t,
              lang: n
            } = y.value;
            await C({
              serverURL: t,
              lang: n,
              token: (_d$value3 = d.value) === null || _d$value3 === void 0 ? void 0 : _d$value3.token,
              objectId: e.objectId,
              comment: {
                sticky: e.sticky ? 0 : 1
              }
            }), e.sticky = !e.sticky;
          },
          H = async e => {
            var _d$value4;
            let {
              objectId: t
            } = e;
            if (!confirm("Are you sure you want to delete this comment?")) return;
            const {
              serverURL: n,
              lang: r
            } = y.value;
            await (e => {
              let {
                serverURL: t,
                lang: n,
                token: r,
                objectId: i
              } = e;
              return fetch(`${t}/comment/${i}?lang=${n}`, {
                method: "DELETE",
                headers: {
                  Authorization: `Bearer ${r}`
                }
              }).then(e => e.json()).then(e => x(e, "Delete comment"));
            })({
              serverURL: n,
              lang: r,
              token: (_d$value4 = d.value) === null || _d$value4 === void 0 ? void 0 : _d$value4.token,
              objectId: t
            }), w.value.some((e, n) => e.objectId === t ? (w.value = w.value.filter((e, t) => t !== n), !0) : e.children.some((r, i) => r.objectId === t && (w.value[n].children = e.children.filter((e, t) => t !== i), !0)));
          },
          W = async e => {
            var _d$value5;
            const {
                serverURL: t,
                lang: n
              } = y.value,
              {
                objectId: r
              } = e,
              i = f.value.includes(r);
            await C({
              serverURL: t,
              lang: n,
              objectId: r,
              token: (_d$value5 = d.value) === null || _d$value5 === void 0 ? void 0 : _d$value5.token,
              comment: {
                like: !i
              }
            }), i ? f.value = f.value.filter(e => e !== r) : (f.value = [...f.value, r], f.value.length > 50 && (f.value = f.value.slice(-50))), e.like = (e.like || 0) + (i ? -1 : 1);
          };
        return function (e, t) {
          if (hi) {
            let e = hi.provides;
            const n = hi.parent && hi.parent.provides;
            n === e && (e = hi.provides = Object.create(n)), e.config = t;
          }
        }(0, y), Qn(() => {
          Hn(() => [t.serverURL, t.path], () => $(), {
            immediate: !0
          });
        }), Xn(() => {
          var _D2;
          return (_D2 = D) === null || _D2 === void 0 ? void 0 : _D2();
        }), (e, t) => (Wr(), qr("div", ec, [ni(Ea), b.value ? si("v-if", !0) : (Wr(), Zr(Ol, {
          key: 0,
          onLog: $,
          onSubmit: Y
        })), ti("div", tc, [ti("div", nc, [m.value ? (Wr(), qr("span", {
          key: 0,
          class: "wl-num",
          textContent: B(m.value)
        }, null, 8, rc)) : si("v-if", !0), ii(" " + B(rn(O).comment), 1)]), ti("ul", ic, [(Wr(!0), qr(Ur, null, ir(rn(u), e => (Wr(), qr("li", {
          key: e,
          class: j([e === _.value ? "active" : ""]),
          onClick: t => (e => {
            _.value !== e && (_.value = e, $());
          })(e)
        }, B(rn(O)[e]), 11, sc))), 128))])]), ti("div", oc, [(Wr(!0), qr(Ur, null, ir(w.value, e => (Wr(), Zr(Xl, {
          key: e.objectId,
          "root-id": e.objectId,
          comment: e,
          reply: b.value,
          edit: S.value,
          onLog: $,
          onReply: P,
          onEdit: U,
          onSubmit: Y,
          onStatus: z,
          onDelete: H,
          onSticky: F,
          onLike: W
        }, null, 8, ["root-id", "comment", "reply", "edit"]))), 128))]), "error" === p.value ? (Wr(), qr("div", ac, [ti("button", {
          type: "button",
          class: "wl-btn",
          onClick: $,
          textContent: B(rn(O).refresh)
        }, null, 8, lc)])) : (Wr(), qr(Ur, {
          key: 2
        }, ["loading" === p.value ? (Wr(), qr("div", cc, [ni(rn(aa), {
          size: 30
        })])) : w.value.length ? g.value < v.value ? (Wr(), qr("div", dc, [ti("button", {
          type: "button",
          class: "wl-btn",
          onClick: I,
          textContent: B(rn(O).more)
        }, null, 8, hc)])) : si("v-if", !0) : (Wr(), qr("div", {
          key: 1,
          class: "wl-empty",
          textContent: B(rn(O).sofa)
        }, null, 8, uc))], 64)), rn(y).copyright ? (Wr(), qr("div", fc, [ii(" Powered by "), pc, ii(" v" + B(rn(Jl)), 1)])) : si("v-if", !0)]));
      }
    }),
    gc = Ra(mc, [["__file", "WalineComment.vue"]]),
    vc = ["中国标准时间", "China Standard Time", "توقيت الصين الرسمي", "चीन मानक समय", "hora estándar de China", "heure normale de la Chine", "চীন মানক সময়", "Китай, стандартное время", "Horário Padrão da China", "چین سٹینڈرڈ ٹائم", "中国標準時", "Chiny (czas standardowy)"];
  const yc = (e, t) => {
      t.forEach((t, n) => {
        t.innerText = e[n].toString();
      });
    },
    _c = e => {
      let {
        serverURL: t,
        path: n = window.location.pathname,
        selector: r = ".waline-pageview-count",
        update: i = !0,
        lang: s = navigator.language
      } = e;
      const o = new AbortController(),
        a = Array.from(document.querySelectorAll(r)),
        l = e => {
          const t = Qo(e);
          return null !== t && n !== t;
        },
        c = e => (e => {
          let {
            serverURL: t,
            lang: n,
            paths: r,
            signal: i
          } = e;
          return S({
            serverURL: t,
            lang: n,
            paths: r,
            type: ["time"],
            signal: i
          }).then(e => Array.isArray(e) ? e : [e]);
        })({
          serverURL: R(t),
          paths: e.map(e => Qo(e) || n),
          lang: s,
          signal: o.signal
        }).then(t => yc(t, e)).catch(io);
      if (i) {
        const e = a.filter(e => !l(e)),
          r = a.filter(l),
          i = new Date().toString().includes("GMT+0800") && vc.some(e => new Date().toString().includes(e)),
          o = Ua().utcOffset(8).startOf("day").valueOf();
        (u = {
          serverURL: R(t),
          path: n,
          lang: s,
          isChinaZone: i,
          curPreviewTime: o
        }, T({
          ...u,
          type: "time",
          action: "inc"
        })).then(t => yc(new Array(e.length).fill(t), e)), r.length && c(r);
      } else c(a);
      var u;
      return o.abort.bind(o);
    };
  e.pageviewCount = _c, e.init = e => {
    let {
      el: t = "#waline",
      path: n = window.location.pathname,
      comment: r = !1,
      pageview: i = !1,
      ...s
    } = e;
    const o = t ? so(t) : null;
    if (t && !o) throw new Error("Option 'el' do not match any domElement!");
    if (!s.serverURL) throw new Error("Option 'serverURL' is missing!");
    const a = Yt({
        ...s
      }),
      l = Yt({
        comment: r,
        pageview: i,
        path: n
      }),
      c = o ? function () {
        const e = (rs || (rs = Nr(ns))).createApp(...arguments),
          {
            mount: t
          } = e;
        return e.mount = n => {
          const r = function (e) {
            return ue(e) ? document.querySelector(e) : e;
          }(n);
          if (!r) return;
          const i = e._component;
          ce(i) || i.render || i.template || (i.template = r.innerHTML), r.innerHTML = "";
          const s = t(r, !1, r instanceof SVGElement);
          return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), s;
        }, e;
      }(() => xi(gc, {
        path: l.path,
        ...a
      })) : null;
    c && c.mount(o);
    const u = jn(() => {
        l.comment && Ko({
          serverURL: a.serverURL,
          path: l.path,
          selector: "string" == typeof l.comment ? l.comment : void 0
        });
      }),
      d = jn(() => {
        l.pageview && _c({
          serverURL: a.serverURL,
          path: l.path,
          selector: "string" == typeof l.pageview ? l.pageview : void 0
        });
      });
    return {
      el: o,
      update: function () {
        let {
          comment: e,
          pageview: t,
          path: n = window.location.pathname,
          ...r
        } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        Object.entries(r).forEach(e => {
          let [t, n] = e;
          a[t] = n;
        }), l.path = n, void 0 !== e && (l.comment = e), void 0 !== t && (l.pageview = t);
      },
      destroy: () => {
        c !== null && c !== void 0 && c.unmount(), u(), d();
      }
    };
  }, e.RecentComments = e => {
    var _s$value2;
    let {
      el: t,
      serverURL: n,
      count: r,
      lang: i = navigator.language
    } = e;
    const s = wa(),
      o = so(t),
      a = new AbortController();
    return (e => {
      let {
        serverURL: t,
        lang: n,
        count: r,
        signal: i,
        token: s
      } = e;
      const o = {};
      return s && (o.Authorization = `Bearer ${s}`), fetch(`${t}/comment?type=recent&count=${r}&lang=${n}`, {
        signal: i,
        headers: o
      }).then(e => e.json());
    })({
      serverURL: n,
      count: r,
      lang: i,
      signal: a.signal,
      token: (_s$value2 = s.value) === null || _s$value2 === void 0 ? void 0 : _s$value2.token
    }).then(e => o && e.length ? (o.innerHTML = `<ul class="wl-recent-list">${e.map(e => `<li class="wl-recent-item"><a href="${e.url}">${e.nick}</a>：${e.comment}</li>`).join("")}</ul>`, {
      comments: e,
      destroy: () => {
        a.abort(), o.innerHTML = "";
      }
    }) : {
      comments: e,
      destroy: () => a.abort()
    });
  }, e.UserList = e => {
    let {
      el: t,
      serverURL: n,
      count: r,
      locale: s,
      lang: o = navigator.language,
      mode: a = "list"
    } = e;
    const l = so(t),
      c = new AbortController();
    return (e => {
      let {
        serverURL: t,
        signal: n,
        pageSize: r,
        lang: i
      } = e;
      return fetch(`${t}/user?pageSize=${r}&lang=${i}`, {
        signal: n
      }).then(e => e.json()).then(e => x(e, "user list")).then(e => e.data);
    })({
      serverURL: n,
      pageSize: r,
      lang: o,
      signal: c.signal
    }).then(e => l && e.length ? (s = {
      ...(k[o] || k[i]),
      ...("object" == typeof s ? s : {})
    }, l.innerHTML = `<ul class="wl-user-${a}">${e.map((e, t) => [`<li class="wl-user-item" aria-label="${e.nick}">`, e.link && `<a href="${e.link}" target="_blank">`, '<div class="wl-user-avatar">', `<img src="${e.avatar}" alt="${e.nick}">`, `<span class="wl-user-badge">${t + 1}</span>`, "</div>", '<div class="wl-user-meta">', '<div class="wl-user-name">', e.nick, e.level && `<span class="wl-badge">${s ? s[`level${e.level}`] : `Level ${e.level}`}</span>`, e.label && `<span class="wl-badge">${e.label}</span>`, "</div>", e.link && e.link, "</div>", e.link && "</a>", "</li>"].filter(e => e).join("")).join("")}</ul>`, {
      users: e,
      destroy: () => {
        c.abort(), l.innerHTML = "";
      }
    }) : {
      users: e,
      destroy: () => c.abort()
    });
  };
});